import { graphql, type GraphQLResponseResolver, type RequestHandlerOptions } from 'msw'
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  PhoneNumber: { input: string; output: string; }
  PiiPhoneNumber: { input: string; output: string; }
  PiiString: { input: string; output: string; }
};

export type AddExpertSessionInput = {
  customerSessionId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type AddExpertSessionPayload = AddExpertSessionSuccessPayload | BaseError | NotFoundError;

export type AddExpertSessionSuccessPayload = {
  __typename?: 'AddExpertSessionSuccessPayload';
  expertSession: ExpertSession;
};

export type Address = {
  __typename?: 'Address';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressLine3?: Maybe<Scalars['String']['output']>;
  addressType?: Maybe<AddressType>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  municipality?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  addressLine1?: InputMaybe<Scalars['PiiString']['input']>;
  addressLine2?: InputMaybe<Scalars['PiiString']['input']>;
  addressLine3?: InputMaybe<Scalars['PiiString']['input']>;
  addressType?: InputMaybe<AddressType>;
  city?: InputMaybe<Scalars['PiiString']['input']>;
  country?: InputMaybe<Scalars['PiiString']['input']>;
  municipality?: InputMaybe<Scalars['PiiString']['input']>;
  postalCode?: InputMaybe<Scalars['PiiString']['input']>;
  state?: InputMaybe<Scalars['PiiString']['input']>;
};

export enum AddressType {
  Billing = 'BILLING',
  Service = 'SERVICE'
}

export type Asset = {
  __typename?: 'Asset';
  assetCatalogId?: Maybe<Scalars['String']['output']>;
  externalProductId?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  imei?: Maybe<Scalars['String']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  saleDate?: Maybe<Scalars['Date']['output']>;
  sapCode?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

export type AssetInput = {
  assetCatalogId?: InputMaybe<Scalars['String']['input']>;
  externalProductId?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  imei?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  saleDate?: InputMaybe<Scalars['Date']['input']>;
  sapCode?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

export type AsurionCall = {
  __typename?: 'AsurionCall';
  direction?: Maybe<CallDirection>;
  flexReservation?: Maybe<FlexReservation>;
  id: Scalars['ID']['output'];
};

export type BaseError = Error & {
  __typename?: 'BaseError';
  message: Scalars['String']['output'];
};

export type Billing = {
  __typename?: 'Billing';
  address: Address;
  closingDay?: Maybe<Scalars['String']['output']>;
  dueDay?: Maybe<Scalars['String']['output']>;
  externalBillingCycleId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type BillingDiscount = {
  __typename?: 'BillingDiscount';
  discountActionType?: Maybe<DiscountActionType>;
  discountCodeId?: Maybe<Scalars['String']['output']>;
  discountDescription?: Maybe<Scalars['String']['output']>;
  discountId?: Maybe<Scalars['String']['output']>;
  discountName?: Maybe<Scalars['String']['output']>;
  discountType?: Maybe<DiscountType>;
  discountValue?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  programId?: Maybe<Scalars['String']['output']>;
  redemptionLimit?: Maybe<Scalars['Int']['output']>;
  redemptionType?: Maybe<RedemptionType>;
  status?: Maybe<DiscountStatus>;
  validityEnd?: Maybe<Scalars['DateTime']['output']>;
  validityStart?: Maybe<Scalars['DateTime']['output']>;
};

export type BusinessUnit = Node & {
  __typename?: 'BusinessUnit';
  businessUnit: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type BusinessUnitsConnection = Connection & {
  __typename?: 'BusinessUnitsConnection';
  edges: Array<BusinessUnitsEdge>;
  pageInfo: PageInfo;
};

export type BusinessUnitsEdge = Edge & {
  __typename?: 'BusinessUnitsEdge';
  cursor: Scalars['String']['output'];
  node: BusinessUnit;
};

export enum CallDirection {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

/**
 * CheckoutMethod is used to dictated where consent will be sent. If CheckoutMethod is not provided with request, it will default to online.
 * If SMS method is provided, a valid phone number must exist on the customer session.
 * If Email method is provided, a valid email address must exist on the customer session.
 */
export enum CheckoutMethod {
  Email = 'email',
  Online = 'online',
  Sms = 'sms'
}

export type Communication = {
  __typename?: 'Communication';
  customerSessionId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mdn?: Maybe<Scalars['PhoneNumber']['output']>;
  productSku?: Maybe<Scalars['String']['output']>;
  status: MessageStatus;
  templateId: Scalars['String']['output'];
  templateVariables?: Maybe<Scalars['JSONObject']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  type: MessageType;
};

export type Connection = {
  edges: Array<Edge>;
  pageInfo: PageInfo;
};

export type CpfVerification = {
  __typename?: 'CpfVerification';
  cpf: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: CpfVerificationStatus;
};

export enum CpfVerificationStatus {
  Failed = 'FAILED',
  NotVerified = 'NOT_VERIFIED',
  Pending = 'PENDING',
  Verified = 'VERIFIED'
}

export type CreateAsurionCallInput = {
  direction?: InputMaybe<CallDirection>;
  flexReservation?: InputMaybe<FlexReservationInput>;
  id: Scalars['ID']['input'];
};

export type CreateBillingDiscountInput = {
  discountActionType?: InputMaybe<DiscountActionType>;
  discountCodeId?: InputMaybe<Scalars['String']['input']>;
  discountDescription?: InputMaybe<Scalars['String']['input']>;
  discountId: Scalars['ID']['input'];
  discountName?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<DiscountType>;
  discountValue?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  programId?: InputMaybe<Scalars['String']['input']>;
  redemptionLimit?: InputMaybe<Scalars['Int']['input']>;
  redemptionType?: InputMaybe<RedemptionType>;
  status?: InputMaybe<DiscountStatus>;
  validityEnd?: InputMaybe<Scalars['String']['input']>;
  validityStart?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBillingDiscountsInput = {
  billingDiscounts: Array<CreateBillingDiscountInput>;
  productOfferId: Scalars['ID']['input'];
};

export type CreateBillingDiscountsPayload = BaseError | CreateBillingDiscountsSuccessPayload | NotFoundError;

export type CreateBillingDiscountsSuccessPayload = {
  __typename?: 'CreateBillingDiscountsSuccessPayload';
  billingDiscounts?: Maybe<Array<Maybe<BillingDiscount>>>;
};

export type CreateBillingInput = {
  address: AddressInput;
  customerSessionId: Scalars['ID']['input'];
};

export type CreateBillingPayload = BaseError | CreateBillingSuccessPayload | DuplicateError | NotFoundError;

export type CreateBillingSuccessPayload = {
  __typename?: 'CreateBillingSuccessPayload';
  billing: Billing;
};

export type CreateCommunicationInput = {
  customerSessionId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['PiiString']['input']>;
  mdn?: InputMaybe<Scalars['PiiPhoneNumber']['input']>;
  productSku?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MessageStatus>;
  templateId: Scalars['String']['input'];
  templateVariables?: InputMaybe<Scalars['JSONObject']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
  type: MessageType;
};

export type CreateCommunicationPayload = BaseError | CreateCommunicationSuccessPayload | NotFoundError;

export type CreateCommunicationSuccessPayload = {
  __typename?: 'CreateCommunicationSuccessPayload';
  communication?: Maybe<Communication>;
};

export type CreateCpfVerificationInput = {
  cpf: Scalars['PiiString']['input'];
  customerSessionId: Scalars['ID']['input'];
};

export type CreateCpfVerificationPayload = BaseError | CreateCpfVerificationSuccessPayload | DuplicateError | NotFoundError;

export type CreateCpfVerificationSuccessPayload = {
  __typename?: 'CreateCpfVerificationSuccessPayload';
  cpfVerification: CpfVerification;
};

export type CreateCustomerInput = {
  accountNumber?: InputMaybe<Scalars['PiiString']['input']>;
  address?: InputMaybe<AddressInput>;
  asset?: InputMaybe<AssetInput>;
  asurionId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['PiiString']['input']>;
  firstName?: InputMaybe<Scalars['PiiString']['input']>;
  lastName?: InputMaybe<Scalars['PiiString']['input']>;
  mdn?: InputMaybe<Scalars['PiiPhoneNumber']['input']>;
  mobileBan?: InputMaybe<Scalars['PiiString']['input']>;
  socialName?: InputMaybe<Scalars['PiiString']['input']>;
};

export type CreateCustomerSessionInput = {
  asurionCall?: InputMaybe<CreateAsurionCallInput>;
  channel?: InputMaybe<Scalars['String']['input']>;
  cohortTag?: InputMaybe<Scalars['String']['input']>;
  customer?: InputMaybe<CreateCustomerInput>;
  /** @deprecated Use AsurionCallInput.direction */
  direction?: InputMaybe<CallDirection>;
  expertSessionId?: InputMaybe<Scalars['ID']['input']>;
  extensions?: InputMaybe<Array<ExtensionInput>>;
  externalClientAccount?: InputMaybe<CreateExternalClientAccountInput>;
  externalSession?: InputMaybe<CreateExternalSessionInput>;
  horizonSession?: InputMaybe<CreateHorizonSessionInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  marketing?: InputMaybe<MarketingInput>;
  mdnVerification?: InputMaybe<CreateCustomerSessionMdnVerificationInput>;
  origin?: InputMaybe<Scalars['String']['input']>;
  partner: Scalars['String']['input'];
  sessionStatus?: InputMaybe<SessionStatus>;
};

export type CreateCustomerSessionMdnVerificationInput = {
  expiration: Scalars['DateTime']['input'];
  transactionId: Scalars['String']['input'];
};

export type CreateCustomerSessionPayload = BaseError | CreateCustomerSessionSuccessPayload | DuplicateError;

export type CreateCustomerSessionSuccessPayload = {
  __typename?: 'CreateCustomerSessionSuccessPayload';
  customerSession: CustomerSession;
  mdnVerification?: Maybe<MdnVerification>;
};

export type CreateExpertInput = {
  email: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CreateExpertSessionInput = {
  expert: CreateExpertInput;
  hostApp?: InputMaybe<Scalars['String']['input']>;
  supportedSkus?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateExpertSessionPayload = BaseError | CreateExpertSessionSuccessPayload;

export type CreateExpertSessionSuccessPayload = {
  __typename?: 'CreateExpertSessionSuccessPayload';
  expertSession: ExpertSession;
};

export type CreateExternalClientAccountInput = {
  id: Scalars['ID']['input'];
};

export type CreateExternalSessionInput = {
  id: Scalars['ID']['input'];
};

export type CreateHorizonSessionInput = {
  id: Scalars['ID']['input'];
};

export type CreateMdnVerificationInput = {
  customerSessionId: Scalars['ID']['input'];
};

export type CreateMdnVerificationPayload = BaseError | CreateMdnVerificationSuccessPayload | NotFoundError;

export type CreateMdnVerificationSuccessPayload = {
  __typename?: 'CreateMdnVerificationSuccessPayload';
  mdnVerification: MdnVerification;
};

export type CreatePaySessionInput = {
  billingFrequencyInMonths?: InputMaybe<Scalars['String']['input']>;
  billingToken?: InputMaybe<Scalars['String']['input']>;
  customerSessionId: Scalars['ID']['input'];
  paymentType?: InputMaybe<PaymentType>;
  productPaidFrequency?: InputMaybe<Scalars['String']['input']>;
  productSku: Scalars['String']['input'];
  transactionType?: InputMaybe<TransactionType>;
};

export type CreatePaySessionPayload = BaseError | CreatePaySessionSuccessPayload | NotFoundError;

export type CreatePaySessionSuccessPayload = {
  __typename?: 'CreatePaySessionSuccessPayload';
  paySession: PaySession;
};

export type CreateProductDeclinationInput = {
  productOfferId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProductDeclinationPayload = BaseError | CreateProductDeclinationSuccessPayload | NotFoundError;

export type CreateProductDeclinationSuccessPayload = {
  __typename?: 'CreateProductDeclinationSuccessPayload';
  productDeclination: ProductDeclination;
};

export type CreateProductEnrollmentInput = {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  confirmationCode?: InputMaybe<Scalars['String']['input']>;
  consentId?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<ProductEnrollmentErrorInput>;
  externalReferenceId?: InputMaybe<Scalars['String']['input']>;
  paySessionId?: InputMaybe<Scalars['ID']['input']>;
  planId?: InputMaybe<Scalars['String']['input']>;
  productOfferId: Scalars['ID']['input'];
  status?: InputMaybe<ProductEnrollmentStatus>;
};

export type CreateProductEnrollmentPayload = BaseError | CreateProductEnrollmentSuccessPayload | NotFoundError;

export type CreateProductEnrollmentSuccessPayload = {
  __typename?: 'CreateProductEnrollmentSuccessPayload';
  productEnrollment: ProductEnrollment;
};

export type CreateProductOfferEligibilityInput = {
  extensions?: InputMaybe<Array<ExtensionInput>>;
  /**
   * A reference to a 3rd party ID utilized during their eligibility look up process,
   * this is currently used for AT&T Home Tech Protect.
   */
  externalEligibilityId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProductEligibilityStatus>;
  subscriptionNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProductOfferInput = {
  /** @deprecated Use Customer.mdn */
  customerMdn?: InputMaybe<Scalars['PiiPhoneNumber']['input']>;
  customerSessionId: Scalars['ID']['input'];
  expertSessionId?: InputMaybe<Scalars['ID']['input']>;
  partner: Scalars['String']['input'];
  /** Defines the eligibility status of the product offer that is going to be created. */
  productEligibility?: InputMaybe<CreateProductOfferEligibilityInput>;
  productSku: Scalars['String']['input'];
};

export type CreateProductOfferPayload = BaseError | CreateProductOfferSuccessPayload;

export type CreateProductOfferSuccessPayload = {
  __typename?: 'CreateProductOfferSuccessPayload';
  productOffer: ProductOffer;
};

export type Customer = {
  __typename?: 'Customer';
  accountNumber?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Address>;
  asset?: Maybe<Asset>;
  asurionId?: Maybe<Scalars['ID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  mdn?: Maybe<Scalars['PhoneNumber']['output']>;
  mobileBan?: Maybe<Scalars['String']['output']>;
  socialName?: Maybe<Scalars['String']['output']>;
  temporaryMdn?: Maybe<Scalars['PhoneNumber']['output']>;
};

export type CustomerSession = {
  __typename?: 'CustomerSession';
  asurionCall?: Maybe<AsurionCall>;
  billing?: Maybe<Billing>;
  channel?: Maybe<Scalars['String']['output']>;
  cohortTag?: Maybe<Scalars['String']['output']>;
  communications: Array<Communication>;
  cpfVerification?: Maybe<CpfVerification>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  /** @deprecated Use AsurionCall.direction */
  direction?: Maybe<CallDirection>;
  expertSessions: Array<ExpertSession>;
  extensions: Array<Extension>;
  externalClientAccount?: Maybe<ExternalClientAccount>;
  externalSession?: Maybe<ExternalSession>;
  horizonSession?: Maybe<HorizonSession>;
  id: Scalars['ID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  marketing?: Maybe<Marketing>;
  mdnVerification?: Maybe<MdnVerification>;
  origin?: Maybe<Scalars['String']['output']>;
  outboundCalls: Array<AsurionCall>;
  partner: Scalars['String']['output'];
  paySession?: Maybe<PaySession>;
  status: SessionStatus;
};


export type CustomerSessionMdnVerificationArgs = {
  id: Scalars['ID']['input'];
};


export type CustomerSessionPaySessionArgs = {
  id: Scalars['ID']['input'];
};

export type DeleteCustomerSessionInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCustomerSessionPayload = BaseError | DeleteCustomerSessionSuccessPayload | NotFoundError;

export type DeleteCustomerSessionSuccessPayload = {
  __typename?: 'DeleteCustomerSessionSuccessPayload';
  id: Scalars['ID']['output'];
};

export type DeleteProductOfferInput = {
  id: Scalars['ID']['input'];
};

export type DeleteProductOfferPayload = BaseError | DeleteProductOfferSuccessPayload | NotFoundError;

export type DeleteProductOfferSuccessPayload = {
  __typename?: 'DeleteProductOfferSuccessPayload';
  id: Scalars['ID']['output'];
};

export enum DiscountActionType {
  /** The flat dollar amount value to be deducted from the full premium amount */
  FlatAmount = 'FLAT_AMOUNT',
  /** The percentage to be deducted from the full premium amount */
  Percentage = 'PERCENTAGE'
}

export enum DiscountStatus {
  /** The discount is active and available for use */
  Active = 'ACTIVE'
}

export enum DiscountType {
  ExitSave = 'EXIT_SAVE',
  Promotion = 'PROMOTION'
}

export type DuplicateError = Error & {
  __typename?: 'DuplicateError';
  message: Scalars['String']['output'];
};

export type Edge = {
  cursor: Scalars['String']['output'];
  node: Node;
};

export type Error = {
  message: Scalars['String']['output'];
};

export type Expert = Node & {
  __typename?: 'Expert';
  businessUnit?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lob?: Maybe<Scalars['String']['output']>;
  manager?: Maybe<Scalars['String']['output']>;
  managerId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  site?: Maybe<Scalars['String']['output']>;
  supervisor?: Maybe<Scalars['String']['output']>;
  supervisorId?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type ExpertMetric = Node & {
  __typename?: 'ExpertMetric';
  businessUnit?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  manager?: Maybe<Scalars['String']['output']>;
  metrics: SalesMetric;
  name: Scalars['String']['output'];
  site?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  supervisor?: Maybe<Scalars['String']['output']>;
};


export type ExpertMetricMetricsArgs = {
  productSKU?: InputMaybe<Scalars['String']['input']>;
};

export type ExpertMetricsEdge = Edge & {
  __typename?: 'ExpertMetricsEdge';
  cursor: Scalars['String']['output'];
  node: ExpertMetric;
};

export type ExpertSession = Node & {
  __typename?: 'ExpertSession';
  expert: Expert;
  hostApp?: Maybe<Scalars['String']['output']>;
  /** @deprecated no longer use */
  hostAppId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  supportedSkus: Array<Scalars['String']['output']>;
};

export type ExpertSessionsConnection = Connection & {
  __typename?: 'ExpertSessionsConnection';
  edges: Array<ExpertSessionsEdge>;
  pageInfo: PageInfo;
};

export type ExpertSessionsEdge = Edge & {
  __typename?: 'ExpertSessionsEdge';
  cursor: Scalars['String']['output'];
  node: ExpertSession;
};

export type ExpertsConnection = Connection & {
  __typename?: 'ExpertsConnection';
  edges: Array<ExpertMetricsEdge>;
  pageInfo: PageInfo;
};

/**
 * An extension is a property that can be attached to a type to extend its
 * functionality. Every extension has a code and a value. The code is used to
 * identify the extension and the value is used to store the data.
 */
export type Extension = {
  __typename?: 'Extension';
  /** The code of the extension. */
  code: ExtensionCode;
  /** The value of the extension. The code determines the type of the value. */
  value: Scalars['JSON']['output'];
};

/** The extension codes that are used to identify the extensions. */
export enum ExtensionCode {
  /** Enrollment details from Account Management enrollment eligibility API */
  AmEnrollmentDetails = 'AM_ENROLLMENT_DETAILS',
  /** Eligibility partner ID from Account Management eligibility API */
  AmPartnerId = 'AM_PARTNER_ID',
  /** Denial reason for Fiber internet eligibility */
  DenialReason = 'DENIAL_REASON',
  /** Code for the floor number of an address. Can be a number or a numeric string. */
  FloorNumber = 'FLOOR_NUMBER',
  /**
   * Code for the max internet speed of an internet product. Is a numeric value
   * expressed in megabits per second.
   */
  MaxInternetSpeed = 'MAX_INTERNET_SPEED',
  /** Call type for reporting purposes, specific to McAfee partner */
  McafeeCallType = 'MCAFEE_CALL_TYPE',
  /** Call type for reporting purposes, specific to Optimum partner */
  OptimumCallType = 'OPTIMUM_CALL_TYPE'
}

/**
 * An extension is a property that can be attached to a type to extend its
 * functionality. Every extension has a code and a value. The code is used to
 * identify the extension and the value is used to store the data.
 */
export type ExtensionInput = {
  /** The code of the extension. */
  code: ExtensionCode;
  /** The value of the extension. The code determines the type of the value. */
  value: Scalars['JSON']['input'];
};

export type ExternalClientAccount = {
  __typename?: 'ExternalClientAccount';
  id: Scalars['ID']['output'];
};

export type ExternalSession = {
  __typename?: 'ExternalSession';
  id: Scalars['ID']['output'];
};

export type FlexReservation = {
  __typename?: 'FlexReservation';
  id: Scalars['ID']['output'];
};

export type FlexReservationInput = {
  id: Scalars['ID']['input'];
};

export type HorizonSession = {
  __typename?: 'HorizonSession';
  id: Scalars['ID']['output'];
};

export type IncrementAcceptInput = {
  businessUnit?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['DateTime']['input'];
  expertId: Scalars['String']['input'];
  expertName: Scalars['String']['input'];
  managerId?: InputMaybe<Scalars['String']['input']>;
  managerName?: InputMaybe<Scalars['String']['input']>;
  productSKU: Scalars['String']['input'];
  site?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  supervisorId?: InputMaybe<Scalars['String']['input']>;
  supervisorName?: InputMaybe<Scalars['String']['input']>;
};

export type IncrementAcceptPayload = {
  __typename?: 'IncrementAcceptPayload';
  success: Scalars['Boolean']['output'];
};

export type IncrementCustomerSessionInput = {
  businessUnit?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['DateTime']['input'];
  expertId: Scalars['String']['input'];
  expertName: Scalars['String']['input'];
  managerId?: InputMaybe<Scalars['String']['input']>;
  managerName?: InputMaybe<Scalars['String']['input']>;
  productSKU: Scalars['String']['input'];
  site?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  supervisorId?: InputMaybe<Scalars['String']['input']>;
  supervisorName?: InputMaybe<Scalars['String']['input']>;
};

export type IncrementCustomerSessionPayload = {
  __typename?: 'IncrementCustomerSessionPayload';
  success: Scalars['Boolean']['output'];
};

export type IncrementEnrollmentInput = {
  businessUnit?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['DateTime']['input'];
  expertId: Scalars['String']['input'];
  expertName: Scalars['String']['input'];
  managerId?: InputMaybe<Scalars['String']['input']>;
  managerName?: InputMaybe<Scalars['String']['input']>;
  productSKU: Scalars['String']['input'];
  site?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  supervisorId?: InputMaybe<Scalars['String']['input']>;
  supervisorName?: InputMaybe<Scalars['String']['input']>;
};

export type IncrementEnrollmentPayload = {
  __typename?: 'IncrementEnrollmentPayload';
  success: Scalars['Boolean']['output'];
};

export type IncrementOfferInput = {
  businessUnit?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['DateTime']['input'];
  expertId: Scalars['String']['input'];
  expertName: Scalars['String']['input'];
  managerId?: InputMaybe<Scalars['String']['input']>;
  managerName?: InputMaybe<Scalars['String']['input']>;
  productSKU: Scalars['String']['input'];
  site?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  supervisorId?: InputMaybe<Scalars['String']['input']>;
  supervisorName?: InputMaybe<Scalars['String']['input']>;
};

export type IncrementOfferPayload = {
  __typename?: 'IncrementOfferPayload';
  success: Scalars['Boolean']['output'];
};

export type IncrementOpportunityInput = {
  businessUnit?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['DateTime']['input'];
  expertId: Scalars['String']['input'];
  expertName: Scalars['String']['input'];
  managerId?: InputMaybe<Scalars['String']['input']>;
  managerName?: InputMaybe<Scalars['String']['input']>;
  productSKU: Scalars['String']['input'];
  site?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  supervisorId?: InputMaybe<Scalars['String']['input']>;
  supervisorName?: InputMaybe<Scalars['String']['input']>;
};

export type IncrementOpportunityPayload = {
  __typename?: 'IncrementOpportunityPayload';
  success: Scalars['Boolean']['output'];
};

export type IncrementSearchInput = {
  businessUnit?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['DateTime']['input'];
  expertId: Scalars['String']['input'];
  expertName: Scalars['String']['input'];
  managerId?: InputMaybe<Scalars['String']['input']>;
  managerName?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  supervisorId?: InputMaybe<Scalars['String']['input']>;
  supervisorName?: InputMaybe<Scalars['String']['input']>;
};

export type IncrementSearchPayload = {
  __typename?: 'IncrementSearchPayload';
  success: Scalars['Boolean']['output'];
};

export type Interval = {
  __typename?: 'Interval';
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export type Manager = Node & {
  __typename?: 'Manager';
  businessUnit?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  managerId: Scalars['String']['output'];
  managerName: Scalars['String']['output'];
  site?: Maybe<Scalars['String']['output']>;
};

export type ManagersConnection = Connection & {
  __typename?: 'ManagersConnection';
  edges: Array<ManagersEdge>;
  pageInfo: PageInfo;
};

export type ManagersEdge = Edge & {
  __typename?: 'ManagersEdge';
  cursor: Scalars['String']['output'];
  node: Manager;
};

export type Marketing = {
  __typename?: 'Marketing';
  dealerCode?: Maybe<Scalars['String']['output']>;
  dealerName?: Maybe<Scalars['String']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  referralPartner?: Maybe<Scalars['String']['output']>;
  referrerCode?: Maybe<Scalars['String']['output']>;
  salesChannel?: Maybe<Scalars['String']['output']>;
  salesPersonId?: Maybe<Scalars['String']['output']>;
  salesSessionId?: Maybe<Scalars['String']['output']>;
  storeCode?: Maybe<Scalars['String']['output']>;
  utmParams?: Maybe<UtmParams>;
  vendorData?: Maybe<Scalars['JSONObject']['output']>;
};

export type MarketingInput = {
  /**
   * dealerCode is sourced from the url query parameter `d_c` for direct to consumer channels and is reported in analytics tools as dealerCode. This field has a default value of 4RUMW.
   * Additionally this field is sent as part of the Enrollment record for Asurion Enrollment as the DealerCode field on the Agreement.
   */
  dealerCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * dealerName is sourced from the url query parameter `d_n` for direct to consumer channels and is reported in analytics tools as dealerName.
   * If no `d_n` parameter exists we will look for a configured value in our product-config mapping, and as a final fallback it will be an empty string.
   * Additionally this field is sent as part of the Enrollment record for Asurion Enrollment as the DealerName field on the Agreement.
   */
  dealerName?: InputMaybe<Scalars['String']['input']>;
  /**
   * promoCode is sourced from the url query parameter `p_c` for direct to consumer channels and is reported in analytics tools as promoCode.
   * Additionally this field helps determine the price and month duration as part of the Enrollment record for Asurion Enrollment as the promoCode field on the Agreement.
   */
  promoCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * referralPartner is sourced from the url query parameter `partner` for direct to consumer channels and is reported in analytics tools as referralPartner with a default value of Asurion.
   * Additonally, this field is sent as part of the Enrollment record for Asurion Enrollment in the EnrollmentVendor AccountAttribute.
   */
  referralPartner?: InputMaybe<Scalars['String']['input']>;
  /**
   * referrerCode is sourced from the url query parameter `RCO` for direct to consumer channels and is reported in analytics tools as referrerCode.
   * Additonally, this field is sent as part of the Enrollment record for Asurion Enrollment in the EnrollmentVendor AccountAttribute.
   */
  referrerCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * salesChannel is sourced from the url query parameter `sales_channel` for direct to consumer channels and is reported in analytics tools as referrerCode.
   * Additonally, this field is sent as part of the Enrollment record for Asurion Enrollment in the Sales Channel AccountAttribute.
   */
  salesChannel?: InputMaybe<Scalars['String']['input']>;
  /**
   * Sales Person ID is sourced from the url query parameter `a_id` for direct to consumer channels and is reported in analytics tools as salesPersonId.
   * Additionally this field is sent as part of the Enrollment record for Asurion Enrollment as the SalesPersonId field on the Agreement.
   */
  salesPersonId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Sales Session ID is sourced from the url query parameter `ss_id` for direct to consumer channels and is reported in analytics tools as salesSaessionId.
   * Additionally this field is sent as part of the Enrollment record for Asurion Enrollment as the Sales Session Id AccountAttribute on the Agreement.
   */
  salesSessionId?: InputMaybe<Scalars['String']['input']>;
  /**
   * storeCode is sourced from the url query parameter `s_c` for direct to consumer channels and is reported in analytics tools as storeCode.
   * Additionally this field is sent as part of the Enrollment record for Asurion Enrollment as the StoreCode field on the Agreement.
   */
  storeCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * utmParams is sourced from the url query parameters beginning with `utm_` for direct to consumer channels and is reported in analytics tools as individual UTM entries.
   * Additionally this field is sent as part of the Enrollment record for Asurion Enrollment as an AccountAttribute on the Agreement.
   * NOTE: These parameters are sent as a JSON stringified object to the Enrollment API and can be difficult to parse effectively from that side.
   */
  utmParams?: InputMaybe<UtmParamsInput>;
  /**
   * vendorData is sourced from the url query parameter `v_data` for direct to consumer channels and is reported in analytics tools as vendorData.
   * Additionally this field is sent as part of the Enrollment record for Asurion Enrollment as an AccountAttribute.
   */
  vendorData?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type MdnVerification = {
  __typename?: 'MdnVerification';
  accessToken?: Maybe<Scalars['String']['output']>;
  attemptsRemaining?: Maybe<Scalars['Int']['output']>;
  expiration?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  refreshToken?: Maybe<Scalars['String']['output']>;
  status: MdnVerificationStatus;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export enum MdnVerificationStatus {
  Failed = 'FAILED',
  NotVerified = 'NOT_VERIFIED',
  Pending = 'PENDING',
  Verified = 'VERIFIED'
}

/**
 * Possible status' on the communication entity based on AMP's SNS topic
 * (https://enterprise-confluence.asurion.com/pages/viewpage.action?spaceKey=AMP&title=States+of+a+Request)
 */
export enum MessageStatus {
  /** Message accepted as valid by Vendor. */
  Accepted = 'ACCEPTED',
  /** Destination address is configured to block communications */
  BlacklistBlocked = 'BLACKLIST_BLOCKED',
  /** Customer Clicked on the email */
  Clicked = 'CLICKED',
  /** Message sent by vendor. (May still bounce) */
  Delivered = 'DELIVERED',
  /** It is a duplicate message that is delivered already, Duplicate based on AMP configuration */
  Duplicate = 'DUPLICATE',
  /** ASP status to define a communication entity has been created */
  Initialized = 'INITIALIZED',
  /** Message is determined invalid by AMP due to lack of valid required data elements. */
  Invalid = 'INVALID',
  /** Message not delivered by Vendor */
  NotDelivered = 'NOT_DELIVERED',
  /** Customer Opened the email */
  Opened = 'OPENED',
  /** Message is rejected, could be various reason like rejected at Vendor or out-bound communication failed at customer due to bad address etc. */
  Rejected = 'REJECTED',
  /** Message has been sent to the ESP (Email Service Provider) */
  Sent = 'SENT',
  /** Message received by vendor but not validated. */
  Staged = 'STAGED',
  /** Message is marked as is when there is system error  like error in CG or exception when calling Vendor. */
  SystemError = 'SYSTEM_ERROR',
  /** ASP status if there is an unexpected AMP status */
  Unknown = 'UNKNOWN',
  /** Customer has unsubscribed future delivery of the messages */
  Unsubscribe = 'UNSUBSCRIBE'
}

export enum MessageType {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type Mutation = {
  __typename?: 'Mutation';
  addExpertSession: AddExpertSessionPayload;
  createBilling: CreateBillingPayload;
  createBillingDiscounts: CreateBillingDiscountsPayload;
  createCommunication: CreateCommunicationPayload;
  createCpfVerification: CreateCpfVerificationPayload;
  createCustomerSession: CreateCustomerSessionPayload;
  createExpertSession: CreateExpertSessionPayload;
  createMdnVerification: CreateMdnVerificationPayload;
  createPaySession: CreatePaySessionPayload;
  createProductDeclination: CreateProductDeclinationPayload;
  createProductEnrollment: CreateProductEnrollmentPayload;
  createProductOffer: CreateProductOfferPayload;
  deleteCustomerSession: DeleteCustomerSessionPayload;
  deleteProductOffer: DeleteProductOfferPayload;
  /** Generates a SmartLink for sales checkout. */
  generateSmartLink?: Maybe<SmartLinkResponse>;
  incrementAccept: IncrementAcceptPayload;
  incrementCustomerSession: IncrementCustomerSessionPayload;
  incrementEnrollment: IncrementEnrollmentPayload;
  incrementOffer: IncrementOfferPayload;
  incrementOpportunity: IncrementOpportunityPayload;
  incrementSearch: IncrementSearchPayload;
  updateBilling: UpdateBillingPayload;
  updateCommunication: UpdateCommunicationPayload;
  updateCpfVerification: UpdateCpfVerificationPayload;
  updateCustomer: UpdateCustomerPayload;
  updateCustomerSession: UpdateCustomerSessionPayload;
  updateCustomerSessions: UpdateCustomerSessionsPayload;
  updateExpertOrgChartData: UpdateExpertOrgChartDataPayload;
  updateExpertSession?: Maybe<UpdateExpertSessionPayload>;
  updateMdnVerification: UpdateMdnVerificationPayload;
  updatePaySession: UpdatePaySessionPayload;
  updateProductEligibility: UpdateProductEligibilityPayload;
  updateProductEnrollment: UpdateProductEnrollmentPayload;
  updateProductOffer: UpdateProductOfferPayload;
  updateSalesConfig?: Maybe<Scalars['String']['output']>;
};


export type MutationAddExpertSessionArgs = {
  input: AddExpertSessionInput;
};


export type MutationCreateBillingArgs = {
  input: CreateBillingInput;
};


export type MutationCreateBillingDiscountsArgs = {
  input: CreateBillingDiscountsInput;
};


export type MutationCreateCommunicationArgs = {
  input: CreateCommunicationInput;
};


export type MutationCreateCpfVerificationArgs = {
  input: CreateCpfVerificationInput;
};


export type MutationCreateCustomerSessionArgs = {
  input: CreateCustomerSessionInput;
};


export type MutationCreateExpertSessionArgs = {
  input: CreateExpertSessionInput;
};


export type MutationCreateMdnVerificationArgs = {
  input: CreateMdnVerificationInput;
};


export type MutationCreatePaySessionArgs = {
  input: CreatePaySessionInput;
};


export type MutationCreateProductDeclinationArgs = {
  input: CreateProductDeclinationInput;
};


export type MutationCreateProductEnrollmentArgs = {
  input: CreateProductEnrollmentInput;
};


export type MutationCreateProductOfferArgs = {
  input: CreateProductOfferInput;
};


export type MutationDeleteCustomerSessionArgs = {
  input: DeleteCustomerSessionInput;
};


export type MutationDeleteProductOfferArgs = {
  input: DeleteProductOfferInput;
};


export type MutationGenerateSmartLinkArgs = {
  appName: Scalars['String']['input'];
  checkoutMethod?: InputMaybe<CheckoutMethod>;
  externalConsentReference?: InputMaybe<Scalars['String']['input']>;
  productOfferId: Scalars['ID']['input'];
  smartLinkMdn?: InputMaybe<Scalars['PiiPhoneNumber']['input']>;
};


export type MutationIncrementAcceptArgs = {
  input: IncrementAcceptInput;
};


export type MutationIncrementCustomerSessionArgs = {
  input: IncrementCustomerSessionInput;
};


export type MutationIncrementEnrollmentArgs = {
  input: IncrementEnrollmentInput;
};


export type MutationIncrementOfferArgs = {
  input: IncrementOfferInput;
};


export type MutationIncrementOpportunityArgs = {
  input: IncrementOpportunityInput;
};


export type MutationIncrementSearchArgs = {
  input: IncrementSearchInput;
};


export type MutationUpdateBillingArgs = {
  input: UpdateBillingInput;
};


export type MutationUpdateCommunicationArgs = {
  input: UpdateCommunicationInput;
};


export type MutationUpdateCpfVerificationArgs = {
  input: UpdateCpfVerificationInput;
};


export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerInput;
};


export type MutationUpdateCustomerSessionArgs = {
  input: UpdateCustomerSessionInput;
};


export type MutationUpdateCustomerSessionsArgs = {
  input: UpdateCustomerSessionsInput;
};


export type MutationUpdateExpertOrgChartDataArgs = {
  input: UpdateExpertOrgChartDataInput;
};


export type MutationUpdateExpertSessionArgs = {
  input: UpdateExpertSessionInput;
};


export type MutationUpdateMdnVerificationArgs = {
  input: UpdateMdnVerificationInput;
};


export type MutationUpdatePaySessionArgs = {
  input: UpdatePaySessionInput;
};


export type MutationUpdateProductEligibilityArgs = {
  input: UpdateProductEligibilityInput;
};


export type MutationUpdateProductEnrollmentArgs = {
  input: UpdateProductEnrollmentInput;
};


export type MutationUpdateProductOfferArgs = {
  input: UpdateProductOfferInput;
};


export type MutationUpdateSalesConfigArgs = {
  input: Scalars['String']['input'];
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type NotFoundError = Error & {
  __typename?: 'NotFoundError';
  message: Scalars['String']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaySession = {
  __typename?: 'PaySession';
  /** The biiling frequecny of the transaction in iGlobis. `1`,`6`,`12` supported */
  billingFrequencyInMonths?: Maybe<Scalars['String']['output']>;
  /** This is the token that comes back from the call to getSecurityToken */
  billingGatewaySessionId?: Maybe<Scalars['String']['output']>;
  /**
   * This value comes back on the SNS event at transaction.billingToken
   * It is the tokenized payment details used to collect payment
   */
  billingToken?: Maybe<Scalars['String']['output']>;
  /** The brand of the credit card used in the pay session. */
  brand?: Maybe<Scalars['String']['output']>;
  /** This is used to encrypt the CC data when doing client-side-encryption */
  encryptionKey?: Maybe<Scalars['String']['output']>;
  /** The expiration month of the credit card used in the pay session */
  expirationMonth?: Maybe<Scalars['String']['output']>;
  /** The expiration month of the credit card used in the pay session */
  expirationYear?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The last four of the credit card used in the pay session */
  lastFour?: Maybe<Scalars['String']['output']>;
  /**
   * PayMethodId is sourced from the fraudResults.payMethodIdentifier field on the event from billing
   * gateway and sent to account management as part of the asurion enrollment flow
   */
  payMethodId?: Maybe<Scalars['String']['output']>;
  /** Payment link associated with the session. This will only exist when the transaction type is PAYMENT_LINK. */
  paymentLink?: Maybe<Scalars['String']['output']>;
  /**
   * PaymentType is sourced from the PaymentMethod field on the event from billing
   * gateway and sent to account management as part of the asurion enrollment flow
   */
  paymentType?: Maybe<PaymentType>;
  /** Additional payment frequency field the specifies the payment frequency as either Monthly/Annual. Required for Asurion Enrollment call */
  productPaidFrequency?: Maybe<Scalars['String']['output']>;
  /** Product SKU is used to map to the proper billingProgramId and BG API Key in the Pay-Session service */
  productSku: Scalars['String']['output'];
  status: PaySessionStatus;
  /**
   * This is passed to BG on the call to getSecurityToken
   * It will default to PCITOKEN if not provided on creation
   */
  transactionType: TransactionType;
};

export enum PaySessionStatus {
  Authorized = 'AUTHORIZED',
  AwaitingAuthorization = 'AWAITING_AUTHORIZATION',
  Failure = 'FAILURE',
  Initialized = 'INITIALIZED'
}

/** These map to values expected by AM for payment type */
export enum PaymentType {
  /** Bill to account */
  Bta = 'BTA',
  /** Credit card */
  Cc = 'CC',
  /** Debit card */
  Dc = 'DC',
  /** Direct debit */
  Dd = 'DD',
  /** In store payment */
  Isp = 'ISP'
}

export type Product = {
  __typename?: 'Product';
  sku: Scalars['String']['output'];
};

/** The Product Declination entity is used to represent the customer's declined disposition for a given product. */
export type ProductDeclination = {
  __typename?: 'ProductDeclination';
  id: Scalars['ID']['output'];
  /** The reason why the customer declined the offer. */
  reason?: Maybe<Scalars['String']['output']>;
};

/** The Product Eligibility entity is used to represent the customer's eligibility for a given product. */
export type ProductEligibility = {
  __typename?: 'ProductEligibility';
  /** Extensions included from the eligibility check. */
  extensions: Array<Extension>;
  /**
   * A reference to a 3rd party ID utilized during their eligibility look up process,
   * this is currently used for AT&T Home Tech Protect.
   */
  externalEligibilityId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Elibility reason */
  reason?: Maybe<Scalars['String']['output']>;
  /** The status of eligibility received from 3rd party services or additional rule sets. */
  status: ProductEligibilityStatus;
  /**
   * This is a field returned from eligibility checks on asurion branded SKUs,
   * and is needed to send back along to Account Management when completing enrollment.
   */
  subscriptionNumber?: Maybe<Scalars['String']['output']>;
};

export enum ProductEligibilityStatus {
  /** The customer is already enrolled in the product. */
  AlreadyEnrolled = 'ALREADY_ENROLLED',
  /** The customer's eligibility for the given product is eligible for enrollment. */
  Eligible = 'ELIGIBLE',
  /** The product eligibility errored or timed out. */
  Error = 'ERROR',
  /** The eligibility gets checked externally */
  External = 'EXTERNAL',
  /** The customer is not eligible for the given product's enrollment. */
  Ineligible = 'INELIGIBLE',
  /** The product eligibility check has been initialized. */
  Initialized = 'INITIALIZED',
  /** @deprecated Rename PENDING eligibility status to INITIALIZED (SELL-550) */
  Pending = 'PENDING',
  /**
   * The customer has a pending enrollment in the product, meaning the first attempt failed,
   * and our services are attempting to retry the enrollment in the background.
   */
  PendingEnrollment = 'PENDING_ENROLLMENT',
  /** The customer is currently enrolled in a plan that can be upgraded to a product with additional benefits and coverage. */
  Upgradeable = 'UPGRADEABLE'
}

/**
 * The Product Enrollment entity is used to represent the customer's acceptance of the product offer,
 * as well as reference the status of the enrollment attempt with a 3rd party service.
 */
export type ProductEnrollment = {
  __typename?: 'ProductEnrollment';
  /** Additional data included on the product enrollment */
  additionalData?: Maybe<Scalars['JSON']['output']>;
  /** The enrollment confirmation number received from the 3rd party service. */
  confirmationCode?: Maybe<Scalars['String']['output']>;
  /**
   * The error details associated with a failed enrollment operation.
   * There will always be an associated category, and possible error code and/or message.
   */
  error?: Maybe<ProductEnrollmentError>;
  /** The customer's external reference ID */
  externalReferenceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The timestamp that the product enrollment was most recently updated. */
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /** The ID associated with a Pay Session for Asurion direct billed products. */
  paySessionId?: Maybe<Scalars['ID']['output']>;
  /** The subscription or enrollment ID received from the 3rd party service. */
  planId?: Maybe<Scalars['ID']['output']>;
  /**
   * The status associated with the enrollment attempt,
   * starts with `INITIALIZED` and ultimately results in either `SUCCESS` or `FAILURE`.
   */
  status: ProductEnrollmentStatus;
};

export type ProductEnrollmentError = {
  __typename?: 'ProductEnrollmentError';
  category: ProductEnrollmentErrorCategory;
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum ProductEnrollmentErrorCategory {
  AlreadyEnrolled = 'ALREADY_ENROLLED',
  Billing = 'BILLING',
  Generic = 'GENERIC',
  Ineligible = 'INELIGIBLE'
}

export type ProductEnrollmentErrorInput = {
  category: ProductEnrollmentErrorCategory;
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export enum ProductEnrollmentStatus {
  /** The enrollment failed. */
  Failure = 'FAILURE',
  /** The enrollment is in an intermediate state. */
  Initialized = 'INITIALIZED',
  /** The enrollment is being checked (carrier specific). */
  Pending = 'PENDING',
  /** The enrollment successfully went through. */
  Success = 'SUCCESS'
}

export type ProductMetrics = {
  __typename?: 'ProductMetrics';
  businessUnits: BusinessUnitsConnection;
  experts: ExpertsConnection;
  id: Scalars['ID']['output'];
  interval: Interval;
  managers: ManagersConnection;
  product: Product;
  sites: SitesConnection;
  supervisors: SupervisorsConnection;
  total: SalesMetric;
};


export type ProductMetricsBusinessUnitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type ProductMetricsExpertsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type ProductMetricsManagersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type ProductMetricsSitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type ProductMetricsSupervisorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};

/**
 * A Product Offer is when we offer a product or service to a customer,
 * in which the customer can either decide to enroll in the product or service, or they can decline to enroll.
 */
export type ProductOffer = {
  __typename?: 'ProductOffer';
  /** The discount codes this customer is eligible for as part of this product offer sku and billing program */
  billingDiscounts: Array<BillingDiscount>;
  /** @deprecated Use Customer.mdn */
  customerMdn?: Maybe<Scalars['PhoneNumber']['output']>;
  /** The customer session that the product offer is a part of. */
  customerSession: CustomerSession;
  /** The status of the disclosures for the product offer. */
  disclosureStatus?: Maybe<TransmittedDisclosureStatus>;
  /** If it is an Asurion expert that is making the offer, the associated expert session that initiated the product offer. */
  expertSession?: Maybe<ExpertSession>;
  id: Scalars['ID']['output'];
  /** The ID of the smartlink generated by cloudAPI for checkout */
  linkId?: Maybe<Scalars['String']['output']>;
  /** The Asurion partner associated with the product and/or product offer (ex. Verizon, ATT, Asurion, Cricket). */
  partner: Scalars['String']['output'];
  /** A product offer entity representing the customer's declined disposition of the offer. */
  productDeclination?: Maybe<ProductDeclination>;
  /** A product offer entity representing the customer's eligibility in relation to the product offer. */
  productEligibility?: Maybe<ProductEligibility>;
  /** A product offer entity representing the customer's enrollment status of the product. */
  productEnrollment?: Maybe<ProductEnrollment>;
  /** The internal catalog SKU for a given product. */
  productSku: Scalars['String']['output'];
  /**
   * A derived value based off the existence of the entities `ProductEnrollment` or `ProductDeclination`,
   * will result in either `NOT_OFFERED`, `ACCEPTED`, or `DECLINED`.
   */
  status: ProductOfferStatus;
  /** Get the tax amount for a product when provided with an invoice amount and address */
  taxAmount?: Maybe<Scalars['String']['output']>;
};


/**
 * A Product Offer is when we offer a product or service to a customer,
 * in which the customer can either decide to enroll in the product or service, or they can decline to enroll.
 */
export type ProductOfferTaxAmountArgs = {
  invoiceAmount: Scalars['String']['input'];
  shipToAddress: AddressInput;
};

export enum ProductOfferStatus {
  /** The status that is derived when a Product Offer contains a Product Enrollment entity. */
  Accepted = 'ACCEPTED',
  /** The status that is derived when a Product Offer contains a Product Declination entity. */
  Declined = 'DECLINED',
  /** The default status when a product offer is created. */
  NotOffered = 'NOT_OFFERED',
  /** @deprecated no longer possible */
  Offered = 'OFFERED'
}

export type Query = {
  __typename?: 'Query';
  customerSession?: Maybe<CustomerSession>;
  customerSessions: Array<CustomerSession>;
  customerSessionsByExternalSessionId: Array<CustomerSession>;
  expertMetric?: Maybe<ExpertMetric>;
  expertSession?: Maybe<ExpertSession>;
  expertSessions: ExpertSessionsConnection;
  metrics: ProductMetrics;
  productOffer?: Maybe<ProductOffer>;
  productOffersByCustomerSessionId: Array<ProductOffer>;
  salesConfig?: Maybe<Scalars['JSON']['output']>;
};


export type QueryCustomerSessionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomerSessionsArgs = {
  mdn: Scalars['PiiPhoneNumber']['input'];
  partner?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomerSessionsByExternalSessionIdArgs = {
  externalSessionId: Scalars['ID']['input'];
};


export type QueryExpertMetricArgs = {
  expertId: Scalars['String']['input'];
};


export type QueryExpertSessionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExpertSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  since?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  username: Scalars['String']['input'];
};


export type QueryMetricsArgs = {
  businessUnit?: InputMaybe<Scalars['String']['input']>;
  manager?: InputMaybe<Scalars['String']['input']>;
  productSKU: Scalars['String']['input'];
  site?: InputMaybe<Scalars['String']['input']>;
  supervisor?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductOfferArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductOffersByCustomerSessionIdArgs = {
  customerSessionId: Scalars['ID']['input'];
  productSku?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySalesConfigArgs = {
  applicationName: Scalars['String']['input'];
  configName: Scalars['String']['input'];
};

export enum RedemptionType {
  Limited = 'LIMITED',
  Unlimited = 'UNLIMITED'
}

export type SalesMetric = {
  __typename?: 'SalesMetric';
  /** @deprecated Use enrollmentRate instead */
  acceptRate: Scalars['Float']['output'];
  /** @deprecated Use enrollments instead */
  accepts: Scalars['Int']['output'];
  customerSessions: Scalars['Int']['output'];
  enrollmentRate: Scalars['Float']['output'];
  enrollments: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Use sessionOfferRate instead */
  offerRate: Scalars['Float']['output'];
  offers: Scalars['Int']['output'];
  /** @deprecated Use customerSessions instead */
  opportunities: Scalars['Int']['output'];
  searches: Scalars['Int']['output'];
  sessionOfferRate: Scalars['Float']['output'];
};

export enum SessionStatus {
  Callback = 'CALLBACK',
  ClosedByRefresh = 'CLOSED_BY_REFRESH',
  Completed = 'COMPLETED',
  HasEligibleOffers = 'HAS_ELIGIBLE_OFFERS',
  HasNoEligibleOffers = 'HAS_NO_ELIGIBLE_OFFERS',
  InProgress = 'IN_PROGRESS',
  StartedWithoutMdn = 'STARTED_WITHOUT_MDN',
  StartedWithMdn = 'STARTED_WITH_MDN'
}

export type Site = Node & {
  __typename?: 'Site';
  businessUnit?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metrics: SalesMetric;
  site: Scalars['String']['output'];
  source?: Maybe<Scalars['String']['output']>;
};

export type SitesConnection = Connection & {
  __typename?: 'SitesConnection';
  edges: Array<SitesEdge>;
  pageInfo: PageInfo;
};

export type SitesEdge = Edge & {
  __typename?: 'SitesEdge';
  cursor: Scalars['String']['output'];
  node: Site;
};

/** Response from SmartLink generation request */
export type SmartLinkResponse = {
  __typename?: 'SmartLinkResponse';
  /** Expiration time of the link Smartlink will be valid for 30 mins from the time of creation */
  expires_at: Scalars['DateTime']['output'];
  /** Checkout Link */
  link: Scalars['String']['output'];
  /** ID of the SmartLink. Used to invalidate link on expiration or usage. */
  link_id: Scalars['String']['output'];
  render_billing_page: Scalars['Boolean']['output'];
};

export enum Sort {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Subscription = {
  __typename?: 'Subscription';
  customerSessionCreated: CustomerSession;
  customerSessionUpdated: CustomerSession;
  mdnVerificationUpdated: MdnVerification;
  paySessionUpdated: PaySession;
  productEligibilityCreated: ProductEligibility;
  productEligibilityUpdated: ProductEligibility;
  productEnrollmentCreated: ProductEnrollment;
  productEnrollmentUpdated: ProductEnrollment;
  productOfferCreated: ProductOffer;
  productOfferUpdated?: Maybe<ProductOffer>;
};


export type SubscriptionCustomerSessionCreatedArgs = {
  customerSessionId?: InputMaybe<Scalars['ID']['input']>;
  expertSessionId: Scalars['ID']['input'];
  since?: InputMaybe<Scalars['DateTime']['input']>;
};


export type SubscriptionCustomerSessionUpdatedArgs = {
  customerSessionId: Scalars['ID']['input'];
  since?: InputMaybe<Scalars['DateTime']['input']>;
};


export type SubscriptionMdnVerificationUpdatedArgs = {
  customerSessionId?: InputMaybe<Scalars['ID']['input']>;
  mdnVerificationId: Scalars['ID']['input'];
  since?: InputMaybe<Scalars['DateTime']['input']>;
};


export type SubscriptionPaySessionUpdatedArgs = {
  customerSessionId?: InputMaybe<Scalars['ID']['input']>;
  paySessionId: Scalars['ID']['input'];
  since?: InputMaybe<Scalars['DateTime']['input']>;
};


export type SubscriptionProductEligibilityCreatedArgs = {
  productOfferId: Scalars['ID']['input'];
  since?: InputMaybe<Scalars['DateTime']['input']>;
};


export type SubscriptionProductEligibilityUpdatedArgs = {
  productOfferId: Scalars['ID']['input'];
  since?: InputMaybe<Scalars['DateTime']['input']>;
};


export type SubscriptionProductEnrollmentCreatedArgs = {
  productOfferId: Scalars['ID']['input'];
  since?: InputMaybe<Scalars['DateTime']['input']>;
};


export type SubscriptionProductEnrollmentUpdatedArgs = {
  productOfferId: Scalars['ID']['input'];
  since?: InputMaybe<Scalars['DateTime']['input']>;
};


export type SubscriptionProductOfferCreatedArgs = {
  productOfferId: Scalars['ID']['input'];
  since?: InputMaybe<Scalars['DateTime']['input']>;
};


export type SubscriptionProductOfferUpdatedArgs = {
  productOfferId: Scalars['ID']['input'];
  since?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Supervisor = Node & {
  __typename?: 'Supervisor';
  businessUnit?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  managerId?: Maybe<Scalars['String']['output']>;
  site?: Maybe<Scalars['String']['output']>;
  supervisorId: Scalars['String']['output'];
  supervisorName: Scalars['String']['output'];
};

export type SupervisorsConnection = Connection & {
  __typename?: 'SupervisorsConnection';
  edges: Array<SupervisorsEdge>;
  pageInfo: PageInfo;
};

export type SupervisorsEdge = Edge & {
  __typename?: 'SupervisorsEdge';
  cursor: Scalars['String']['output'];
  node: Supervisor;
};

/** This maps to the values given for txnType here: https://enterprise-confluence.asurion.com/pages/viewpage.action?pageId=332551353 */
export enum TransactionType {
  AgentAssisted = 'AGENT_ASSISTED',
  PaymentLink = 'PAYMENT_LINK',
  Pcitoken = 'PCITOKEN',
  Terminal = 'TERMINAL'
}

export enum TransmittedDisclosureStatus {
  /** The disclosures have been accepted. */
  Accepted = 'ACCEPTED',
  /** The disclosures have been declined. */
  Declined = 'DECLINED',
  /** Default status when a product offer is created. */
  Initialized = 'INITIALIZED'
}

export type UpdateAsurionCallInput = {
  direction?: InputMaybe<CallDirection>;
  flexReservation?: InputMaybe<FlexReservationInput>;
  id: Scalars['ID']['input'];
};

export type UpdateBillingInput = {
  address?: InputMaybe<AddressInput>;
  customerSessionId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateBillingPayload = BaseError | NotFoundError | UpdateBillingSuccessPayload;

export type UpdateBillingSuccessPayload = {
  __typename?: 'UpdateBillingSuccessPayload';
  billing: Billing;
};

export type UpdateCommunicationInput = {
  customerSessionId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  status?: InputMaybe<MessageStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  templateVariables?: InputMaybe<Scalars['JSONObject']['input']>;
  type?: InputMaybe<MessageType>;
};

export type UpdateCommunicationPayload = BaseError | NotFoundError | UpdateCommunicationSuccessPayload;

export type UpdateCommunicationSuccessPayload = {
  __typename?: 'UpdateCommunicationSuccessPayload';
  communication?: Maybe<Communication>;
};

export type UpdateCpfVerificationInput = {
  customerSessionId: Scalars['ID']['input'];
  status?: InputMaybe<CpfVerificationStatus>;
};

export type UpdateCpfVerificationPayload = BaseError | NotFoundError | UpdateCpfVerificationSuccessPayload;

export type UpdateCpfVerificationSuccessPayload = {
  __typename?: 'UpdateCpfVerificationSuccessPayload';
  cpfVerification: CpfVerification;
};

export type UpdateCustomerInput = {
  accountNumber?: InputMaybe<Scalars['PiiString']['input']>;
  address?: InputMaybe<AddressInput>;
  asset?: InputMaybe<AssetInput>;
  asurionId?: InputMaybe<Scalars['ID']['input']>;
  customerSessionId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['PiiString']['input']>;
  firstName?: InputMaybe<Scalars['PiiString']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['PiiString']['input']>;
  mdn?: InputMaybe<Scalars['PiiPhoneNumber']['input']>;
  mobileBan?: InputMaybe<Scalars['PiiString']['input']>;
  socialName?: InputMaybe<Scalars['PiiString']['input']>;
  temporaryMdn?: InputMaybe<Scalars['PiiPhoneNumber']['input']>;
};

export type UpdateCustomerPayload = BaseError | NotFoundError | UpdateCustomerSuccessPayload;

export type UpdateCustomerSessionCpfVerificationInput = {
  cpf: Scalars['PiiString']['input'];
  status: CpfVerificationStatus;
};

export type UpdateCustomerSessionCustomerInput = {
  accountNumber?: InputMaybe<Scalars['PiiString']['input']>;
  address?: InputMaybe<AddressInput>;
  asset?: InputMaybe<AssetInput>;
  asurionId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['PiiString']['input']>;
  firstName?: InputMaybe<Scalars['PiiString']['input']>;
  lastName?: InputMaybe<Scalars['PiiString']['input']>;
  mdn?: InputMaybe<Scalars['PiiPhoneNumber']['input']>;
  mobileBan?: InputMaybe<Scalars['PiiString']['input']>;
  socialName?: InputMaybe<Scalars['PiiString']['input']>;
  temporaryMdn?: InputMaybe<Scalars['PiiPhoneNumber']['input']>;
};

export type UpdateCustomerSessionInput = {
  asurionCall?: InputMaybe<UpdateAsurionCallInput>;
  billing?: InputMaybe<UpdateCustomerSessionUpdateBillingInput>;
  cpfVerification?: InputMaybe<UpdateCustomerSessionCpfVerificationInput>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  customer?: InputMaybe<UpdateCustomerSessionCustomerInput>;
  /** @deprecated Use AsurionCallInput.direction */
  direction?: InputMaybe<CallDirection>;
  id: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  marketing?: InputMaybe<UpdateCustomerSessionMarketingInput>;
  outboundCall?: InputMaybe<UpdateAsurionCallInput>;
  status?: InputMaybe<SessionStatus>;
};

export type UpdateCustomerSessionMarketingInput = {
  dealerCode?: InputMaybe<Scalars['String']['input']>;
  dealerName?: InputMaybe<Scalars['String']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  referralPartner?: InputMaybe<Scalars['String']['input']>;
  referrerCode?: InputMaybe<Scalars['String']['input']>;
  salesChannel?: InputMaybe<Scalars['String']['input']>;
  salesPersonId?: InputMaybe<Scalars['String']['input']>;
  salesSessionId?: InputMaybe<Scalars['String']['input']>;
  storeCode?: InputMaybe<Scalars['String']['input']>;
  utmParams?: InputMaybe<UtmParamsInput>;
  vendorData?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type UpdateCustomerSessionPayload = BaseError | NotFoundError | UpdateCustomerSessionSuccessPayload;

export type UpdateCustomerSessionSuccessPayload = {
  __typename?: 'UpdateCustomerSessionSuccessPayload';
  customerSession: CustomerSession;
};

export type UpdateCustomerSessionUpdateBillingInput = {
  address: AddressInput;
  closingDay?: InputMaybe<Scalars['String']['input']>;
  dueDay?: InputMaybe<Scalars['String']['input']>;
  externalBillingCycleId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerSessionsInput = {
  expertId?: InputMaybe<Scalars['ID']['input']>;
  externalSessionId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<SessionStatus>;
};

export type UpdateCustomerSessionsPayload = BaseError | NotFoundError | UpdateCustomerSessionsSuccessPayload;

export type UpdateCustomerSessionsSuccessPayload = {
  __typename?: 'UpdateCustomerSessionsSuccessPayload';
  customerSessions: Array<CustomerSession>;
};

export type UpdateCustomerSuccessPayload = {
  __typename?: 'UpdateCustomerSuccessPayload';
  customer: Customer;
};

export type UpdateExpertOrgChartDataInput = {
  businessUnit?: InputMaybe<Scalars['String']['input']>;
  expertSessionId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  lob?: InputMaybe<Scalars['String']['input']>;
  manager?: InputMaybe<Scalars['String']['input']>;
  managerId?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Scalars['String']['input']>;
  supervisor?: InputMaybe<Scalars['String']['input']>;
  supervisorId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExpertOrgChartDataPayload = BaseError | NotFoundError | UpdateExpertOrgChartDataSuccessPayload;

export type UpdateExpertOrgChartDataSuccessPayload = {
  __typename?: 'UpdateExpertOrgChartDataSuccessPayload';
  expertSession: ExpertSession;
};

export type UpdateExpertSessionInput = {
  hostApp?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateExpertSessionPayload = BaseError | NotFoundError | UpdateExpertSessionSuccessPayload;

export type UpdateExpertSessionSuccessPayload = {
  __typename?: 'UpdateExpertSessionSuccessPayload';
  expertSession: ExpertSession;
};

export type UpdateMdnVerificationInput = {
  accessToken?: InputMaybe<Scalars['PiiString']['input']>;
  attemptsRemaining?: InputMaybe<Scalars['Int']['input']>;
  customerSessionId: Scalars['ID']['input'];
  expiration?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  otp?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['PiiString']['input']>;
  status?: InputMaybe<MdnVerificationStatus>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMdnVerificationPayload = BaseError | NotFoundError | UpdateMdnVerificationSuccessPayload;

export type UpdateMdnVerificationSuccessPayload = {
  __typename?: 'UpdateMdnVerificationSuccessPayload';
  mdnVerification: MdnVerification;
};

export type UpdatePaySessionInput = {
  billingFrequencyInMonths?: InputMaybe<Scalars['String']['input']>;
  /** This is the token that comes back from the call to getSecurityToken */
  billingGatewaySessionId?: InputMaybe<Scalars['String']['input']>;
  /**
   * This value comes back on the SNS event at transaction.billingToken
   * It is the tokenized payment details used to collect payment
   */
  billingToken?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['PiiString']['input']>;
  customerSessionId: Scalars['ID']['input'];
  /** This is used to encrypt the CC data when doing client-side-encryption */
  encryptionKey?: InputMaybe<Scalars['String']['input']>;
  expirationMonth?: InputMaybe<Scalars['PiiString']['input']>;
  expirationYear?: InputMaybe<Scalars['PiiString']['input']>;
  id: Scalars['ID']['input'];
  lastFour?: InputMaybe<Scalars['PiiString']['input']>;
  payMethodId?: InputMaybe<Scalars['String']['input']>;
  /** Payment link associated with the session. This will only exist when the transaction type is PAYMENT_LINK. */
  paymentLink?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<PaymentType>;
  productPaidFrequency?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaySessionStatus>;
};

export type UpdatePaySessionPayload = BaseError | NotFoundError | UpdatePaySessionSuccessPayload;

export type UpdatePaySessionSuccessPayload = {
  __typename?: 'UpdatePaySessionSuccessPayload';
  paySession: PaySession;
};

export type UpdateProductEligibilityInput = {
  extensions?: InputMaybe<Array<ExtensionInput>>;
  externalEligibilityId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  productOfferId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProductEligibilityStatus>;
  subscriptionNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductEligibilityPayload = BaseError | NotFoundError | UpdateProductEligibilitySuccessPayload;

export type UpdateProductEligibilitySuccessPayload = {
  __typename?: 'UpdateProductEligibilitySuccessPayload';
  productEligibility: ProductEligibility;
};

export type UpdateProductEnrollmentInput = {
  error?: InputMaybe<ProductEnrollmentErrorInput>;
  externalReferenceId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  planId?: InputMaybe<Scalars['ID']['input']>;
  productOfferId: Scalars['ID']['input'];
  status: ProductEnrollmentStatus;
};

export type UpdateProductEnrollmentPayload = BaseError | NotFoundError | UpdateProductEnrollmentSuccessPayload;

export type UpdateProductEnrollmentSuccessPayload = {
  __typename?: 'UpdateProductEnrollmentSuccessPayload';
  productEnrollment: ProductEnrollment;
};

export type UpdateProductOfferInput = {
  disclosureStatus?: InputMaybe<TransmittedDisclosureStatus>;
  id: Scalars['ID']['input'];
  /** Id of smart link generated by cloud api during checkout */
  linkId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductOfferPayload = BaseError | NotFoundError | UpdateProductOfferSuccessPayload;

export type UpdateProductOfferSuccessPayload = {
  __typename?: 'UpdateProductOfferSuccessPayload';
  productOffer: ProductOffer;
};

export type UtmParams = {
  __typename?: 'UtmParams';
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmContent?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
};

export type UtmParamsInput = {
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};

export type AddressFragment = { __typename?: 'Address', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, addressType?: AddressType | null, city?: string | null, country?: string | null, municipality?: string | null, postalCode?: string | null, state?: string | null };

export type AssetFragment = { __typename?: 'Asset', assetCatalogId?: string | null, imageUrl?: string | null, make?: string | null, model?: string | null, name?: string | null };

export type AsurionCallFragment = { __typename?: 'AsurionCall', id: string, flexReservation?: { __typename?: 'FlexReservation', id: string } | null };

export type BillingFragment = { __typename?: 'Billing', id: string, address: { __typename?: 'Address', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, addressType?: AddressType | null, city?: string | null, country?: string | null, municipality?: string | null, postalCode?: string | null, state?: string | null } };

export type CommunicationFragment = { __typename?: 'Communication', customerSessionId: string, id: string, transactionId?: string | null, status: MessageStatus, productSku?: string | null, templateId: string, templateVariables?: any | null, type: MessageType };

export type CustomerSessionFragment = { __typename?: 'CustomerSession', id: string, status: SessionStatus, partner: string, createdAt?: string | null, channel?: string | null, cohortTag?: string | null, language?: string | null, direction?: CallDirection | null, expertSessions: Array<{ __typename?: 'ExpertSession', id: string }>, asurionCall?: { __typename?: 'AsurionCall', id: string, flexReservation?: { __typename?: 'FlexReservation', id: string } | null } | null, billing?: { __typename?: 'Billing', id: string, address: { __typename?: 'Address', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, addressType?: AddressType | null, city?: string | null, country?: string | null, municipality?: string | null, postalCode?: string | null, state?: string | null } } | null, externalClientAccount?: { __typename?: 'ExternalClientAccount', id: string } | null, horizonSession?: { __typename?: 'HorizonSession', id: string } | null, customer?: { __typename?: 'Customer', id: string, asurionId?: string | null, mdn?: any | null, email?: string | null, firstName?: string | null, lastName?: string | null, socialName?: string | null, accountNumber?: string | null, asset?: { __typename?: 'Asset', assetCatalogId?: string | null, imageUrl?: string | null, make?: string | null, model?: string | null, name?: string | null } | null, address?: { __typename?: 'Address', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, addressType?: AddressType | null, city?: string | null, country?: string | null, municipality?: string | null, postalCode?: string | null, state?: string | null } | null } | null, marketing?: { __typename?: 'Marketing', salesChannel?: string | null, referralPartner?: string | null, referrerCode?: string | null, salesSessionId?: string | null, vendorData?: any | null, dealerCode?: string | null, salesPersonId?: string | null, storeCode?: string | null, promoCode?: string | null, utmParams?: { __typename?: 'UtmParams', utmCampaign?: string | null, utmContent?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, extensions: Array<{ __typename?: 'Extension', value: any, code: ExtensionCode }>, externalSession?: { __typename?: 'ExternalSession', id: string } | null, outboundCalls: Array<{ __typename?: 'AsurionCall', id: string, flexReservation?: { __typename?: 'FlexReservation', id: string } | null }> };

export type CustomerFragment = { __typename?: 'Customer', id: string, asurionId?: string | null, mdn?: any | null, email?: string | null, firstName?: string | null, lastName?: string | null, socialName?: string | null, accountNumber?: string | null, asset?: { __typename?: 'Asset', assetCatalogId?: string | null, imageUrl?: string | null, make?: string | null, model?: string | null, name?: string | null } | null, address?: { __typename?: 'Address', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, addressType?: AddressType | null, city?: string | null, country?: string | null, municipality?: string | null, postalCode?: string | null, state?: string | null } | null };

export type ExternalClientAccountFragment = { __typename?: 'ExternalClientAccount', id: string };

export type HorizonSessionFragment = { __typename?: 'HorizonSession', id: string };

export type MarketingFragment = { __typename?: 'Marketing', salesChannel?: string | null, referralPartner?: string | null, referrerCode?: string | null, salesSessionId?: string | null, vendorData?: any | null, dealerCode?: string | null, salesPersonId?: string | null, storeCode?: string | null, promoCode?: string | null, utmParams?: { __typename?: 'UtmParams', utmCampaign?: string | null, utmContent?: string | null, utmMedium?: string | null, utmSource?: string | null } | null };

export type MdnVerificationFragment = { __typename?: 'MdnVerification', id: string, status: MdnVerificationStatus, transactionId?: string | null, expiration?: any | null, attemptsRemaining?: number | null, accessToken?: string | null, refreshToken?: string | null };

export type PaySessionFragment = { __typename?: 'PaySession', id: string, billingGatewaySessionId?: string | null, billingToken?: string | null, encryptionKey?: string | null, paymentLink?: string | null, paymentType?: PaymentType | null, payMethodId?: string | null, productSku: string, status: PaySessionStatus, transactionType: TransactionType, lastFour?: string | null, brand?: string | null, expirationMonth?: string | null, expirationYear?: string | null, billingFrequencyInMonths?: string | null, productPaidFrequency?: string | null };

export type CreateBillingMutationVariables = Exact<{
  customerSessionId: Scalars['ID']['input'];
  address: AddressInput;
}>;


export type CreateBillingMutation = { __typename?: 'Mutation', createBilling: { __typename?: 'BaseError', message: string } | { __typename?: 'CreateBillingSuccessPayload', billing: { __typename?: 'Billing', id: string, address: { __typename?: 'Address', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, addressType?: AddressType | null, city?: string | null, country?: string | null, municipality?: string | null, postalCode?: string | null, state?: string | null } } } | { __typename?: 'DuplicateError', message: string } | { __typename?: 'NotFoundError', message: string } };

export type CreateCommunicationMutationVariables = Exact<{
  customerSessionId: Scalars['ID']['input'];
  templateId: Scalars['String']['input'];
  status?: InputMaybe<MessageStatus>;
  productSku?: InputMaybe<Scalars['String']['input']>;
  type: MessageType;
  mdn?: InputMaybe<Scalars['PiiPhoneNumber']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['PiiString']['input']>;
  templateVariables?: InputMaybe<Scalars['JSONObject']['input']>;
}>;


export type CreateCommunicationMutation = { __typename?: 'Mutation', createCommunication: { __typename?: 'BaseError', message: string } | { __typename?: 'CreateCommunicationSuccessPayload', communication?: { __typename?: 'Communication', customerSessionId: string, id: string, transactionId?: string | null, status: MessageStatus, productSku?: string | null, templateId: string, templateVariables?: any | null, type: MessageType } | null } | { __typename?: 'NotFoundError', message: string } };

export type CreateCustomerSessionMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  expertSessionId?: InputMaybe<Scalars['ID']['input']>;
  partner: Scalars['String']['input'];
  customer?: InputMaybe<CreateCustomerInput>;
  includeCustomer?: Scalars['Boolean']['input'];
  origin?: InputMaybe<Scalars['String']['input']>;
  externalClientAccount?: InputMaybe<CreateExternalClientAccountInput>;
  horizonSession?: InputMaybe<CreateHorizonSessionInput>;
  externalSession?: InputMaybe<CreateExternalSessionInput>;
  asurionCall?: InputMaybe<CreateAsurionCallInput>;
  channel?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CallDirection>;
  marketing?: InputMaybe<MarketingInput>;
  includeMarketing?: Scalars['Boolean']['input'];
  extensions?: InputMaybe<Array<ExtensionInput> | ExtensionInput>;
  sessionStatus?: InputMaybe<SessionStatus>;
  cohortTag?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCustomerSessionMutation = { __typename?: 'Mutation', createCustomerSession: { __typename?: 'BaseError', message: string } | { __typename?: 'CreateCustomerSessionSuccessPayload', customerSession: { __typename?: 'CustomerSession', id: string, status: SessionStatus, partner: string, createdAt?: string | null, channel?: string | null, cohortTag?: string | null, language?: string | null, direction?: CallDirection | null, customer?: { __typename?: 'Customer', id: string, asurionId?: string | null, mdn?: any | null, email?: string | null, firstName?: string | null, lastName?: string | null, socialName?: string | null, accountNumber?: string | null, asset?: { __typename?: 'Asset', assetCatalogId?: string | null, imageUrl?: string | null, make?: string | null, model?: string | null, name?: string | null } | null, address?: { __typename?: 'Address', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, addressType?: AddressType | null, city?: string | null, country?: string | null, municipality?: string | null, postalCode?: string | null, state?: string | null } | null } | null, expertSessions: Array<{ __typename?: 'ExpertSession', id: string }>, asurionCall?: { __typename?: 'AsurionCall', id: string, flexReservation?: { __typename?: 'FlexReservation', id: string } | null } | null, billing?: { __typename?: 'Billing', id: string, address: { __typename?: 'Address', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, addressType?: AddressType | null, city?: string | null, country?: string | null, municipality?: string | null, postalCode?: string | null, state?: string | null } } | null, externalClientAccount?: { __typename?: 'ExternalClientAccount', id: string } | null, horizonSession?: { __typename?: 'HorizonSession', id: string } | null, marketing?: { __typename?: 'Marketing', salesChannel?: string | null, referralPartner?: string | null, referrerCode?: string | null, salesSessionId?: string | null, vendorData?: any | null, dealerCode?: string | null, salesPersonId?: string | null, storeCode?: string | null, promoCode?: string | null, utmParams?: { __typename?: 'UtmParams', utmCampaign?: string | null, utmContent?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, extensions: Array<{ __typename?: 'Extension', value: any, code: ExtensionCode }>, externalSession?: { __typename?: 'ExternalSession', id: string } | null, outboundCalls: Array<{ __typename?: 'AsurionCall', id: string, flexReservation?: { __typename?: 'FlexReservation', id: string } | null }> } } | { __typename?: 'DuplicateError' } };

export type CreateMdnVerificationMutationVariables = Exact<{
  customerSessionId: Scalars['ID']['input'];
}>;


export type CreateMdnVerificationMutation = { __typename?: 'Mutation', createMdnVerification: { __typename?: 'BaseError', message: string } | { __typename?: 'CreateMdnVerificationSuccessPayload', mdnVerification: { __typename?: 'MdnVerification', id: string, status: MdnVerificationStatus, transactionId?: string | null, expiration?: any | null, attemptsRemaining?: number | null, accessToken?: string | null, refreshToken?: string | null } } | { __typename?: 'NotFoundError', message: string } };

export type CreatePaySessionMutationVariables = Exact<{
  customerSessionId: Scalars['ID']['input'];
  productSku: Scalars['String']['input'];
  transactionType?: InputMaybe<TransactionType>;
  billingToken?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<PaymentType>;
  billingFrequencyInMonths?: InputMaybe<Scalars['String']['input']>;
  productPaidFrequency?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreatePaySessionMutation = { __typename?: 'Mutation', createPaySession: { __typename?: 'BaseError', message: string } | { __typename?: 'CreatePaySessionSuccessPayload', paySession: { __typename?: 'PaySession', id: string, billingGatewaySessionId?: string | null, billingToken?: string | null, encryptionKey?: string | null, paymentLink?: string | null, paymentType?: PaymentType | null, payMethodId?: string | null, productSku: string, status: PaySessionStatus, transactionType: TransactionType, lastFour?: string | null, brand?: string | null, expirationMonth?: string | null, expirationYear?: string | null, billingFrequencyInMonths?: string | null, productPaidFrequency?: string | null } } | { __typename?: 'NotFoundError', message: string } };

export type GenerateSmartLinkMutationVariables = Exact<{
  productOfferId: Scalars['ID']['input'];
  appName: Scalars['String']['input'];
  checkoutMethod?: InputMaybe<CheckoutMethod>;
  smartLinkMdn?: InputMaybe<Scalars['PiiPhoneNumber']['input']>;
  externalConsentReference?: InputMaybe<Scalars['String']['input']>;
}>;


export type GenerateSmartLinkMutation = { __typename?: 'Mutation', generateSmartLink?: { __typename?: 'SmartLinkResponse', expires_at: any, link: string, link_id: string, render_billing_page: boolean } | null };

export type UpdateBillingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  customerSessionId: Scalars['ID']['input'];
  address?: InputMaybe<AddressInput>;
}>;


export type UpdateBillingMutation = { __typename?: 'Mutation', updateBilling: { __typename?: 'BaseError', message: string } | { __typename?: 'NotFoundError', message: string } | { __typename?: 'UpdateBillingSuccessPayload', billing: { __typename?: 'Billing', id: string, address: { __typename?: 'Address', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, addressType?: AddressType | null, city?: string | null, country?: string | null, municipality?: string | null, postalCode?: string | null, state?: string | null } } } };

export type UpdateCommunicationMutationVariables = Exact<{
  customerSessionId: Scalars['ID']['input'];
  communicationId: Scalars['ID']['input'];
  templateId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MessageStatus>;
  type?: InputMaybe<MessageType>;
  templateVariables?: InputMaybe<Scalars['JSONObject']['input']>;
}>;


export type UpdateCommunicationMutation = { __typename?: 'Mutation', updateCommunication: { __typename?: 'BaseError', message: string } | { __typename?: 'NotFoundError', message: string } | { __typename?: 'UpdateCommunicationSuccessPayload', communication?: { __typename?: 'Communication', customerSessionId: string, id: string, transactionId?: string | null, status: MessageStatus, productSku?: string | null, templateId: string, templateVariables?: any | null, type: MessageType } | null } };

export type UpdateCustomerSessionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  status?: InputMaybe<SessionStatus>;
  outboundCall?: InputMaybe<UpdateAsurionCallInput>;
  marketing?: InputMaybe<UpdateCustomerSessionMarketingInput>;
  customer?: InputMaybe<UpdateCustomerSessionCustomerInput>;
  direction?: InputMaybe<CallDirection>;
  language?: InputMaybe<Scalars['String']['input']>;
  includeCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  includeMarketing?: Scalars['Boolean']['input'];
}>;


export type UpdateCustomerSessionMutation = { __typename?: 'Mutation', updateCustomerSession: { __typename?: 'BaseError', message: string } | { __typename?: 'NotFoundError', message: string } | { __typename?: 'UpdateCustomerSessionSuccessPayload', customerSession: { __typename?: 'CustomerSession', id: string, status: SessionStatus, partner: string, createdAt?: string | null, channel?: string | null, cohortTag?: string | null, language?: string | null, direction?: CallDirection | null, expertSessions: Array<{ __typename?: 'ExpertSession', id: string }>, asurionCall?: { __typename?: 'AsurionCall', id: string, flexReservation?: { __typename?: 'FlexReservation', id: string } | null } | null, billing?: { __typename?: 'Billing', id: string, address: { __typename?: 'Address', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, addressType?: AddressType | null, city?: string | null, country?: string | null, municipality?: string | null, postalCode?: string | null, state?: string | null } } | null, externalClientAccount?: { __typename?: 'ExternalClientAccount', id: string } | null, horizonSession?: { __typename?: 'HorizonSession', id: string } | null, customer?: { __typename?: 'Customer', id: string, asurionId?: string | null, mdn?: any | null, email?: string | null, firstName?: string | null, lastName?: string | null, socialName?: string | null, accountNumber?: string | null, asset?: { __typename?: 'Asset', assetCatalogId?: string | null, imageUrl?: string | null, make?: string | null, model?: string | null, name?: string | null } | null, address?: { __typename?: 'Address', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, addressType?: AddressType | null, city?: string | null, country?: string | null, municipality?: string | null, postalCode?: string | null, state?: string | null } | null } | null, marketing?: { __typename?: 'Marketing', salesChannel?: string | null, referralPartner?: string | null, referrerCode?: string | null, salesSessionId?: string | null, vendorData?: any | null, dealerCode?: string | null, salesPersonId?: string | null, storeCode?: string | null, promoCode?: string | null, utmParams?: { __typename?: 'UtmParams', utmCampaign?: string | null, utmContent?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, extensions: Array<{ __typename?: 'Extension', value: any, code: ExtensionCode }>, externalSession?: { __typename?: 'ExternalSession', id: string } | null, outboundCalls: Array<{ __typename?: 'AsurionCall', id: string, flexReservation?: { __typename?: 'FlexReservation', id: string } | null }> } } };

export type UpdateCustomerSessionsMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  externalSessionId?: InputMaybe<Scalars['ID']['input']>;
  expertId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<SessionStatus>;
  includeCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  includeMarketing?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateCustomerSessionsMutation = { __typename?: 'Mutation', updateCustomerSessions: { __typename?: 'BaseError', message: string } | { __typename?: 'NotFoundError', message: string } | { __typename?: 'UpdateCustomerSessionsSuccessPayload', customerSessions: Array<{ __typename?: 'CustomerSession', id: string, status: SessionStatus, partner: string, createdAt?: string | null, channel?: string | null, cohortTag?: string | null, language?: string | null, direction?: CallDirection | null, expertSessions: Array<{ __typename?: 'ExpertSession', id: string }>, asurionCall?: { __typename?: 'AsurionCall', id: string, flexReservation?: { __typename?: 'FlexReservation', id: string } | null } | null, billing?: { __typename?: 'Billing', id: string, address: { __typename?: 'Address', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, addressType?: AddressType | null, city?: string | null, country?: string | null, municipality?: string | null, postalCode?: string | null, state?: string | null } } | null, externalClientAccount?: { __typename?: 'ExternalClientAccount', id: string } | null, horizonSession?: { __typename?: 'HorizonSession', id: string } | null, customer?: { __typename?: 'Customer', id: string, asurionId?: string | null, mdn?: any | null, email?: string | null, firstName?: string | null, lastName?: string | null, socialName?: string | null, accountNumber?: string | null, asset?: { __typename?: 'Asset', assetCatalogId?: string | null, imageUrl?: string | null, make?: string | null, model?: string | null, name?: string | null } | null, address?: { __typename?: 'Address', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, addressType?: AddressType | null, city?: string | null, country?: string | null, municipality?: string | null, postalCode?: string | null, state?: string | null } | null } | null, marketing?: { __typename?: 'Marketing', salesChannel?: string | null, referralPartner?: string | null, referrerCode?: string | null, salesSessionId?: string | null, vendorData?: any | null, dealerCode?: string | null, salesPersonId?: string | null, storeCode?: string | null, promoCode?: string | null, utmParams?: { __typename?: 'UtmParams', utmCampaign?: string | null, utmContent?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, extensions: Array<{ __typename?: 'Extension', value: any, code: ExtensionCode }>, externalSession?: { __typename?: 'ExternalSession', id: string } | null, outboundCalls: Array<{ __typename?: 'AsurionCall', id: string, flexReservation?: { __typename?: 'FlexReservation', id: string } | null }> }> } };

export type UpdateCustomerMutationVariables = Exact<{
  customerSessionId: Scalars['ID']['input'];
  address?: InputMaybe<AddressInput>;
  asurionId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['PiiString']['input']>;
  firstName?: InputMaybe<Scalars['PiiString']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['PiiString']['input']>;
  mdn?: InputMaybe<Scalars['PiiPhoneNumber']['input']>;
  asset?: InputMaybe<AssetInput>;
}>;


export type UpdateCustomerMutation = { __typename?: 'Mutation', updateCustomer: { __typename?: 'BaseError', message: string } | { __typename?: 'NotFoundError', message: string } | { __typename?: 'UpdateCustomerSuccessPayload', customer: { __typename?: 'Customer', id: string, asurionId?: string | null, mdn?: any | null, email?: string | null, firstName?: string | null, lastName?: string | null, socialName?: string | null, accountNumber?: string | null, asset?: { __typename?: 'Asset', assetCatalogId?: string | null, imageUrl?: string | null, make?: string | null, model?: string | null, name?: string | null } | null, address?: { __typename?: 'Address', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, addressType?: AddressType | null, city?: string | null, country?: string | null, municipality?: string | null, postalCode?: string | null, state?: string | null } | null } } };

export type UpdateMdnVerificationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  customerSessionId: Scalars['ID']['input'];
  status?: InputMaybe<MdnVerificationStatus>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
  expiration?: InputMaybe<Scalars['DateTime']['input']>;
  attemptsRemaining?: InputMaybe<Scalars['Int']['input']>;
  accessToken?: InputMaybe<Scalars['PiiString']['input']>;
  refreshToken?: InputMaybe<Scalars['PiiString']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateMdnVerificationMutation = { __typename?: 'Mutation', updateMdnVerification: { __typename?: 'BaseError', message: string } | { __typename?: 'NotFoundError', message: string } | { __typename?: 'UpdateMdnVerificationSuccessPayload', mdnVerification: { __typename?: 'MdnVerification', id: string, status: MdnVerificationStatus, transactionId?: string | null, expiration?: any | null, attemptsRemaining?: number | null, accessToken?: string | null, refreshToken?: string | null } } };

export type UpdatePaySessionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  customerSessionId: Scalars['ID']['input'];
  status?: InputMaybe<PaySessionStatus>;
  billingGatewaySessionId?: InputMaybe<Scalars['String']['input']>;
  billingToken?: InputMaybe<Scalars['String']['input']>;
  paymentLink?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<PaymentType>;
  payMethodId?: InputMaybe<Scalars['String']['input']>;
  encryptionKey?: InputMaybe<Scalars['String']['input']>;
  billingFrequencyInMonths?: InputMaybe<Scalars['String']['input']>;
  productPaidFrequency?: InputMaybe<Scalars['String']['input']>;
  lastFour?: InputMaybe<Scalars['PiiString']['input']>;
  brand?: InputMaybe<Scalars['PiiString']['input']>;
  expirationMonth?: InputMaybe<Scalars['PiiString']['input']>;
  expirationYear?: InputMaybe<Scalars['PiiString']['input']>;
}>;


export type UpdatePaySessionMutation = { __typename?: 'Mutation', updatePaySession: { __typename?: 'BaseError', message: string } | { __typename?: 'NotFoundError', message: string } | { __typename?: 'UpdatePaySessionSuccessPayload', paySession: { __typename?: 'PaySession', id: string, billingGatewaySessionId?: string | null, billingToken?: string | null, encryptionKey?: string | null, paymentLink?: string | null, paymentType?: PaymentType | null, payMethodId?: string | null, productSku: string, status: PaySessionStatus, transactionType: TransactionType, lastFour?: string | null, brand?: string | null, expirationMonth?: string | null, expirationYear?: string | null, billingFrequencyInMonths?: string | null, productPaidFrequency?: string | null } } };

export type CustomerSessionExpertSessionsQueryVariables = Exact<{
  customerSessionId: Scalars['ID']['input'];
  includeExpert?: Scalars['Boolean']['input'];
}>;


export type CustomerSessionExpertSessionsQuery = { __typename?: 'Query', customerSession?: { __typename?: 'CustomerSession', expertSessions: Array<{ __typename?: 'ExpertSession', id: string, hostApp?: string | null, supportedSkus: Array<string>, expert?: { __typename?: 'Expert', id: string, email: string, name: string, lob?: string | null, username?: string | null, manager?: string | null, managerId?: string | null, site?: string | null, supervisor?: string | null, supervisorId?: string | null, businessUnit?: string | null } }> } | null };

export type CustomerSessionQueryVariables = Exact<{
  customerSessionId: Scalars['ID']['input'];
  includeCustomer?: Scalars['Boolean']['input'];
  includeMarketing?: Scalars['Boolean']['input'];
}>;


export type CustomerSessionQuery = { __typename?: 'Query', customerSession?: { __typename?: 'CustomerSession', id: string, status: SessionStatus, partner: string, createdAt?: string | null, channel?: string | null, cohortTag?: string | null, language?: string | null, direction?: CallDirection | null, expertSessions: Array<{ __typename?: 'ExpertSession', id: string }>, asurionCall?: { __typename?: 'AsurionCall', id: string, flexReservation?: { __typename?: 'FlexReservation', id: string } | null } | null, billing?: { __typename?: 'Billing', id: string, address: { __typename?: 'Address', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, addressType?: AddressType | null, city?: string | null, country?: string | null, municipality?: string | null, postalCode?: string | null, state?: string | null } } | null, externalClientAccount?: { __typename?: 'ExternalClientAccount', id: string } | null, horizonSession?: { __typename?: 'HorizonSession', id: string } | null, customer?: { __typename?: 'Customer', id: string, asurionId?: string | null, mdn?: any | null, email?: string | null, firstName?: string | null, lastName?: string | null, socialName?: string | null, accountNumber?: string | null, asset?: { __typename?: 'Asset', assetCatalogId?: string | null, imageUrl?: string | null, make?: string | null, model?: string | null, name?: string | null } | null, address?: { __typename?: 'Address', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, addressType?: AddressType | null, city?: string | null, country?: string | null, municipality?: string | null, postalCode?: string | null, state?: string | null } | null } | null, marketing?: { __typename?: 'Marketing', salesChannel?: string | null, referralPartner?: string | null, referrerCode?: string | null, salesSessionId?: string | null, vendorData?: any | null, dealerCode?: string | null, salesPersonId?: string | null, storeCode?: string | null, promoCode?: string | null, utmParams?: { __typename?: 'UtmParams', utmCampaign?: string | null, utmContent?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, extensions: Array<{ __typename?: 'Extension', value: any, code: ExtensionCode }>, externalSession?: { __typename?: 'ExternalSession', id: string } | null, outboundCalls: Array<{ __typename?: 'AsurionCall', id: string, flexReservation?: { __typename?: 'FlexReservation', id: string } | null }> } | null };

export type CustomerSessionsByMdnQueryVariables = Exact<{
  mdn: Scalars['PiiPhoneNumber']['input'];
  partner?: InputMaybe<Scalars['String']['input']>;
  includeCustomer?: Scalars['Boolean']['input'];
  includeMarketing?: Scalars['Boolean']['input'];
}>;


export type CustomerSessionsByMdnQuery = { __typename?: 'Query', customerSessions: Array<{ __typename?: 'CustomerSession', id: string, status: SessionStatus, partner: string, createdAt?: string | null, channel?: string | null, cohortTag?: string | null, language?: string | null, direction?: CallDirection | null, expertSessions: Array<{ __typename?: 'ExpertSession', id: string }>, asurionCall?: { __typename?: 'AsurionCall', id: string, flexReservation?: { __typename?: 'FlexReservation', id: string } | null } | null, billing?: { __typename?: 'Billing', id: string, address: { __typename?: 'Address', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, addressType?: AddressType | null, city?: string | null, country?: string | null, municipality?: string | null, postalCode?: string | null, state?: string | null } } | null, externalClientAccount?: { __typename?: 'ExternalClientAccount', id: string } | null, horizonSession?: { __typename?: 'HorizonSession', id: string } | null, customer?: { __typename?: 'Customer', id: string, asurionId?: string | null, mdn?: any | null, email?: string | null, firstName?: string | null, lastName?: string | null, socialName?: string | null, accountNumber?: string | null, asset?: { __typename?: 'Asset', assetCatalogId?: string | null, imageUrl?: string | null, make?: string | null, model?: string | null, name?: string | null } | null, address?: { __typename?: 'Address', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, addressType?: AddressType | null, city?: string | null, country?: string | null, municipality?: string | null, postalCode?: string | null, state?: string | null } | null } | null, marketing?: { __typename?: 'Marketing', salesChannel?: string | null, referralPartner?: string | null, referrerCode?: string | null, salesSessionId?: string | null, vendorData?: any | null, dealerCode?: string | null, salesPersonId?: string | null, storeCode?: string | null, promoCode?: string | null, utmParams?: { __typename?: 'UtmParams', utmCampaign?: string | null, utmContent?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, extensions: Array<{ __typename?: 'Extension', value: any, code: ExtensionCode }>, externalSession?: { __typename?: 'ExternalSession', id: string } | null, outboundCalls: Array<{ __typename?: 'AsurionCall', id: string, flexReservation?: { __typename?: 'FlexReservation', id: string } | null }> }> };

export type CustomerQueryVariables = Exact<{
  customerSessionId: Scalars['ID']['input'];
}>;


export type CustomerQuery = { __typename?: 'Query', customerSession?: { __typename?: 'CustomerSession', customer?: { __typename?: 'Customer', id: string, asurionId?: string | null, mdn?: any | null, email?: string | null, firstName?: string | null, lastName?: string | null, socialName?: string | null, accountNumber?: string | null, asset?: { __typename?: 'Asset', assetCatalogId?: string | null, imageUrl?: string | null, make?: string | null, model?: string | null, name?: string | null } | null, address?: { __typename?: 'Address', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, addressType?: AddressType | null, city?: string | null, country?: string | null, municipality?: string | null, postalCode?: string | null, state?: string | null } | null } | null } | null };

export type MdnVerificationQueryVariables = Exact<{
  customerSessionId: Scalars['ID']['input'];
  mdnVerificationId: Scalars['ID']['input'];
}>;


export type MdnVerificationQuery = { __typename?: 'Query', customerSession?: { __typename?: 'CustomerSession', mdnVerification?: { __typename?: 'MdnVerification', id: string, status: MdnVerificationStatus, transactionId?: string | null, expiration?: any | null, attemptsRemaining?: number | null, accessToken?: string | null, refreshToken?: string | null } | null } | null };

export type PaySessionQueryVariables = Exact<{
  customerSessionId: Scalars['ID']['input'];
  paySessionId: Scalars['ID']['input'];
}>;


export type PaySessionQuery = { __typename?: 'Query', customerSession?: { __typename?: 'CustomerSession', paySession?: { __typename?: 'PaySession', id: string, billingGatewaySessionId?: string | null, billingToken?: string | null, encryptionKey?: string | null, paymentLink?: string | null, paymentType?: PaymentType | null, payMethodId?: string | null, productSku: string, status: PaySessionStatus, transactionType: TransactionType, lastFour?: string | null, brand?: string | null, expirationMonth?: string | null, expirationYear?: string | null, billingFrequencyInMonths?: string | null, productPaidFrequency?: string | null } | null } | null };

export type CustomerSessionCreatedSubscriptionVariables = Exact<{
  expertSessionId: Scalars['ID']['input'];
  customerSessionId?: InputMaybe<Scalars['ID']['input']>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  includeCustomer?: Scalars['Boolean']['input'];
  includeMarketing?: Scalars['Boolean']['input'];
}>;


export type CustomerSessionCreatedSubscription = { __typename?: 'Subscription', customerSessionCreated: { __typename?: 'CustomerSession', id: string, status: SessionStatus, partner: string, createdAt?: string | null, channel?: string | null, cohortTag?: string | null, language?: string | null, direction?: CallDirection | null, expertSessions: Array<{ __typename?: 'ExpertSession', id: string }>, asurionCall?: { __typename?: 'AsurionCall', id: string, flexReservation?: { __typename?: 'FlexReservation', id: string } | null } | null, billing?: { __typename?: 'Billing', id: string, address: { __typename?: 'Address', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, addressType?: AddressType | null, city?: string | null, country?: string | null, municipality?: string | null, postalCode?: string | null, state?: string | null } } | null, externalClientAccount?: { __typename?: 'ExternalClientAccount', id: string } | null, horizonSession?: { __typename?: 'HorizonSession', id: string } | null, customer?: { __typename?: 'Customer', id: string, asurionId?: string | null, mdn?: any | null, email?: string | null, firstName?: string | null, lastName?: string | null, socialName?: string | null, accountNumber?: string | null, asset?: { __typename?: 'Asset', assetCatalogId?: string | null, imageUrl?: string | null, make?: string | null, model?: string | null, name?: string | null } | null, address?: { __typename?: 'Address', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, addressType?: AddressType | null, city?: string | null, country?: string | null, municipality?: string | null, postalCode?: string | null, state?: string | null } | null } | null, marketing?: { __typename?: 'Marketing', salesChannel?: string | null, referralPartner?: string | null, referrerCode?: string | null, salesSessionId?: string | null, vendorData?: any | null, dealerCode?: string | null, salesPersonId?: string | null, storeCode?: string | null, promoCode?: string | null, utmParams?: { __typename?: 'UtmParams', utmCampaign?: string | null, utmContent?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, extensions: Array<{ __typename?: 'Extension', value: any, code: ExtensionCode }>, externalSession?: { __typename?: 'ExternalSession', id: string } | null, outboundCalls: Array<{ __typename?: 'AsurionCall', id: string, flexReservation?: { __typename?: 'FlexReservation', id: string } | null }> } };

export type MdnVerificationUpdatedSubscriptionVariables = Exact<{
  mdnVerificationId: Scalars['ID']['input'];
  customerSessionId?: InputMaybe<Scalars['ID']['input']>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type MdnVerificationUpdatedSubscription = { __typename?: 'Subscription', mdnVerificationUpdated: { __typename?: 'MdnVerification', id: string, status: MdnVerificationStatus, transactionId?: string | null, expiration?: any | null, attemptsRemaining?: number | null, accessToken?: string | null, refreshToken?: string | null } };

export type PaySessionUpdatedSubscriptionVariables = Exact<{
  paySessionId: Scalars['ID']['input'];
  customerSessionId?: InputMaybe<Scalars['ID']['input']>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type PaySessionUpdatedSubscription = { __typename?: 'Subscription', paySessionUpdated: { __typename?: 'PaySession', id: string, billingGatewaySessionId?: string | null, billingToken?: string | null, encryptionKey?: string | null, paymentLink?: string | null, paymentType?: PaymentType | null, payMethodId?: string | null, productSku: string, status: PaySessionStatus, transactionType: TransactionType, lastFour?: string | null, brand?: string | null, expirationMonth?: string | null, expirationYear?: string | null, billingFrequencyInMonths?: string | null, productPaidFrequency?: string | null } };

export type BaseErrorFragment = { __typename?: 'BaseError', message: string };

export type DuplicateErrorFragment = { __typename?: 'BaseError', message: string };

export type NotFoundErrorFragment = { __typename?: 'NotFoundError', message: string };

export type ExpertSessionFragment = { __typename?: 'ExpertSession', id: string, hostApp?: string | null, supportedSkus: Array<string>, expert?: { __typename?: 'Expert', id: string, email: string, name: string, lob?: string | null, username?: string | null, manager?: string | null, managerId?: string | null, site?: string | null, supervisor?: string | null, supervisorId?: string | null, businessUnit?: string | null } };

export type ExpertFragment = { __typename?: 'Expert', id: string, email: string, name: string, lob?: string | null, username?: string | null, manager?: string | null, managerId?: string | null, site?: string | null, supervisor?: string | null, supervisorId?: string | null, businessUnit?: string | null };

export type CreateExpertSessionMutationVariables = Exact<{
  expert: CreateExpertInput;
  includeExpert?: Scalars['Boolean']['input'];
  supportedSkus?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CreateExpertSessionMutation = { __typename?: 'Mutation', createExpertSession: { __typename?: 'BaseError', message: string } | { __typename?: 'CreateExpertSessionSuccessPayload', expertSession: { __typename?: 'ExpertSession', id: string, hostApp?: string | null, supportedSkus: Array<string>, expert?: { __typename?: 'Expert', id: string, email: string, name: string, lob?: string | null, username?: string | null, manager?: string | null, managerId?: string | null, site?: string | null, supervisor?: string | null, supervisorId?: string | null, businessUnit?: string | null } } } };

export type UpdateExpertOrgChartDataMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  expertSessionId: Scalars['ID']['input'];
  lob?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateExpertOrgChartDataMutation = { __typename?: 'Mutation', updateExpertOrgChartData: { __typename: 'BaseError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UpdateExpertOrgChartDataSuccessPayload', expertSession: { __typename?: 'ExpertSession', id: string, expert: { __typename?: 'Expert', id: string, lob?: string | null, businessUnit?: string | null, site?: string | null, supervisor?: string | null, supervisorId?: string | null, manager?: string | null, managerId?: string | null } } } };

export type UpdateExpertSessionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  hostApp?: InputMaybe<Scalars['String']['input']>;
  includeExpert?: Scalars['Boolean']['input'];
}>;


export type UpdateExpertSessionMutation = { __typename?: 'Mutation', updateExpertSession?: { __typename?: 'BaseError', message: string } | { __typename?: 'NotFoundError' } | { __typename?: 'UpdateExpertSessionSuccessPayload', expertSession: { __typename?: 'ExpertSession', id: string, hostApp?: string | null, supportedSkus: Array<string>, expert?: { __typename?: 'Expert', id: string, email: string, name: string, lob?: string | null, username?: string | null, manager?: string | null, managerId?: string | null, site?: string | null, supervisor?: string | null, supervisorId?: string | null, businessUnit?: string | null } } } | null };

export type ExpertSessionQueryVariables = Exact<{
  expertSessionId: Scalars['ID']['input'];
  includeExpert?: Scalars['Boolean']['input'];
}>;


export type ExpertSessionQuery = { __typename?: 'Query', expertSession?: { __typename?: 'ExpertSession', id: string, hostApp?: string | null, supportedSkus: Array<string>, expert?: { __typename?: 'Expert', id: string, email: string, name: string, lob?: string | null, username?: string | null, manager?: string | null, managerId?: string | null, site?: string | null, supervisor?: string | null, supervisorId?: string | null, businessUnit?: string | null } } | null };

export type ExpertSessionsQueryVariables = Exact<{
  username: Scalars['String']['input'];
  first: Scalars['Int']['input'];
  since?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  includeExpert?: Scalars['Boolean']['input'];
}>;


export type ExpertSessionsQuery = { __typename?: 'Query', expertSessions: { __typename?: 'ExpertSessionsConnection', edges: Array<{ __typename?: 'ExpertSessionsEdge', node: { __typename?: 'ExpertSession', id: string, hostApp?: string | null, supportedSkus: Array<string>, expert?: { __typename?: 'Expert', id: string, email: string, name: string, lob?: string | null, username?: string | null, manager?: string | null, managerId?: string | null, site?: string | null, supervisor?: string | null, supervisorId?: string | null, businessUnit?: string | null } } }> } };

export type ExpertQueryVariables = Exact<{
  expertSessionId: Scalars['ID']['input'];
}>;


export type ExpertQuery = { __typename?: 'Query', expertSession?: { __typename?: 'ExpertSession', expert: { __typename?: 'Expert', id: string, email: string, name: string, lob?: string | null, username?: string | null, manager?: string | null, managerId?: string | null, site?: string | null, supervisor?: string | null, supervisorId?: string | null, businessUnit?: string | null } } | null };

export type BillingDiscountFragment = { __typename?: 'BillingDiscount', id: string, discountName?: string | null, discountType?: DiscountType | null, discountDescription?: string | null, programId?: string | null, discountActionType?: DiscountActionType | null, discountValue?: number | null, redemptionType?: RedemptionType | null, redemptionLimit?: number | null, status?: DiscountStatus | null, validityStart?: any | null, validityEnd?: any | null, discountCodeId?: string | null };

export type ProductDeclinationFragment = { __typename?: 'ProductDeclination', id: string, reason?: string | null };

export type ProductEligibilityFragment = { __typename?: 'ProductEligibility', id: string, status: ProductEligibilityStatus, externalEligibilityId?: string | null, subscriptionNumber?: string | null, reason?: string | null };

export type ProductEnrollmentErrorFragment = { __typename?: 'ProductEnrollmentError', category: ProductEnrollmentErrorCategory, code?: string | null, message?: string | null };

export type ProductEnrollmentFragment = { __typename?: 'ProductEnrollment', id: string, status: ProductEnrollmentStatus, planId?: string | null, lastModified?: any | null, confirmationCode?: string | null, additionalData?: any | null, error?: { __typename?: 'ProductEnrollmentError', category: ProductEnrollmentErrorCategory, code?: string | null, message?: string | null } | null };

export type ProductOfferFragment = { __typename?: 'ProductOffer', id: string, productSku: string, customerMdn?: any | null, status: ProductOfferStatus, partner: string, disclosureStatus?: TransmittedDisclosureStatus | null, expertSession?: { __typename?: 'ExpertSession', id: string } | null, customerSession: { __typename?: 'CustomerSession', id: string }, productEligibility?: { __typename?: 'ProductEligibility', id: string, status: ProductEligibilityStatus, externalEligibilityId?: string | null, subscriptionNumber?: string | null, reason?: string | null } | null, productEnrollment?: { __typename?: 'ProductEnrollment', id: string, status: ProductEnrollmentStatus, planId?: string | null, lastModified?: any | null, confirmationCode?: string | null, additionalData?: any | null, error?: { __typename?: 'ProductEnrollmentError', category: ProductEnrollmentErrorCategory, code?: string | null, message?: string | null } | null } | null, productDeclination?: { __typename?: 'ProductDeclination', id: string, reason?: string | null } | null, billingDiscounts?: Array<{ __typename?: 'BillingDiscount', id: string, discountName?: string | null, discountType?: DiscountType | null, discountDescription?: string | null, programId?: string | null, discountActionType?: DiscountActionType | null, discountValue?: number | null, redemptionType?: RedemptionType | null, redemptionLimit?: number | null, status?: DiscountStatus | null, validityStart?: any | null, validityEnd?: any | null, discountCodeId?: string | null }> };

export type CreateBillingDiscountsMutationVariables = Exact<{
  productOfferId: Scalars['ID']['input'];
  billingDiscounts: Array<CreateBillingDiscountInput> | CreateBillingDiscountInput;
}>;


export type CreateBillingDiscountsMutation = { __typename?: 'Mutation', createBillingDiscounts: { __typename?: 'BaseError', message: string } | { __typename?: 'CreateBillingDiscountsSuccessPayload', billingDiscounts?: Array<{ __typename?: 'BillingDiscount', id: string, discountName?: string | null, discountType?: DiscountType | null, discountDescription?: string | null, programId?: string | null, discountActionType?: DiscountActionType | null, discountValue?: number | null, redemptionType?: RedemptionType | null, redemptionLimit?: number | null, status?: DiscountStatus | null, validityStart?: any | null, validityEnd?: any | null, discountCodeId?: string | null } | null> | null } | { __typename?: 'NotFoundError', message: string } };

export type CreateProductDeclinationMutationVariables = Exact<{
  productOfferId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateProductDeclinationMutation = { __typename?: 'Mutation', createProductDeclination: { __typename?: 'BaseError', message: string } | { __typename?: 'CreateProductDeclinationSuccessPayload', productDeclination: { __typename?: 'ProductDeclination', id: string, reason?: string | null } } | { __typename?: 'NotFoundError', message: string } };

export type CreateProductEnrollmentMutationVariables = Exact<{
  productOfferId: Scalars['ID']['input'];
  status?: InputMaybe<ProductEnrollmentStatus>;
  paySessionId?: InputMaybe<Scalars['ID']['input']>;
  confirmationCode?: InputMaybe<Scalars['String']['input']>;
  externalReferenceId?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateProductEnrollmentMutation = { __typename?: 'Mutation', createProductEnrollment: { __typename?: 'BaseError', message: string } | { __typename?: 'CreateProductEnrollmentSuccessPayload', productEnrollment: { __typename?: 'ProductEnrollment', id: string, status: ProductEnrollmentStatus, planId?: string | null, lastModified?: any | null, confirmationCode?: string | null, additionalData?: any | null, error?: { __typename?: 'ProductEnrollmentError', category: ProductEnrollmentErrorCategory, code?: string | null, message?: string | null } | null } } | { __typename?: 'NotFoundError', message: string } };

export type CreateProductOfferMutationVariables = Exact<{
  customerMdn?: InputMaybe<Scalars['PiiPhoneNumber']['input']>;
  productSku: Scalars['String']['input'];
  customerSessionId: Scalars['ID']['input'];
  partner: Scalars['String']['input'];
  expertSessionId?: InputMaybe<Scalars['ID']['input']>;
  includeProductEligibility?: Scalars['Boolean']['input'];
  includeProductEnrollment?: Scalars['Boolean']['input'];
  includeProductDeclination?: Scalars['Boolean']['input'];
  includeBillingDiscounts?: Scalars['Boolean']['input'];
  productEligibilityStatus?: InputMaybe<ProductEligibilityStatus>;
}>;


export type CreateProductOfferMutation = { __typename?: 'Mutation', createProductOffer: { __typename?: 'BaseError', message: string } | { __typename?: 'CreateProductOfferSuccessPayload', productOffer: { __typename?: 'ProductOffer', id: string, productSku: string, customerMdn?: any | null, status: ProductOfferStatus, partner: string, disclosureStatus?: TransmittedDisclosureStatus | null, expertSession?: { __typename?: 'ExpertSession', id: string } | null, customerSession: { __typename?: 'CustomerSession', id: string }, productEligibility?: { __typename?: 'ProductEligibility', id: string, status: ProductEligibilityStatus, externalEligibilityId?: string | null, subscriptionNumber?: string | null, reason?: string | null } | null, productEnrollment?: { __typename?: 'ProductEnrollment', id: string, status: ProductEnrollmentStatus, planId?: string | null, lastModified?: any | null, confirmationCode?: string | null, additionalData?: any | null, error?: { __typename?: 'ProductEnrollmentError', category: ProductEnrollmentErrorCategory, code?: string | null, message?: string | null } | null } | null, productDeclination?: { __typename?: 'ProductDeclination', id: string, reason?: string | null } | null, billingDiscounts?: Array<{ __typename?: 'BillingDiscount', id: string, discountName?: string | null, discountType?: DiscountType | null, discountDescription?: string | null, programId?: string | null, discountActionType?: DiscountActionType | null, discountValue?: number | null, redemptionType?: RedemptionType | null, redemptionLimit?: number | null, status?: DiscountStatus | null, validityStart?: any | null, validityEnd?: any | null, discountCodeId?: string | null }> } } };

export type DeleteProductOfferMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProductOfferMutation = { __typename?: 'Mutation', deleteProductOffer: { __typename?: 'BaseError', message: string } | { __typename?: 'DeleteProductOfferSuccessPayload' } | { __typename?: 'NotFoundError', message: string } };

export type UpdateProductEligibilityMutationVariables = Exact<{
  productEligibilityId: Scalars['ID']['input'];
  productOfferId: Scalars['ID']['input'];
  externalEligibilityId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProductEligibilityStatus>;
  subscriptionNumber?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateProductEligibilityMutation = { __typename?: 'Mutation', updateProductEligibility: { __typename?: 'BaseError', message: string } | { __typename?: 'NotFoundError', message: string } | { __typename?: 'UpdateProductEligibilitySuccessPayload', productEligibility: { __typename?: 'ProductEligibility', id: string, status: ProductEligibilityStatus, externalEligibilityId?: string | null, subscriptionNumber?: string | null, reason?: string | null } } };

export type UpdateProductEnrollmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  productOfferId: Scalars['ID']['input'];
  status: ProductEnrollmentStatus;
  planId?: InputMaybe<Scalars['ID']['input']>;
  error?: InputMaybe<ProductEnrollmentErrorInput>;
  externalReferenceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateProductEnrollmentMutation = { __typename?: 'Mutation', updateProductEnrollment: { __typename?: 'BaseError', message: string } | { __typename?: 'NotFoundError', message: string } | { __typename?: 'UpdateProductEnrollmentSuccessPayload', productEnrollment: { __typename?: 'ProductEnrollment', id: string, status: ProductEnrollmentStatus, planId?: string | null, lastModified?: any | null, confirmationCode?: string | null, additionalData?: any | null, error?: { __typename?: 'ProductEnrollmentError', category: ProductEnrollmentErrorCategory, code?: string | null, message?: string | null } | null } } };

export type UpdateProductOfferMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  disclosureStatus?: InputMaybe<TransmittedDisclosureStatus>;
  linkId?: InputMaybe<Scalars['String']['input']>;
  includeProductEligibility?: Scalars['Boolean']['input'];
  includeProductEnrollment?: Scalars['Boolean']['input'];
  includeProductDeclination?: Scalars['Boolean']['input'];
  includeBillingDiscounts?: Scalars['Boolean']['input'];
}>;


export type UpdateProductOfferMutation = { __typename?: 'Mutation', updateProductOffer: { __typename?: 'BaseError', message: string } | { __typename?: 'NotFoundError', message: string } | { __typename?: 'UpdateProductOfferSuccessPayload', productOffer: { __typename?: 'ProductOffer', id: string, productSku: string, customerMdn?: any | null, status: ProductOfferStatus, partner: string, disclosureStatus?: TransmittedDisclosureStatus | null, expertSession?: { __typename?: 'ExpertSession', id: string } | null, customerSession: { __typename?: 'CustomerSession', id: string }, productEligibility?: { __typename?: 'ProductEligibility', id: string, status: ProductEligibilityStatus, externalEligibilityId?: string | null, subscriptionNumber?: string | null, reason?: string | null } | null, productEnrollment?: { __typename?: 'ProductEnrollment', id: string, status: ProductEnrollmentStatus, planId?: string | null, lastModified?: any | null, confirmationCode?: string | null, additionalData?: any | null, error?: { __typename?: 'ProductEnrollmentError', category: ProductEnrollmentErrorCategory, code?: string | null, message?: string | null } | null } | null, productDeclination?: { __typename?: 'ProductDeclination', id: string, reason?: string | null } | null, billingDiscounts?: Array<{ __typename?: 'BillingDiscount', id: string, discountName?: string | null, discountType?: DiscountType | null, discountDescription?: string | null, programId?: string | null, discountActionType?: DiscountActionType | null, discountValue?: number | null, redemptionType?: RedemptionType | null, redemptionLimit?: number | null, status?: DiscountStatus | null, validityStart?: any | null, validityEnd?: any | null, discountCodeId?: string | null }> } } };

export type ProductEligibilityQueryVariables = Exact<{
  productOfferId: Scalars['ID']['input'];
}>;


export type ProductEligibilityQuery = { __typename?: 'Query', productOffer?: { __typename?: 'ProductOffer', productEligibility?: { __typename?: 'ProductEligibility', id: string, status: ProductEligibilityStatus, externalEligibilityId?: string | null, subscriptionNumber?: string | null, reason?: string | null } | null } | null };

export type ProductEnrollmentQueryVariables = Exact<{
  productOfferId: Scalars['ID']['input'];
}>;


export type ProductEnrollmentQuery = { __typename?: 'Query', productOffer?: { __typename?: 'ProductOffer', productEnrollment?: { __typename?: 'ProductEnrollment', id: string, status: ProductEnrollmentStatus, planId?: string | null, lastModified?: any | null, confirmationCode?: string | null, additionalData?: any | null, error?: { __typename?: 'ProductEnrollmentError', category: ProductEnrollmentErrorCategory, code?: string | null, message?: string | null } | null } | null } | null };

export type ProductOfferCustomerSessionQueryVariables = Exact<{
  productOfferId: Scalars['ID']['input'];
  includeCustomer?: Scalars['Boolean']['input'];
  includeMarketing?: Scalars['Boolean']['input'];
}>;


export type ProductOfferCustomerSessionQuery = { __typename?: 'Query', productOffer?: { __typename?: 'ProductOffer', customerSession: { __typename?: 'CustomerSession', id: string, status: SessionStatus, partner: string, createdAt?: string | null, channel?: string | null, cohortTag?: string | null, language?: string | null, direction?: CallDirection | null, expertSessions: Array<{ __typename?: 'ExpertSession', id: string }>, asurionCall?: { __typename?: 'AsurionCall', id: string, flexReservation?: { __typename?: 'FlexReservation', id: string } | null } | null, billing?: { __typename?: 'Billing', id: string, address: { __typename?: 'Address', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, addressType?: AddressType | null, city?: string | null, country?: string | null, municipality?: string | null, postalCode?: string | null, state?: string | null } } | null, externalClientAccount?: { __typename?: 'ExternalClientAccount', id: string } | null, horizonSession?: { __typename?: 'HorizonSession', id: string } | null, customer?: { __typename?: 'Customer', id: string, asurionId?: string | null, mdn?: any | null, email?: string | null, firstName?: string | null, lastName?: string | null, socialName?: string | null, accountNumber?: string | null, asset?: { __typename?: 'Asset', assetCatalogId?: string | null, imageUrl?: string | null, make?: string | null, model?: string | null, name?: string | null } | null, address?: { __typename?: 'Address', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, addressType?: AddressType | null, city?: string | null, country?: string | null, municipality?: string | null, postalCode?: string | null, state?: string | null } | null } | null, marketing?: { __typename?: 'Marketing', salesChannel?: string | null, referralPartner?: string | null, referrerCode?: string | null, salesSessionId?: string | null, vendorData?: any | null, dealerCode?: string | null, salesPersonId?: string | null, storeCode?: string | null, promoCode?: string | null, utmParams?: { __typename?: 'UtmParams', utmCampaign?: string | null, utmContent?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, extensions: Array<{ __typename?: 'Extension', value: any, code: ExtensionCode }>, externalSession?: { __typename?: 'ExternalSession', id: string } | null, outboundCalls: Array<{ __typename?: 'AsurionCall', id: string, flexReservation?: { __typename?: 'FlexReservation', id: string } | null }> } } | null };

export type ProductOfferTaxAmountQueryVariables = Exact<{
  productOfferId: Scalars['ID']['input'];
  invoiceAmount: Scalars['String']['input'];
  shipToAddress: AddressInput;
}>;


export type ProductOfferTaxAmountQuery = { __typename?: 'Query', productOffer?: { __typename?: 'ProductOffer', taxAmount?: string | null } | null };

export type ProductOfferQueryVariables = Exact<{
  productOfferId: Scalars['ID']['input'];
  includeProductEligibility?: Scalars['Boolean']['input'];
  includeProductEnrollment?: Scalars['Boolean']['input'];
  includeProductDeclination?: Scalars['Boolean']['input'];
  includeBillingDiscounts?: Scalars['Boolean']['input'];
}>;


export type ProductOfferQuery = { __typename?: 'Query', productOffer?: { __typename?: 'ProductOffer', id: string, productSku: string, customerMdn?: any | null, status: ProductOfferStatus, partner: string, disclosureStatus?: TransmittedDisclosureStatus | null, expertSession?: { __typename?: 'ExpertSession', id: string } | null, customerSession: { __typename?: 'CustomerSession', id: string }, productEligibility?: { __typename?: 'ProductEligibility', id: string, status: ProductEligibilityStatus, externalEligibilityId?: string | null, subscriptionNumber?: string | null, reason?: string | null } | null, productEnrollment?: { __typename?: 'ProductEnrollment', id: string, status: ProductEnrollmentStatus, planId?: string | null, lastModified?: any | null, confirmationCode?: string | null, additionalData?: any | null, error?: { __typename?: 'ProductEnrollmentError', category: ProductEnrollmentErrorCategory, code?: string | null, message?: string | null } | null } | null, productDeclination?: { __typename?: 'ProductDeclination', id: string, reason?: string | null } | null, billingDiscounts?: Array<{ __typename?: 'BillingDiscount', id: string, discountName?: string | null, discountType?: DiscountType | null, discountDescription?: string | null, programId?: string | null, discountActionType?: DiscountActionType | null, discountValue?: number | null, redemptionType?: RedemptionType | null, redemptionLimit?: number | null, status?: DiscountStatus | null, validityStart?: any | null, validityEnd?: any | null, discountCodeId?: string | null }> } | null };

export type ProductOffersByCustomerSessionIdQueryVariables = Exact<{
  customerSessionId: Scalars['ID']['input'];
  productSku?: InputMaybe<Scalars['String']['input']>;
  includeProductEligibility?: Scalars['Boolean']['input'];
  includeProductEnrollment?: Scalars['Boolean']['input'];
  includeProductDeclination?: Scalars['Boolean']['input'];
  includeBillingDiscounts?: Scalars['Boolean']['input'];
}>;


export type ProductOffersByCustomerSessionIdQuery = { __typename?: 'Query', productOffersByCustomerSessionId: Array<{ __typename?: 'ProductOffer', id: string, productSku: string, customerMdn?: any | null, status: ProductOfferStatus, partner: string, disclosureStatus?: TransmittedDisclosureStatus | null, expertSession?: { __typename?: 'ExpertSession', id: string } | null, customerSession: { __typename?: 'CustomerSession', id: string }, productEligibility?: { __typename?: 'ProductEligibility', id: string, status: ProductEligibilityStatus, externalEligibilityId?: string | null, subscriptionNumber?: string | null, reason?: string | null } | null, productEnrollment?: { __typename?: 'ProductEnrollment', id: string, status: ProductEnrollmentStatus, planId?: string | null, lastModified?: any | null, confirmationCode?: string | null, additionalData?: any | null, error?: { __typename?: 'ProductEnrollmentError', category: ProductEnrollmentErrorCategory, code?: string | null, message?: string | null } | null } | null, productDeclination?: { __typename?: 'ProductDeclination', id: string, reason?: string | null } | null, billingDiscounts?: Array<{ __typename?: 'BillingDiscount', id: string, discountName?: string | null, discountType?: DiscountType | null, discountDescription?: string | null, programId?: string | null, discountActionType?: DiscountActionType | null, discountValue?: number | null, redemptionType?: RedemptionType | null, redemptionLimit?: number | null, status?: DiscountStatus | null, validityStart?: any | null, validityEnd?: any | null, discountCodeId?: string | null }> }> };

export type ProductEligibilityCreatedSubscriptionVariables = Exact<{
  productOfferId: Scalars['ID']['input'];
  since?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type ProductEligibilityCreatedSubscription = { __typename?: 'Subscription', productEligibilityCreated: { __typename?: 'ProductEligibility', id: string, status: ProductEligibilityStatus, externalEligibilityId?: string | null, subscriptionNumber?: string | null, reason?: string | null } };

export type ProductEligibilityUpdatedSubscriptionVariables = Exact<{
  productOfferId: Scalars['ID']['input'];
  since?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type ProductEligibilityUpdatedSubscription = { __typename?: 'Subscription', productEligibilityUpdated: { __typename?: 'ProductEligibility', id: string, status: ProductEligibilityStatus, externalEligibilityId?: string | null, subscriptionNumber?: string | null, reason?: string | null } };

export type ProductEnrollmentCreatedSubscriptionVariables = Exact<{
  productOfferId: Scalars['ID']['input'];
  since?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type ProductEnrollmentCreatedSubscription = { __typename?: 'Subscription', productEnrollmentCreated: { __typename?: 'ProductEnrollment', id: string, status: ProductEnrollmentStatus, planId?: string | null, lastModified?: any | null, confirmationCode?: string | null, additionalData?: any | null, error?: { __typename?: 'ProductEnrollmentError', category: ProductEnrollmentErrorCategory, code?: string | null, message?: string | null } | null } };

export type ProductEnrollmentUpdatedSubscriptionVariables = Exact<{
  productOfferId: Scalars['ID']['input'];
  since?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type ProductEnrollmentUpdatedSubscription = { __typename?: 'Subscription', productEnrollmentUpdated: { __typename?: 'ProductEnrollment', id: string, status: ProductEnrollmentStatus, planId?: string | null, lastModified?: any | null, confirmationCode?: string | null, additionalData?: any | null, error?: { __typename?: 'ProductEnrollmentError', category: ProductEnrollmentErrorCategory, code?: string | null, message?: string | null } | null } };

export type ProductOfferCreatedSubscriptionVariables = Exact<{
  productOfferId: Scalars['ID']['input'];
  since?: InputMaybe<Scalars['DateTime']['input']>;
  includeProductEligibility?: Scalars['Boolean']['input'];
  includeProductEnrollment?: Scalars['Boolean']['input'];
  includeProductDeclination?: Scalars['Boolean']['input'];
  includeBillingDiscounts?: Scalars['Boolean']['input'];
}>;


export type ProductOfferCreatedSubscription = { __typename?: 'Subscription', productOfferCreated: { __typename?: 'ProductOffer', id: string, productSku: string, customerMdn?: any | null, status: ProductOfferStatus, partner: string, disclosureStatus?: TransmittedDisclosureStatus | null, expertSession?: { __typename?: 'ExpertSession', id: string } | null, customerSession: { __typename?: 'CustomerSession', id: string }, productEligibility?: { __typename?: 'ProductEligibility', id: string, status: ProductEligibilityStatus, externalEligibilityId?: string | null, subscriptionNumber?: string | null, reason?: string | null } | null, productEnrollment?: { __typename?: 'ProductEnrollment', id: string, status: ProductEnrollmentStatus, planId?: string | null, lastModified?: any | null, confirmationCode?: string | null, additionalData?: any | null, error?: { __typename?: 'ProductEnrollmentError', category: ProductEnrollmentErrorCategory, code?: string | null, message?: string | null } | null } | null, productDeclination?: { __typename?: 'ProductDeclination', id: string, reason?: string | null } | null, billingDiscounts?: Array<{ __typename?: 'BillingDiscount', id: string, discountName?: string | null, discountType?: DiscountType | null, discountDescription?: string | null, programId?: string | null, discountActionType?: DiscountActionType | null, discountValue?: number | null, redemptionType?: RedemptionType | null, redemptionLimit?: number | null, status?: DiscountStatus | null, validityStart?: any | null, validityEnd?: any | null, discountCodeId?: string | null }> } };

export type ProductOfferUpdatedSubscriptionVariables = Exact<{
  productOfferId: Scalars['ID']['input'];
  since?: InputMaybe<Scalars['DateTime']['input']>;
  includeProductEligibility?: Scalars['Boolean']['input'];
  includeProductEnrollment?: Scalars['Boolean']['input'];
  includeProductDeclination?: Scalars['Boolean']['input'];
  includeBillingDiscounts?: Scalars['Boolean']['input'];
}>;


export type ProductOfferUpdatedSubscription = { __typename?: 'Subscription', productOfferUpdated?: { __typename?: 'ProductOffer', id: string, productSku: string, customerMdn?: any | null, status: ProductOfferStatus, partner: string, disclosureStatus?: TransmittedDisclosureStatus | null, expertSession?: { __typename?: 'ExpertSession', id: string } | null, customerSession: { __typename?: 'CustomerSession', id: string }, productEligibility?: { __typename?: 'ProductEligibility', id: string, status: ProductEligibilityStatus, externalEligibilityId?: string | null, subscriptionNumber?: string | null, reason?: string | null } | null, productEnrollment?: { __typename?: 'ProductEnrollment', id: string, status: ProductEnrollmentStatus, planId?: string | null, lastModified?: any | null, confirmationCode?: string | null, additionalData?: any | null, error?: { __typename?: 'ProductEnrollmentError', category: ProductEnrollmentErrorCategory, code?: string | null, message?: string | null } | null } | null, productDeclination?: { __typename?: 'ProductDeclination', id: string, reason?: string | null } | null, billingDiscounts?: Array<{ __typename?: 'BillingDiscount', id: string, discountName?: string | null, discountType?: DiscountType | null, discountDescription?: string | null, programId?: string | null, discountActionType?: DiscountActionType | null, discountValue?: number | null, redemptionType?: RedemptionType | null, redemptionLimit?: number | null, status?: DiscountStatus | null, validityStart?: any | null, validityEnd?: any | null, discountCodeId?: string | null }> } | null };

export type SalesConfigQueryVariables = Exact<{
  applicationName: Scalars['String']['input'];
  configName: Scalars['String']['input'];
}>;


export type SalesConfigQuery = { __typename?: 'Query', salesConfig?: any | null };


export const anAddExpertSessionInput = (overrides?: Partial<AddExpertSessionInput>, _relationshipsToOmit: Set<string> = new Set()): AddExpertSessionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddExpertSessionInput');
    return {
        customerSessionId: overrides && overrides.hasOwnProperty('customerSessionId') ? overrides.customerSessionId! : '11b3ccd7-6e2f-42bd-9a20-178c34d041c3',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '99f4795b-e527-4388-b8fd-b7ec7cca4d70',
    };
};

export const anAddExpertSessionSuccessPayload = (overrides?: Partial<AddExpertSessionSuccessPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AddExpertSessionSuccessPayload' } & AddExpertSessionSuccessPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddExpertSessionSuccessPayload');
    return {
        __typename: 'AddExpertSessionSuccessPayload',
        expertSession: overrides && overrides.hasOwnProperty('expertSession') ? overrides.expertSession! : relationshipsToOmit.has('ExpertSession') ? {} as ExpertSession : anExpertSession({}, relationshipsToOmit),
    };
};

export const anAddress = (overrides?: Partial<Address>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Address' } & Address => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Address');
    return {
        __typename: 'Address',
        addressLine1: overrides && overrides.hasOwnProperty('addressLine1') ? overrides.addressLine1! : 'et',
        addressLine2: overrides && overrides.hasOwnProperty('addressLine2') ? overrides.addressLine2! : 'sed',
        addressLine3: overrides && overrides.hasOwnProperty('addressLine3') ? overrides.addressLine3! : 'quia',
        addressType: overrides && overrides.hasOwnProperty('addressType') ? overrides.addressType! : AddressType.Billing,
        city: overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'amet',
        country: overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'non',
        municipality: overrides && overrides.hasOwnProperty('municipality') ? overrides.municipality! : 'dolore',
        postalCode: overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'veniam',
        state: overrides && overrides.hasOwnProperty('state') ? overrides.state! : 'non',
    };
};

export const anAddressInput = (overrides?: Partial<AddressInput>, _relationshipsToOmit: Set<string> = new Set()): AddressInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddressInput');
    return {
        addressLine1: overrides && overrides.hasOwnProperty('addressLine1') ? overrides.addressLine1! : 'suscipit',
        addressLine2: overrides && overrides.hasOwnProperty('addressLine2') ? overrides.addressLine2! : 'dolore',
        addressLine3: overrides && overrides.hasOwnProperty('addressLine3') ? overrides.addressLine3! : 'modi',
        addressType: overrides && overrides.hasOwnProperty('addressType') ? overrides.addressType! : AddressType.Billing,
        city: overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'adipisci',
        country: overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'autem',
        municipality: overrides && overrides.hasOwnProperty('municipality') ? overrides.municipality! : 'sed',
        postalCode: overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'architecto',
        state: overrides && overrides.hasOwnProperty('state') ? overrides.state! : 'alias',
    };
};

export const anAsset = (overrides?: Partial<Asset>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Asset' } & Asset => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Asset');
    return {
        __typename: 'Asset',
        assetCatalogId: overrides && overrides.hasOwnProperty('assetCatalogId') ? overrides.assetCatalogId! : 'consequatur',
        externalProductId: overrides && overrides.hasOwnProperty('externalProductId') ? overrides.externalProductId! : 'iste',
        imageUrl: overrides && overrides.hasOwnProperty('imageUrl') ? overrides.imageUrl! : 'porro',
        imei: overrides && overrides.hasOwnProperty('imei') ? overrides.imei! : 'eligendi',
        make: overrides && overrides.hasOwnProperty('make') ? overrides.make! : 'dolorum',
        model: overrides && overrides.hasOwnProperty('model') ? overrides.model! : 'ipsum',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'non',
        saleDate: overrides && overrides.hasOwnProperty('saleDate') ? overrides.saleDate! : '1970-01-08T18:12:46.495Z',
        sapCode: overrides && overrides.hasOwnProperty('sapCode') ? overrides.sapCode! : 'corrupti',
        sku: overrides && overrides.hasOwnProperty('sku') ? overrides.sku! : 'qui',
    };
};

export const anAssetInput = (overrides?: Partial<AssetInput>, _relationshipsToOmit: Set<string> = new Set()): AssetInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AssetInput');
    return {
        assetCatalogId: overrides && overrides.hasOwnProperty('assetCatalogId') ? overrides.assetCatalogId! : 'unde',
        externalProductId: overrides && overrides.hasOwnProperty('externalProductId') ? overrides.externalProductId! : 'est',
        imageUrl: overrides && overrides.hasOwnProperty('imageUrl') ? overrides.imageUrl! : 'veniam',
        imei: overrides && overrides.hasOwnProperty('imei') ? overrides.imei! : 'incidunt',
        make: overrides && overrides.hasOwnProperty('make') ? overrides.make! : 'veritatis',
        model: overrides && overrides.hasOwnProperty('model') ? overrides.model! : 'quod',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'et',
        saleDate: overrides && overrides.hasOwnProperty('saleDate') ? overrides.saleDate! : '1970-01-11T02:28:07.859Z',
        sapCode: overrides && overrides.hasOwnProperty('sapCode') ? overrides.sapCode! : 'culpa',
        sku: overrides && overrides.hasOwnProperty('sku') ? overrides.sku! : 'id',
    };
};

export const anAsurionCall = (overrides?: Partial<AsurionCall>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AsurionCall' } & AsurionCall => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AsurionCall');
    return {
        __typename: 'AsurionCall',
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : CallDirection.Inbound,
        flexReservation: overrides && overrides.hasOwnProperty('flexReservation') ? overrides.flexReservation! : relationshipsToOmit.has('FlexReservation') ? {} as FlexReservation : aFlexReservation({}, relationshipsToOmit),
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '1d51b415-bf3e-4159-bca8-0f1afc60994f',
    };
};

export const aBaseError = (overrides?: Partial<BaseError>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'BaseError' } & BaseError => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BaseError');
    return {
        __typename: 'BaseError',
        message: overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'est',
    };
};

export const aBilling = (overrides?: Partial<Billing>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Billing' } & Billing => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Billing');
    return {
        __typename: 'Billing',
        address: overrides && overrides.hasOwnProperty('address') ? overrides.address! : relationshipsToOmit.has('Address') ? {} as Address : anAddress({}, relationshipsToOmit),
        closingDay: overrides && overrides.hasOwnProperty('closingDay') ? overrides.closingDay! : 'velit',
        dueDay: overrides && overrides.hasOwnProperty('dueDay') ? overrides.dueDay! : 'aliquam',
        externalBillingCycleId: overrides && overrides.hasOwnProperty('externalBillingCycleId') ? overrides.externalBillingCycleId! : 'et',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '0f0eaeef-6648-4d38-9e47-7bff4ce83bae',
    };
};

export const aBillingDiscount = (overrides?: Partial<BillingDiscount>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'BillingDiscount' } & BillingDiscount => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BillingDiscount');
    return {
        __typename: 'BillingDiscount',
        discountActionType: overrides && overrides.hasOwnProperty('discountActionType') ? overrides.discountActionType! : DiscountActionType.FlatAmount,
        discountCodeId: overrides && overrides.hasOwnProperty('discountCodeId') ? overrides.discountCodeId! : 'cupiditate',
        discountDescription: overrides && overrides.hasOwnProperty('discountDescription') ? overrides.discountDescription! : 'est',
        discountId: overrides && overrides.hasOwnProperty('discountId') ? overrides.discountId! : 'doloribus',
        discountName: overrides && overrides.hasOwnProperty('discountName') ? overrides.discountName! : 'nemo',
        discountType: overrides && overrides.hasOwnProperty('discountType') ? overrides.discountType! : DiscountType.ExitSave,
        discountValue: overrides && overrides.hasOwnProperty('discountValue') ? overrides.discountValue! : 4.59,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'dcf2fd06-5fb9-455f-91b2-aa8c3392c5df',
        programId: overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'placeat',
        redemptionLimit: overrides && overrides.hasOwnProperty('redemptionLimit') ? overrides.redemptionLimit! : 5350,
        redemptionType: overrides && overrides.hasOwnProperty('redemptionType') ? overrides.redemptionType! : RedemptionType.Limited,
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : DiscountStatus.Active,
        validityEnd: overrides && overrides.hasOwnProperty('validityEnd') ? overrides.validityEnd! : 'aut',
        validityStart: overrides && overrides.hasOwnProperty('validityStart') ? overrides.validityStart! : 'qui',
    };
};

export const aBusinessUnit = (overrides?: Partial<BusinessUnit>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'BusinessUnit' } & BusinessUnit => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BusinessUnit');
    return {
        __typename: 'BusinessUnit',
        businessUnit: overrides && overrides.hasOwnProperty('businessUnit') ? overrides.businessUnit! : 'autem',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'b6332471-3de5-4683-af6d-b465585aae9c',
    };
};

export const aBusinessUnitsConnection = (overrides?: Partial<BusinessUnitsConnection>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'BusinessUnitsConnection' } & BusinessUnitsConnection => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BusinessUnitsConnection');
    return {
        __typename: 'BusinessUnitsConnection',
        edges: overrides && overrides.hasOwnProperty('edges') ? overrides.edges! : [relationshipsToOmit.has('BusinessUnitsEdge') ? {} as BusinessUnitsEdge : aBusinessUnitsEdge({}, relationshipsToOmit)],
        pageInfo: overrides && overrides.hasOwnProperty('pageInfo') ? overrides.pageInfo! : relationshipsToOmit.has('PageInfo') ? {} as PageInfo : aPageInfo({}, relationshipsToOmit),
    };
};

export const aBusinessUnitsEdge = (overrides?: Partial<BusinessUnitsEdge>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'BusinessUnitsEdge' } & BusinessUnitsEdge => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BusinessUnitsEdge');
    return {
        __typename: 'BusinessUnitsEdge',
        cursor: overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'molestias',
        node: overrides && overrides.hasOwnProperty('node') ? overrides.node! : relationshipsToOmit.has('BusinessUnit') ? {} as BusinessUnit : aBusinessUnit({}, relationshipsToOmit),
    };
};

export const aCommunication = (overrides?: Partial<Communication>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Communication' } & Communication => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Communication');
    return {
        __typename: 'Communication',
        customerSessionId: overrides && overrides.hasOwnProperty('customerSessionId') ? overrides.customerSessionId! : 'caa78a3b-ada7-4bca-b13d-06df4205a207',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'delectus',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'e9b005aa-6de3-48a4-a7b0-599dc76dbe0b',
        mdn: overrides && overrides.hasOwnProperty('mdn') ? overrides.mdn! : 'esse',
        productSku: overrides && overrides.hasOwnProperty('productSku') ? overrides.productSku! : 'et',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : MessageStatus.Accepted,
        templateId: overrides && overrides.hasOwnProperty('templateId') ? overrides.templateId! : 'voluptas',
        templateVariables: overrides && overrides.hasOwnProperty('templateVariables') ? overrides.templateVariables! : 'possimus',
        transactionId: overrides && overrides.hasOwnProperty('transactionId') ? overrides.transactionId! : 'cum',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : MessageType.Email,
    };
};

export const aConnection = (overrides?: Partial<Connection>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Connection' } & Connection => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Connection');
    return {
        __typename: 'Connection',
        edges: overrides && overrides.hasOwnProperty('edges') ? overrides.edges! : [relationshipsToOmit.has('Edge') ? {} as Edge : anEdge({}, relationshipsToOmit)],
        pageInfo: overrides && overrides.hasOwnProperty('pageInfo') ? overrides.pageInfo! : relationshipsToOmit.has('PageInfo') ? {} as PageInfo : aPageInfo({}, relationshipsToOmit),
    };
};

export const aCpfVerification = (overrides?: Partial<CpfVerification>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CpfVerification' } & CpfVerification => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CpfVerification');
    return {
        __typename: 'CpfVerification',
        cpf: overrides && overrides.hasOwnProperty('cpf') ? overrides.cpf! : 'omnis',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '8a7ae51b-69cc-4fe8-a7df-5b09863c7436',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : CpfVerificationStatus.Failed,
    };
};

export const aCreateAsurionCallInput = (overrides?: Partial<CreateAsurionCallInput>, _relationshipsToOmit: Set<string> = new Set()): CreateAsurionCallInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateAsurionCallInput');
    return {
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : CallDirection.Inbound,
        flexReservation: overrides && overrides.hasOwnProperty('flexReservation') ? overrides.flexReservation! : relationshipsToOmit.has('FlexReservationInput') ? {} as FlexReservationInput : aFlexReservationInput({}, relationshipsToOmit),
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '14b840f6-a6d4-4dd3-a9ed-dd923c14b912',
    };
};

export const aCreateBillingDiscountInput = (overrides?: Partial<CreateBillingDiscountInput>, _relationshipsToOmit: Set<string> = new Set()): CreateBillingDiscountInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateBillingDiscountInput');
    return {
        discountActionType: overrides && overrides.hasOwnProperty('discountActionType') ? overrides.discountActionType! : DiscountActionType.FlatAmount,
        discountCodeId: overrides && overrides.hasOwnProperty('discountCodeId') ? overrides.discountCodeId! : 'fugiat',
        discountDescription: overrides && overrides.hasOwnProperty('discountDescription') ? overrides.discountDescription! : 'ea',
        discountId: overrides && overrides.hasOwnProperty('discountId') ? overrides.discountId! : 'c4becee6-2e47-403b-9d1b-1e009126e8d7',
        discountName: overrides && overrides.hasOwnProperty('discountName') ? overrides.discountName! : 'sed',
        discountType: overrides && overrides.hasOwnProperty('discountType') ? overrides.discountType! : DiscountType.ExitSave,
        discountValue: overrides && overrides.hasOwnProperty('discountValue') ? overrides.discountValue! : 4.59,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '3c8bdcf2-3dd0-4178-88d8-dc9114995fe8',
        programId: overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'dolorem',
        redemptionLimit: overrides && overrides.hasOwnProperty('redemptionLimit') ? overrides.redemptionLimit! : 7375,
        redemptionType: overrides && overrides.hasOwnProperty('redemptionType') ? overrides.redemptionType! : RedemptionType.Limited,
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : DiscountStatus.Active,
        validityEnd: overrides && overrides.hasOwnProperty('validityEnd') ? overrides.validityEnd! : 'accusamus',
        validityStart: overrides && overrides.hasOwnProperty('validityStart') ? overrides.validityStart! : 'non',
    };
};

export const aCreateBillingDiscountsInput = (overrides?: Partial<CreateBillingDiscountsInput>, _relationshipsToOmit: Set<string> = new Set()): CreateBillingDiscountsInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateBillingDiscountsInput');
    return {
        billingDiscounts: overrides && overrides.hasOwnProperty('billingDiscounts') ? overrides.billingDiscounts! : [relationshipsToOmit.has('CreateBillingDiscountInput') ? {} as CreateBillingDiscountInput : aCreateBillingDiscountInput({}, relationshipsToOmit)],
        productOfferId: overrides && overrides.hasOwnProperty('productOfferId') ? overrides.productOfferId! : 'ff9f1ac2-768f-4323-9cf9-5dc579353ab5',
    };
};

export const aCreateBillingDiscountsSuccessPayload = (overrides?: Partial<CreateBillingDiscountsSuccessPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateBillingDiscountsSuccessPayload' } & CreateBillingDiscountsSuccessPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateBillingDiscountsSuccessPayload');
    return {
        __typename: 'CreateBillingDiscountsSuccessPayload',
        billingDiscounts: overrides && overrides.hasOwnProperty('billingDiscounts') ? overrides.billingDiscounts! : [relationshipsToOmit.has('BillingDiscount') ? {} as BillingDiscount : aBillingDiscount({}, relationshipsToOmit)],
    };
};

export const aCreateBillingInput = (overrides?: Partial<CreateBillingInput>, _relationshipsToOmit: Set<string> = new Set()): CreateBillingInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateBillingInput');
    return {
        address: overrides && overrides.hasOwnProperty('address') ? overrides.address! : relationshipsToOmit.has('AddressInput') ? {} as AddressInput : anAddressInput({}, relationshipsToOmit),
        customerSessionId: overrides && overrides.hasOwnProperty('customerSessionId') ? overrides.customerSessionId! : '5822cf5c-a715-4197-86b5-d640a60e40b4',
    };
};

export const aCreateBillingSuccessPayload = (overrides?: Partial<CreateBillingSuccessPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateBillingSuccessPayload' } & CreateBillingSuccessPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateBillingSuccessPayload');
    return {
        __typename: 'CreateBillingSuccessPayload',
        billing: overrides && overrides.hasOwnProperty('billing') ? overrides.billing! : relationshipsToOmit.has('Billing') ? {} as Billing : aBilling({}, relationshipsToOmit),
    };
};

export const aCreateCommunicationInput = (overrides?: Partial<CreateCommunicationInput>, _relationshipsToOmit: Set<string> = new Set()): CreateCommunicationInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateCommunicationInput');
    return {
        customerSessionId: overrides && overrides.hasOwnProperty('customerSessionId') ? overrides.customerSessionId! : '7c5cb7ba-0438-45ce-8a7b-bfe6efc1083c',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'laborum',
        mdn: overrides && overrides.hasOwnProperty('mdn') ? overrides.mdn! : 'perspiciatis',
        productSku: overrides && overrides.hasOwnProperty('productSku') ? overrides.productSku! : 'iste',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : MessageStatus.Accepted,
        templateId: overrides && overrides.hasOwnProperty('templateId') ? overrides.templateId! : 'est',
        templateVariables: overrides && overrides.hasOwnProperty('templateVariables') ? overrides.templateVariables! : 'vel',
        transactionId: overrides && overrides.hasOwnProperty('transactionId') ? overrides.transactionId! : 'quis',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : MessageType.Email,
    };
};

export const aCreateCommunicationSuccessPayload = (overrides?: Partial<CreateCommunicationSuccessPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateCommunicationSuccessPayload' } & CreateCommunicationSuccessPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateCommunicationSuccessPayload');
    return {
        __typename: 'CreateCommunicationSuccessPayload',
        communication: overrides && overrides.hasOwnProperty('communication') ? overrides.communication! : relationshipsToOmit.has('Communication') ? {} as Communication : aCommunication({}, relationshipsToOmit),
    };
};

export const aCreateCpfVerificationInput = (overrides?: Partial<CreateCpfVerificationInput>, _relationshipsToOmit: Set<string> = new Set()): CreateCpfVerificationInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateCpfVerificationInput');
    return {
        cpf: overrides && overrides.hasOwnProperty('cpf') ? overrides.cpf! : 'dignissimos',
        customerSessionId: overrides && overrides.hasOwnProperty('customerSessionId') ? overrides.customerSessionId! : 'b8397805-62f3-4f02-9e47-991fd5969b98',
    };
};

export const aCreateCpfVerificationSuccessPayload = (overrides?: Partial<CreateCpfVerificationSuccessPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateCpfVerificationSuccessPayload' } & CreateCpfVerificationSuccessPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateCpfVerificationSuccessPayload');
    return {
        __typename: 'CreateCpfVerificationSuccessPayload',
        cpfVerification: overrides && overrides.hasOwnProperty('cpfVerification') ? overrides.cpfVerification! : relationshipsToOmit.has('CpfVerification') ? {} as CpfVerification : aCpfVerification({}, relationshipsToOmit),
    };
};

export const aCreateCustomerInput = (overrides?: Partial<CreateCustomerInput>, _relationshipsToOmit: Set<string> = new Set()): CreateCustomerInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateCustomerInput');
    return {
        accountNumber: overrides && overrides.hasOwnProperty('accountNumber') ? overrides.accountNumber! : 'cum',
        address: overrides && overrides.hasOwnProperty('address') ? overrides.address! : relationshipsToOmit.has('AddressInput') ? {} as AddressInput : anAddressInput({}, relationshipsToOmit),
        asset: overrides && overrides.hasOwnProperty('asset') ? overrides.asset! : relationshipsToOmit.has('AssetInput') ? {} as AssetInput : anAssetInput({}, relationshipsToOmit),
        asurionId: overrides && overrides.hasOwnProperty('asurionId') ? overrides.asurionId! : 'a36cd886-30e4-4eeb-9ab2-4672061e1bf5',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'perspiciatis',
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'non',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'numquam',
        mdn: overrides && overrides.hasOwnProperty('mdn') ? overrides.mdn! : 'et',
        mobileBan: overrides && overrides.hasOwnProperty('mobileBan') ? overrides.mobileBan! : 'officiis',
        socialName: overrides && overrides.hasOwnProperty('socialName') ? overrides.socialName! : 'dolore',
    };
};

export const aCreateCustomerSessionInput = (overrides?: Partial<CreateCustomerSessionInput>, _relationshipsToOmit: Set<string> = new Set()): CreateCustomerSessionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateCustomerSessionInput');
    return {
        asurionCall: overrides && overrides.hasOwnProperty('asurionCall') ? overrides.asurionCall! : relationshipsToOmit.has('CreateAsurionCallInput') ? {} as CreateAsurionCallInput : aCreateAsurionCallInput({}, relationshipsToOmit),
        channel: overrides && overrides.hasOwnProperty('channel') ? overrides.channel! : 'velit',
        cohortTag: overrides && overrides.hasOwnProperty('cohortTag') ? overrides.cohortTag! : 'sunt',
        customer: overrides && overrides.hasOwnProperty('customer') ? overrides.customer! : relationshipsToOmit.has('CreateCustomerInput') ? {} as CreateCustomerInput : aCreateCustomerInput({}, relationshipsToOmit),
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : CallDirection.Inbound,
        expertSessionId: overrides && overrides.hasOwnProperty('expertSessionId') ? overrides.expertSessionId! : 'f7beae95-30d8-49f2-bee1-538d3b9a6d69',
        extensions: overrides && overrides.hasOwnProperty('extensions') ? overrides.extensions! : [relationshipsToOmit.has('ExtensionInput') ? {} as ExtensionInput : anExtensionInput({}, relationshipsToOmit)],
        externalClientAccount: overrides && overrides.hasOwnProperty('externalClientAccount') ? overrides.externalClientAccount! : relationshipsToOmit.has('CreateExternalClientAccountInput') ? {} as CreateExternalClientAccountInput : aCreateExternalClientAccountInput({}, relationshipsToOmit),
        externalSession: overrides && overrides.hasOwnProperty('externalSession') ? overrides.externalSession! : relationshipsToOmit.has('CreateExternalSessionInput') ? {} as CreateExternalSessionInput : aCreateExternalSessionInput({}, relationshipsToOmit),
        horizonSession: overrides && overrides.hasOwnProperty('horizonSession') ? overrides.horizonSession! : relationshipsToOmit.has('CreateHorizonSessionInput') ? {} as CreateHorizonSessionInput : aCreateHorizonSessionInput({}, relationshipsToOmit),
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '28606149-b87f-4d2d-98f2-e5a33c6faf5b',
        language: overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'doloremque',
        marketing: overrides && overrides.hasOwnProperty('marketing') ? overrides.marketing! : relationshipsToOmit.has('MarketingInput') ? {} as MarketingInput : aMarketingInput({}, relationshipsToOmit),
        mdnVerification: overrides && overrides.hasOwnProperty('mdnVerification') ? overrides.mdnVerification! : relationshipsToOmit.has('CreateCustomerSessionMdnVerificationInput') ? {} as CreateCustomerSessionMdnVerificationInput : aCreateCustomerSessionMdnVerificationInput({}, relationshipsToOmit),
        origin: overrides && overrides.hasOwnProperty('origin') ? overrides.origin! : 'qui',
        partner: overrides && overrides.hasOwnProperty('partner') ? overrides.partner! : 'nobis',
        sessionStatus: overrides && overrides.hasOwnProperty('sessionStatus') ? overrides.sessionStatus! : SessionStatus.Callback,
    };
};

export const aCreateCustomerSessionMdnVerificationInput = (overrides?: Partial<CreateCustomerSessionMdnVerificationInput>, _relationshipsToOmit: Set<string> = new Set()): CreateCustomerSessionMdnVerificationInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateCustomerSessionMdnVerificationInput');
    return {
        expiration: overrides && overrides.hasOwnProperty('expiration') ? overrides.expiration! : 'enim',
        transactionId: overrides && overrides.hasOwnProperty('transactionId') ? overrides.transactionId! : 'aut',
    };
};

export const aCreateCustomerSessionSuccessPayload = (overrides?: Partial<CreateCustomerSessionSuccessPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateCustomerSessionSuccessPayload' } & CreateCustomerSessionSuccessPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateCustomerSessionSuccessPayload');
    return {
        __typename: 'CreateCustomerSessionSuccessPayload',
        customerSession: overrides && overrides.hasOwnProperty('customerSession') ? overrides.customerSession! : relationshipsToOmit.has('CustomerSession') ? {} as CustomerSession : aCustomerSession({}, relationshipsToOmit),
        mdnVerification: overrides && overrides.hasOwnProperty('mdnVerification') ? overrides.mdnVerification! : relationshipsToOmit.has('MdnVerification') ? {} as MdnVerification : aMdnVerification({}, relationshipsToOmit),
    };
};

export const aCreateExpertInput = (overrides?: Partial<CreateExpertInput>, _relationshipsToOmit: Set<string> = new Set()): CreateExpertInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateExpertInput');
    return {
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'delectus',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ed8cca78-b08c-4d82-a115-ee5a6fc4564d',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'temporibus',
        username: overrides && overrides.hasOwnProperty('username') ? overrides.username! : 'qui',
    };
};

export const aCreateExpertSessionInput = (overrides?: Partial<CreateExpertSessionInput>, _relationshipsToOmit: Set<string> = new Set()): CreateExpertSessionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateExpertSessionInput');
    return {
        expert: overrides && overrides.hasOwnProperty('expert') ? overrides.expert! : relationshipsToOmit.has('CreateExpertInput') ? {} as CreateExpertInput : aCreateExpertInput({}, relationshipsToOmit),
        hostApp: overrides && overrides.hasOwnProperty('hostApp') ? overrides.hostApp! : 'facere',
        supportedSkus: overrides && overrides.hasOwnProperty('supportedSkus') ? overrides.supportedSkus! : ['quis'],
    };
};

export const aCreateExpertSessionSuccessPayload = (overrides?: Partial<CreateExpertSessionSuccessPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateExpertSessionSuccessPayload' } & CreateExpertSessionSuccessPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateExpertSessionSuccessPayload');
    return {
        __typename: 'CreateExpertSessionSuccessPayload',
        expertSession: overrides && overrides.hasOwnProperty('expertSession') ? overrides.expertSession! : relationshipsToOmit.has('ExpertSession') ? {} as ExpertSession : anExpertSession({}, relationshipsToOmit),
    };
};

export const aCreateExternalClientAccountInput = (overrides?: Partial<CreateExternalClientAccountInput>, _relationshipsToOmit: Set<string> = new Set()): CreateExternalClientAccountInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateExternalClientAccountInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '86f9ea37-8a68-457d-9294-f68d10043d6c',
    };
};

export const aCreateExternalSessionInput = (overrides?: Partial<CreateExternalSessionInput>, _relationshipsToOmit: Set<string> = new Set()): CreateExternalSessionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateExternalSessionInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'de62d9a5-b3d0-4716-b23a-973738ac0e38',
    };
};

export const aCreateHorizonSessionInput = (overrides?: Partial<CreateHorizonSessionInput>, _relationshipsToOmit: Set<string> = new Set()): CreateHorizonSessionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateHorizonSessionInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '0b7f922f-3d1d-4a45-9b00-b8f2e098d909',
    };
};

export const aCreateMdnVerificationInput = (overrides?: Partial<CreateMdnVerificationInput>, _relationshipsToOmit: Set<string> = new Set()): CreateMdnVerificationInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateMdnVerificationInput');
    return {
        customerSessionId: overrides && overrides.hasOwnProperty('customerSessionId') ? overrides.customerSessionId! : '25c0cbdc-4dd4-44ce-b982-e75afb3ae2ef',
    };
};

export const aCreateMdnVerificationSuccessPayload = (overrides?: Partial<CreateMdnVerificationSuccessPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateMdnVerificationSuccessPayload' } & CreateMdnVerificationSuccessPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateMdnVerificationSuccessPayload');
    return {
        __typename: 'CreateMdnVerificationSuccessPayload',
        mdnVerification: overrides && overrides.hasOwnProperty('mdnVerification') ? overrides.mdnVerification! : relationshipsToOmit.has('MdnVerification') ? {} as MdnVerification : aMdnVerification({}, relationshipsToOmit),
    };
};

export const aCreatePaySessionInput = (overrides?: Partial<CreatePaySessionInput>, _relationshipsToOmit: Set<string> = new Set()): CreatePaySessionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreatePaySessionInput');
    return {
        billingFrequencyInMonths: overrides && overrides.hasOwnProperty('billingFrequencyInMonths') ? overrides.billingFrequencyInMonths! : 'et',
        billingToken: overrides && overrides.hasOwnProperty('billingToken') ? overrides.billingToken! : 'in',
        customerSessionId: overrides && overrides.hasOwnProperty('customerSessionId') ? overrides.customerSessionId! : '5f2f3b62-5931-4622-aaa4-2cedcfeded7a',
        paymentType: overrides && overrides.hasOwnProperty('paymentType') ? overrides.paymentType! : PaymentType.Bta,
        productPaidFrequency: overrides && overrides.hasOwnProperty('productPaidFrequency') ? overrides.productPaidFrequency! : 'quidem',
        productSku: overrides && overrides.hasOwnProperty('productSku') ? overrides.productSku! : 'perspiciatis',
        transactionType: overrides && overrides.hasOwnProperty('transactionType') ? overrides.transactionType! : TransactionType.AgentAssisted,
    };
};

export const aCreatePaySessionSuccessPayload = (overrides?: Partial<CreatePaySessionSuccessPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreatePaySessionSuccessPayload' } & CreatePaySessionSuccessPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreatePaySessionSuccessPayload');
    return {
        __typename: 'CreatePaySessionSuccessPayload',
        paySession: overrides && overrides.hasOwnProperty('paySession') ? overrides.paySession! : relationshipsToOmit.has('PaySession') ? {} as PaySession : aPaySession({}, relationshipsToOmit),
    };
};

export const aCreateProductDeclinationInput = (overrides?: Partial<CreateProductDeclinationInput>, _relationshipsToOmit: Set<string> = new Set()): CreateProductDeclinationInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateProductDeclinationInput');
    return {
        productOfferId: overrides && overrides.hasOwnProperty('productOfferId') ? overrides.productOfferId! : 'a6060b66-40d1-4d6b-a180-9fa91aa5fd14',
        reason: overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : 'veritatis',
    };
};

export const aCreateProductDeclinationSuccessPayload = (overrides?: Partial<CreateProductDeclinationSuccessPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateProductDeclinationSuccessPayload' } & CreateProductDeclinationSuccessPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateProductDeclinationSuccessPayload');
    return {
        __typename: 'CreateProductDeclinationSuccessPayload',
        productDeclination: overrides && overrides.hasOwnProperty('productDeclination') ? overrides.productDeclination! : relationshipsToOmit.has('ProductDeclination') ? {} as ProductDeclination : aProductDeclination({}, relationshipsToOmit),
    };
};

export const aCreateProductEnrollmentInput = (overrides?: Partial<CreateProductEnrollmentInput>, _relationshipsToOmit: Set<string> = new Set()): CreateProductEnrollmentInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateProductEnrollmentInput');
    return {
        additionalData: overrides && overrides.hasOwnProperty('additionalData') ? overrides.additionalData! : 'sed',
        confirmationCode: overrides && overrides.hasOwnProperty('confirmationCode') ? overrides.confirmationCode! : 'recusandae',
        consentId: overrides && overrides.hasOwnProperty('consentId') ? overrides.consentId! : 'reiciendis',
        error: overrides && overrides.hasOwnProperty('error') ? overrides.error! : relationshipsToOmit.has('ProductEnrollmentErrorInput') ? {} as ProductEnrollmentErrorInput : aProductEnrollmentErrorInput({}, relationshipsToOmit),
        externalReferenceId: overrides && overrides.hasOwnProperty('externalReferenceId') ? overrides.externalReferenceId! : 'natus',
        paySessionId: overrides && overrides.hasOwnProperty('paySessionId') ? overrides.paySessionId! : '22d6baef-6a5d-442b-8fe1-965b8a6df976',
        planId: overrides && overrides.hasOwnProperty('planId') ? overrides.planId! : 'nobis',
        productOfferId: overrides && overrides.hasOwnProperty('productOfferId') ? overrides.productOfferId! : 'a2144bc6-3acd-4347-83c4-441fcfa57ed8',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : ProductEnrollmentStatus.Failure,
    };
};

export const aCreateProductEnrollmentSuccessPayload = (overrides?: Partial<CreateProductEnrollmentSuccessPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateProductEnrollmentSuccessPayload' } & CreateProductEnrollmentSuccessPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateProductEnrollmentSuccessPayload');
    return {
        __typename: 'CreateProductEnrollmentSuccessPayload',
        productEnrollment: overrides && overrides.hasOwnProperty('productEnrollment') ? overrides.productEnrollment! : relationshipsToOmit.has('ProductEnrollment') ? {} as ProductEnrollment : aProductEnrollment({}, relationshipsToOmit),
    };
};

export const aCreateProductOfferEligibilityInput = (overrides?: Partial<CreateProductOfferEligibilityInput>, _relationshipsToOmit: Set<string> = new Set()): CreateProductOfferEligibilityInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateProductOfferEligibilityInput');
    return {
        extensions: overrides && overrides.hasOwnProperty('extensions') ? overrides.extensions! : [relationshipsToOmit.has('ExtensionInput') ? {} as ExtensionInput : anExtensionInput({}, relationshipsToOmit)],
        externalEligibilityId: overrides && overrides.hasOwnProperty('externalEligibilityId') ? overrides.externalEligibilityId! : 'aut',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : ProductEligibilityStatus.AlreadyEnrolled,
        subscriptionNumber: overrides && overrides.hasOwnProperty('subscriptionNumber') ? overrides.subscriptionNumber! : 'et',
    };
};

export const aCreateProductOfferInput = (overrides?: Partial<CreateProductOfferInput>, _relationshipsToOmit: Set<string> = new Set()): CreateProductOfferInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateProductOfferInput');
    return {
        customerMdn: overrides && overrides.hasOwnProperty('customerMdn') ? overrides.customerMdn! : 'molestias',
        customerSessionId: overrides && overrides.hasOwnProperty('customerSessionId') ? overrides.customerSessionId! : 'bc9d7866-82d0-417a-8c5f-c1f491465193',
        expertSessionId: overrides && overrides.hasOwnProperty('expertSessionId') ? overrides.expertSessionId! : 'c251fbbb-bd7d-495b-bf1f-5f372d823627',
        partner: overrides && overrides.hasOwnProperty('partner') ? overrides.partner! : 'dolorum',
        productEligibility: overrides && overrides.hasOwnProperty('productEligibility') ? overrides.productEligibility! : relationshipsToOmit.has('CreateProductOfferEligibilityInput') ? {} as CreateProductOfferEligibilityInput : aCreateProductOfferEligibilityInput({}, relationshipsToOmit),
        productSku: overrides && overrides.hasOwnProperty('productSku') ? overrides.productSku! : 'iusto',
    };
};

export const aCreateProductOfferSuccessPayload = (overrides?: Partial<CreateProductOfferSuccessPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateProductOfferSuccessPayload' } & CreateProductOfferSuccessPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateProductOfferSuccessPayload');
    return {
        __typename: 'CreateProductOfferSuccessPayload',
        productOffer: overrides && overrides.hasOwnProperty('productOffer') ? overrides.productOffer! : relationshipsToOmit.has('ProductOffer') ? {} as ProductOffer : aProductOffer({}, relationshipsToOmit),
    };
};

export const aCustomer = (overrides?: Partial<Customer>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Customer' } & Customer => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Customer');
    return {
        __typename: 'Customer',
        accountNumber: overrides && overrides.hasOwnProperty('accountNumber') ? overrides.accountNumber! : 'ut',
        address: overrides && overrides.hasOwnProperty('address') ? overrides.address! : relationshipsToOmit.has('Address') ? {} as Address : anAddress({}, relationshipsToOmit),
        asset: overrides && overrides.hasOwnProperty('asset') ? overrides.asset! : relationshipsToOmit.has('Asset') ? {} as Asset : anAsset({}, relationshipsToOmit),
        asurionId: overrides && overrides.hasOwnProperty('asurionId') ? overrides.asurionId! : 'c93ca322-fa27-46b0-a3b3-fa4de77ecdf6',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'sit',
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'asperiores',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'c7b2f704-dc93-438d-b0a1-216e8083ef04',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'eos',
        mdn: overrides && overrides.hasOwnProperty('mdn') ? overrides.mdn! : 'ut',
        mobileBan: overrides && overrides.hasOwnProperty('mobileBan') ? overrides.mobileBan! : 'qui',
        socialName: overrides && overrides.hasOwnProperty('socialName') ? overrides.socialName! : 'quia',
        temporaryMdn: overrides && overrides.hasOwnProperty('temporaryMdn') ? overrides.temporaryMdn! : 'repellendus',
    };
};

export const aCustomerSession = (overrides?: Partial<CustomerSession>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CustomerSession' } & CustomerSession => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CustomerSession');
    return {
        __typename: 'CustomerSession',
        asurionCall: overrides && overrides.hasOwnProperty('asurionCall') ? overrides.asurionCall! : relationshipsToOmit.has('AsurionCall') ? {} as AsurionCall : anAsurionCall({}, relationshipsToOmit),
        billing: overrides && overrides.hasOwnProperty('billing') ? overrides.billing! : relationshipsToOmit.has('Billing') ? {} as Billing : aBilling({}, relationshipsToOmit),
        channel: overrides && overrides.hasOwnProperty('channel') ? overrides.channel! : 'sed',
        cohortTag: overrides && overrides.hasOwnProperty('cohortTag') ? overrides.cohortTag! : 'excepturi',
        communications: overrides && overrides.hasOwnProperty('communications') ? overrides.communications! : [relationshipsToOmit.has('Communication') ? {} as Communication : aCommunication({}, relationshipsToOmit)],
        cpfVerification: overrides && overrides.hasOwnProperty('cpfVerification') ? overrides.cpfVerification! : relationshipsToOmit.has('CpfVerification') ? {} as CpfVerification : aCpfVerification({}, relationshipsToOmit),
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 'optio',
        customer: overrides && overrides.hasOwnProperty('customer') ? overrides.customer! : relationshipsToOmit.has('Customer') ? {} as Customer : aCustomer({}, relationshipsToOmit),
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : CallDirection.Inbound,
        expertSessions: overrides && overrides.hasOwnProperty('expertSessions') ? overrides.expertSessions! : [relationshipsToOmit.has('ExpertSession') ? {} as ExpertSession : anExpertSession({}, relationshipsToOmit)],
        extensions: overrides && overrides.hasOwnProperty('extensions') ? overrides.extensions! : [relationshipsToOmit.has('Extension') ? {} as Extension : anExtension({}, relationshipsToOmit)],
        externalClientAccount: overrides && overrides.hasOwnProperty('externalClientAccount') ? overrides.externalClientAccount! : relationshipsToOmit.has('ExternalClientAccount') ? {} as ExternalClientAccount : anExternalClientAccount({}, relationshipsToOmit),
        externalSession: overrides && overrides.hasOwnProperty('externalSession') ? overrides.externalSession! : relationshipsToOmit.has('ExternalSession') ? {} as ExternalSession : anExternalSession({}, relationshipsToOmit),
        horizonSession: overrides && overrides.hasOwnProperty('horizonSession') ? overrides.horizonSession! : relationshipsToOmit.has('HorizonSession') ? {} as HorizonSession : aHorizonSession({}, relationshipsToOmit),
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '0d560be1-0f82-4edd-a2c2-998573236fc5',
        language: overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'sed',
        marketing: overrides && overrides.hasOwnProperty('marketing') ? overrides.marketing! : relationshipsToOmit.has('Marketing') ? {} as Marketing : aMarketing({}, relationshipsToOmit),
        mdnVerification: overrides && overrides.hasOwnProperty('mdnVerification') ? overrides.mdnVerification! : relationshipsToOmit.has('MdnVerification') ? {} as MdnVerification : aMdnVerification({}, relationshipsToOmit),
        origin: overrides && overrides.hasOwnProperty('origin') ? overrides.origin! : 'ipsam',
        outboundCalls: overrides && overrides.hasOwnProperty('outboundCalls') ? overrides.outboundCalls! : [relationshipsToOmit.has('AsurionCall') ? {} as AsurionCall : anAsurionCall({}, relationshipsToOmit)],
        partner: overrides && overrides.hasOwnProperty('partner') ? overrides.partner! : 'neque',
        paySession: overrides && overrides.hasOwnProperty('paySession') ? overrides.paySession! : relationshipsToOmit.has('PaySession') ? {} as PaySession : aPaySession({}, relationshipsToOmit),
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : SessionStatus.Callback,
    };
};

export const aDeleteCustomerSessionInput = (overrides?: Partial<DeleteCustomerSessionInput>, _relationshipsToOmit: Set<string> = new Set()): DeleteCustomerSessionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteCustomerSessionInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ff3a1037-db0c-4cf0-9ac7-63d8e9ec60c0',
    };
};

export const aDeleteCustomerSessionSuccessPayload = (overrides?: Partial<DeleteCustomerSessionSuccessPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteCustomerSessionSuccessPayload' } & DeleteCustomerSessionSuccessPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteCustomerSessionSuccessPayload');
    return {
        __typename: 'DeleteCustomerSessionSuccessPayload',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'de80b5a1-7d39-4c7f-bb34-7e970315a11f',
    };
};

export const aDeleteProductOfferInput = (overrides?: Partial<DeleteProductOfferInput>, _relationshipsToOmit: Set<string> = new Set()): DeleteProductOfferInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteProductOfferInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ef08a926-5a00-42af-9d02-356d113104d6',
    };
};

export const aDeleteProductOfferSuccessPayload = (overrides?: Partial<DeleteProductOfferSuccessPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteProductOfferSuccessPayload' } & DeleteProductOfferSuccessPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteProductOfferSuccessPayload');
    return {
        __typename: 'DeleteProductOfferSuccessPayload',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '675b46d5-f20a-4bef-9654-eb35cf40271d',
    };
};

export const aDuplicateError = (overrides?: Partial<DuplicateError>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DuplicateError' } & DuplicateError => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DuplicateError');
    return {
        __typename: 'DuplicateError',
        message: overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'ea',
    };
};

export const anEdge = (overrides?: Partial<Edge>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Edge' } & Edge => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Edge');
    return {
        __typename: 'Edge',
        cursor: overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'recusandae',
        node: overrides && overrides.hasOwnProperty('node') ? overrides.node! : relationshipsToOmit.has('Node') ? {} as Node : aNode({}, relationshipsToOmit),
    };
};

export const anError = (overrides?: Partial<Error>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Error' } & Error => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Error');
    return {
        __typename: 'Error',
        message: overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'et',
    };
};

export const anExpert = (overrides?: Partial<Expert>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Expert' } & Expert => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Expert');
    return {
        __typename: 'Expert',
        businessUnit: overrides && overrides.hasOwnProperty('businessUnit') ? overrides.businessUnit! : 'et',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'illum',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '79b9a915-ba01-4ad3-9122-e2978c6b7b37',
        lob: overrides && overrides.hasOwnProperty('lob') ? overrides.lob! : 'eos',
        manager: overrides && overrides.hasOwnProperty('manager') ? overrides.manager! : 'odit',
        managerId: overrides && overrides.hasOwnProperty('managerId') ? overrides.managerId! : 'omnis',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'aperiam',
        site: overrides && overrides.hasOwnProperty('site') ? overrides.site! : 'harum',
        supervisor: overrides && overrides.hasOwnProperty('supervisor') ? overrides.supervisor! : 'nihil',
        supervisorId: overrides && overrides.hasOwnProperty('supervisorId') ? overrides.supervisorId! : 'eum',
        username: overrides && overrides.hasOwnProperty('username') ? overrides.username! : 'aspernatur',
    };
};

export const anExpertMetric = (overrides?: Partial<ExpertMetric>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ExpertMetric' } & ExpertMetric => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExpertMetric');
    return {
        __typename: 'ExpertMetric',
        businessUnit: overrides && overrides.hasOwnProperty('businessUnit') ? overrides.businessUnit! : 'officiis',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '9f5810e0-ec54-44c9-b093-1a0f62a20f98',
        manager: overrides && overrides.hasOwnProperty('manager') ? overrides.manager! : 'officia',
        metrics: overrides && overrides.hasOwnProperty('metrics') ? overrides.metrics! : relationshipsToOmit.has('SalesMetric') ? {} as SalesMetric : aSalesMetric({}, relationshipsToOmit),
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'amet',
        site: overrides && overrides.hasOwnProperty('site') ? overrides.site! : 'unde',
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : 'minima',
        supervisor: overrides && overrides.hasOwnProperty('supervisor') ? overrides.supervisor! : 'aperiam',
    };
};

export const anExpertMetricsEdge = (overrides?: Partial<ExpertMetricsEdge>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ExpertMetricsEdge' } & ExpertMetricsEdge => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExpertMetricsEdge');
    return {
        __typename: 'ExpertMetricsEdge',
        cursor: overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'perspiciatis',
        node: overrides && overrides.hasOwnProperty('node') ? overrides.node! : relationshipsToOmit.has('ExpertMetric') ? {} as ExpertMetric : anExpertMetric({}, relationshipsToOmit),
    };
};

export const anExpertSession = (overrides?: Partial<ExpertSession>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ExpertSession' } & ExpertSession => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExpertSession');
    return {
        __typename: 'ExpertSession',
        expert: overrides && overrides.hasOwnProperty('expert') ? overrides.expert! : relationshipsToOmit.has('Expert') ? {} as Expert : anExpert({}, relationshipsToOmit),
        hostApp: overrides && overrides.hasOwnProperty('hostApp') ? overrides.hostApp! : 'voluptates',
        hostAppId: overrides && overrides.hasOwnProperty('hostAppId') ? overrides.hostAppId! : 'nobis',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'cd24985b-f241-4a15-9974-bc5881af9691',
        supportedSkus: overrides && overrides.hasOwnProperty('supportedSkus') ? overrides.supportedSkus! : ['facere'],
    };
};

export const anExpertSessionsConnection = (overrides?: Partial<ExpertSessionsConnection>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ExpertSessionsConnection' } & ExpertSessionsConnection => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExpertSessionsConnection');
    return {
        __typename: 'ExpertSessionsConnection',
        edges: overrides && overrides.hasOwnProperty('edges') ? overrides.edges! : [relationshipsToOmit.has('ExpertSessionsEdge') ? {} as ExpertSessionsEdge : anExpertSessionsEdge({}, relationshipsToOmit)],
        pageInfo: overrides && overrides.hasOwnProperty('pageInfo') ? overrides.pageInfo! : relationshipsToOmit.has('PageInfo') ? {} as PageInfo : aPageInfo({}, relationshipsToOmit),
    };
};

export const anExpertSessionsEdge = (overrides?: Partial<ExpertSessionsEdge>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ExpertSessionsEdge' } & ExpertSessionsEdge => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExpertSessionsEdge');
    return {
        __typename: 'ExpertSessionsEdge',
        cursor: overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'facilis',
        node: overrides && overrides.hasOwnProperty('node') ? overrides.node! : relationshipsToOmit.has('ExpertSession') ? {} as ExpertSession : anExpertSession({}, relationshipsToOmit),
    };
};

export const anExpertsConnection = (overrides?: Partial<ExpertsConnection>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ExpertsConnection' } & ExpertsConnection => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExpertsConnection');
    return {
        __typename: 'ExpertsConnection',
        edges: overrides && overrides.hasOwnProperty('edges') ? overrides.edges! : [relationshipsToOmit.has('ExpertMetricsEdge') ? {} as ExpertMetricsEdge : anExpertMetricsEdge({}, relationshipsToOmit)],
        pageInfo: overrides && overrides.hasOwnProperty('pageInfo') ? overrides.pageInfo! : relationshipsToOmit.has('PageInfo') ? {} as PageInfo : aPageInfo({}, relationshipsToOmit),
    };
};

export const anExtension = (overrides?: Partial<Extension>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Extension' } & Extension => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Extension');
    return {
        __typename: 'Extension',
        code: overrides && overrides.hasOwnProperty('code') ? overrides.code! : ExtensionCode.AmEnrollmentDetails,
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'quam',
    };
};

export const anExtensionInput = (overrides?: Partial<ExtensionInput>, _relationshipsToOmit: Set<string> = new Set()): ExtensionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExtensionInput');
    return {
        code: overrides && overrides.hasOwnProperty('code') ? overrides.code! : ExtensionCode.AmEnrollmentDetails,
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'ut',
    };
};

export const anExternalClientAccount = (overrides?: Partial<ExternalClientAccount>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ExternalClientAccount' } & ExternalClientAccount => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExternalClientAccount');
    return {
        __typename: 'ExternalClientAccount',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '36a66ec1-9504-4883-a0cf-219753f8777a',
    };
};

export const anExternalSession = (overrides?: Partial<ExternalSession>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ExternalSession' } & ExternalSession => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExternalSession');
    return {
        __typename: 'ExternalSession',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '429dcbc4-4dcd-4af2-9a78-a0964e5aa66d',
    };
};

export const aFlexReservation = (overrides?: Partial<FlexReservation>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'FlexReservation' } & FlexReservation => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FlexReservation');
    return {
        __typename: 'FlexReservation',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '959618de-860e-4e72-aa83-ce85f1f85ea9',
    };
};

export const aFlexReservationInput = (overrides?: Partial<FlexReservationInput>, _relationshipsToOmit: Set<string> = new Set()): FlexReservationInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FlexReservationInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'a3fbf17a-4abb-4525-80c1-9c7d9080c7f2',
    };
};

export const aHorizonSession = (overrides?: Partial<HorizonSession>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'HorizonSession' } & HorizonSession => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('HorizonSession');
    return {
        __typename: 'HorizonSession',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'a19d2758-0423-4e2a-ad47-d0f1eece6b14',
    };
};

export const anIncrementAcceptInput = (overrides?: Partial<IncrementAcceptInput>, _relationshipsToOmit: Set<string> = new Set()): IncrementAcceptInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('IncrementAcceptInput');
    return {
        businessUnit: overrides && overrides.hasOwnProperty('businessUnit') ? overrides.businessUnit! : 'maxime',
        date: overrides && overrides.hasOwnProperty('date') ? overrides.date! : 'exercitationem',
        expertId: overrides && overrides.hasOwnProperty('expertId') ? overrides.expertId! : 'in',
        expertName: overrides && overrides.hasOwnProperty('expertName') ? overrides.expertName! : 'quia',
        managerId: overrides && overrides.hasOwnProperty('managerId') ? overrides.managerId! : 'autem',
        managerName: overrides && overrides.hasOwnProperty('managerName') ? overrides.managerName! : 'quam',
        productSKU: overrides && overrides.hasOwnProperty('productSKU') ? overrides.productSKU! : 'autem',
        site: overrides && overrides.hasOwnProperty('site') ? overrides.site! : 'porro',
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : 'doloribus',
        supervisorId: overrides && overrides.hasOwnProperty('supervisorId') ? overrides.supervisorId! : 'excepturi',
        supervisorName: overrides && overrides.hasOwnProperty('supervisorName') ? overrides.supervisorName! : 'doloribus',
    };
};

export const anIncrementAcceptPayload = (overrides?: Partial<IncrementAcceptPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'IncrementAcceptPayload' } & IncrementAcceptPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('IncrementAcceptPayload');
    return {
        __typename: 'IncrementAcceptPayload',
        success: overrides && overrides.hasOwnProperty('success') ? overrides.success! : true,
    };
};

export const anIncrementCustomerSessionInput = (overrides?: Partial<IncrementCustomerSessionInput>, _relationshipsToOmit: Set<string> = new Set()): IncrementCustomerSessionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('IncrementCustomerSessionInput');
    return {
        businessUnit: overrides && overrides.hasOwnProperty('businessUnit') ? overrides.businessUnit! : 'voluptas',
        date: overrides && overrides.hasOwnProperty('date') ? overrides.date! : 'et',
        expertId: overrides && overrides.hasOwnProperty('expertId') ? overrides.expertId! : 'voluptatem',
        expertName: overrides && overrides.hasOwnProperty('expertName') ? overrides.expertName! : 'quia',
        managerId: overrides && overrides.hasOwnProperty('managerId') ? overrides.managerId! : 'commodi',
        managerName: overrides && overrides.hasOwnProperty('managerName') ? overrides.managerName! : 'consequatur',
        productSKU: overrides && overrides.hasOwnProperty('productSKU') ? overrides.productSKU! : 'excepturi',
        site: overrides && overrides.hasOwnProperty('site') ? overrides.site! : 'eos',
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : 'deserunt',
        supervisorId: overrides && overrides.hasOwnProperty('supervisorId') ? overrides.supervisorId! : 'recusandae',
        supervisorName: overrides && overrides.hasOwnProperty('supervisorName') ? overrides.supervisorName! : 'et',
    };
};

export const anIncrementCustomerSessionPayload = (overrides?: Partial<IncrementCustomerSessionPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'IncrementCustomerSessionPayload' } & IncrementCustomerSessionPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('IncrementCustomerSessionPayload');
    return {
        __typename: 'IncrementCustomerSessionPayload',
        success: overrides && overrides.hasOwnProperty('success') ? overrides.success! : true,
    };
};

export const anIncrementEnrollmentInput = (overrides?: Partial<IncrementEnrollmentInput>, _relationshipsToOmit: Set<string> = new Set()): IncrementEnrollmentInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('IncrementEnrollmentInput');
    return {
        businessUnit: overrides && overrides.hasOwnProperty('businessUnit') ? overrides.businessUnit! : 'dignissimos',
        date: overrides && overrides.hasOwnProperty('date') ? overrides.date! : 'sint',
        expertId: overrides && overrides.hasOwnProperty('expertId') ? overrides.expertId! : 'quis',
        expertName: overrides && overrides.hasOwnProperty('expertName') ? overrides.expertName! : 'expedita',
        managerId: overrides && overrides.hasOwnProperty('managerId') ? overrides.managerId! : 'aut',
        managerName: overrides && overrides.hasOwnProperty('managerName') ? overrides.managerName! : 'nam',
        productSKU: overrides && overrides.hasOwnProperty('productSKU') ? overrides.productSKU! : 'adipisci',
        site: overrides && overrides.hasOwnProperty('site') ? overrides.site! : 'nostrum',
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : 'et',
        supervisorId: overrides && overrides.hasOwnProperty('supervisorId') ? overrides.supervisorId! : 'dolor',
        supervisorName: overrides && overrides.hasOwnProperty('supervisorName') ? overrides.supervisorName! : 'consequatur',
    };
};

export const anIncrementEnrollmentPayload = (overrides?: Partial<IncrementEnrollmentPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'IncrementEnrollmentPayload' } & IncrementEnrollmentPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('IncrementEnrollmentPayload');
    return {
        __typename: 'IncrementEnrollmentPayload',
        success: overrides && overrides.hasOwnProperty('success') ? overrides.success! : true,
    };
};

export const anIncrementOfferInput = (overrides?: Partial<IncrementOfferInput>, _relationshipsToOmit: Set<string> = new Set()): IncrementOfferInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('IncrementOfferInput');
    return {
        businessUnit: overrides && overrides.hasOwnProperty('businessUnit') ? overrides.businessUnit! : 'consectetur',
        date: overrides && overrides.hasOwnProperty('date') ? overrides.date! : 'autem',
        expertId: overrides && overrides.hasOwnProperty('expertId') ? overrides.expertId! : 'ut',
        expertName: overrides && overrides.hasOwnProperty('expertName') ? overrides.expertName! : 'eos',
        managerId: overrides && overrides.hasOwnProperty('managerId') ? overrides.managerId! : 'ut',
        managerName: overrides && overrides.hasOwnProperty('managerName') ? overrides.managerName! : 'sequi',
        productSKU: overrides && overrides.hasOwnProperty('productSKU') ? overrides.productSKU! : 'fugit',
        site: overrides && overrides.hasOwnProperty('site') ? overrides.site! : 'excepturi',
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : 'ea',
        supervisorId: overrides && overrides.hasOwnProperty('supervisorId') ? overrides.supervisorId! : 'ea',
        supervisorName: overrides && overrides.hasOwnProperty('supervisorName') ? overrides.supervisorName! : 'rerum',
    };
};

export const anIncrementOfferPayload = (overrides?: Partial<IncrementOfferPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'IncrementOfferPayload' } & IncrementOfferPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('IncrementOfferPayload');
    return {
        __typename: 'IncrementOfferPayload',
        success: overrides && overrides.hasOwnProperty('success') ? overrides.success! : false,
    };
};

export const anIncrementOpportunityInput = (overrides?: Partial<IncrementOpportunityInput>, _relationshipsToOmit: Set<string> = new Set()): IncrementOpportunityInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('IncrementOpportunityInput');
    return {
        businessUnit: overrides && overrides.hasOwnProperty('businessUnit') ? overrides.businessUnit! : 'sed',
        date: overrides && overrides.hasOwnProperty('date') ? overrides.date! : 'culpa',
        expertId: overrides && overrides.hasOwnProperty('expertId') ? overrides.expertId! : 'sunt',
        expertName: overrides && overrides.hasOwnProperty('expertName') ? overrides.expertName! : 'consequatur',
        managerId: overrides && overrides.hasOwnProperty('managerId') ? overrides.managerId! : 'at',
        managerName: overrides && overrides.hasOwnProperty('managerName') ? overrides.managerName! : 'facilis',
        productSKU: overrides && overrides.hasOwnProperty('productSKU') ? overrides.productSKU! : 'sunt',
        site: overrides && overrides.hasOwnProperty('site') ? overrides.site! : 'quis',
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : 'quas',
        supervisorId: overrides && overrides.hasOwnProperty('supervisorId') ? overrides.supervisorId! : 'dignissimos',
        supervisorName: overrides && overrides.hasOwnProperty('supervisorName') ? overrides.supervisorName! : 'aut',
    };
};

export const anIncrementOpportunityPayload = (overrides?: Partial<IncrementOpportunityPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'IncrementOpportunityPayload' } & IncrementOpportunityPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('IncrementOpportunityPayload');
    return {
        __typename: 'IncrementOpportunityPayload',
        success: overrides && overrides.hasOwnProperty('success') ? overrides.success! : true,
    };
};

export const anIncrementSearchInput = (overrides?: Partial<IncrementSearchInput>, _relationshipsToOmit: Set<string> = new Set()): IncrementSearchInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('IncrementSearchInput');
    return {
        businessUnit: overrides && overrides.hasOwnProperty('businessUnit') ? overrides.businessUnit! : 'quas',
        date: overrides && overrides.hasOwnProperty('date') ? overrides.date! : 'illo',
        expertId: overrides && overrides.hasOwnProperty('expertId') ? overrides.expertId! : 'quis',
        expertName: overrides && overrides.hasOwnProperty('expertName') ? overrides.expertName! : 'et',
        managerId: overrides && overrides.hasOwnProperty('managerId') ? overrides.managerId! : 'delectus',
        managerName: overrides && overrides.hasOwnProperty('managerName') ? overrides.managerName! : 'laudantium',
        site: overrides && overrides.hasOwnProperty('site') ? overrides.site! : 'eos',
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : 'ducimus',
        supervisorId: overrides && overrides.hasOwnProperty('supervisorId') ? overrides.supervisorId! : 'quia',
        supervisorName: overrides && overrides.hasOwnProperty('supervisorName') ? overrides.supervisorName! : 'iste',
    };
};

export const anIncrementSearchPayload = (overrides?: Partial<IncrementSearchPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'IncrementSearchPayload' } & IncrementSearchPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('IncrementSearchPayload');
    return {
        __typename: 'IncrementSearchPayload',
        success: overrides && overrides.hasOwnProperty('success') ? overrides.success! : false,
    };
};

export const anInterval = (overrides?: Partial<Interval>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Interval' } & Interval => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Interval');
    return {
        __typename: 'Interval',
        end: overrides && overrides.hasOwnProperty('end') ? overrides.end! : 'eius',
        start: overrides && overrides.hasOwnProperty('start') ? overrides.start! : 'blanditiis',
    };
};

export const aManager = (overrides?: Partial<Manager>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Manager' } & Manager => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Manager');
    return {
        __typename: 'Manager',
        businessUnit: overrides && overrides.hasOwnProperty('businessUnit') ? overrides.businessUnit! : 'eveniet',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '6467d2ba-b3d6-4693-ac4e-7c64932e1487',
        managerId: overrides && overrides.hasOwnProperty('managerId') ? overrides.managerId! : 'id',
        managerName: overrides && overrides.hasOwnProperty('managerName') ? overrides.managerName! : 'numquam',
        site: overrides && overrides.hasOwnProperty('site') ? overrides.site! : 'nisi',
    };
};

export const aManagersConnection = (overrides?: Partial<ManagersConnection>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ManagersConnection' } & ManagersConnection => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ManagersConnection');
    return {
        __typename: 'ManagersConnection',
        edges: overrides && overrides.hasOwnProperty('edges') ? overrides.edges! : [relationshipsToOmit.has('ManagersEdge') ? {} as ManagersEdge : aManagersEdge({}, relationshipsToOmit)],
        pageInfo: overrides && overrides.hasOwnProperty('pageInfo') ? overrides.pageInfo! : relationshipsToOmit.has('PageInfo') ? {} as PageInfo : aPageInfo({}, relationshipsToOmit),
    };
};

export const aManagersEdge = (overrides?: Partial<ManagersEdge>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ManagersEdge' } & ManagersEdge => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ManagersEdge');
    return {
        __typename: 'ManagersEdge',
        cursor: overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'officiis',
        node: overrides && overrides.hasOwnProperty('node') ? overrides.node! : relationshipsToOmit.has('Manager') ? {} as Manager : aManager({}, relationshipsToOmit),
    };
};

export const aMarketing = (overrides?: Partial<Marketing>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Marketing' } & Marketing => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Marketing');
    return {
        __typename: 'Marketing',
        dealerCode: overrides && overrides.hasOwnProperty('dealerCode') ? overrides.dealerCode! : 'aut',
        dealerName: overrides && overrides.hasOwnProperty('dealerName') ? overrides.dealerName! : 'doloribus',
        promoCode: overrides && overrides.hasOwnProperty('promoCode') ? overrides.promoCode! : 'rerum',
        referralPartner: overrides && overrides.hasOwnProperty('referralPartner') ? overrides.referralPartner! : 'provident',
        referrerCode: overrides && overrides.hasOwnProperty('referrerCode') ? overrides.referrerCode! : 'qui',
        salesChannel: overrides && overrides.hasOwnProperty('salesChannel') ? overrides.salesChannel! : 'doloribus',
        salesPersonId: overrides && overrides.hasOwnProperty('salesPersonId') ? overrides.salesPersonId! : 'explicabo',
        salesSessionId: overrides && overrides.hasOwnProperty('salesSessionId') ? overrides.salesSessionId! : 'ipsam',
        storeCode: overrides && overrides.hasOwnProperty('storeCode') ? overrides.storeCode! : 'magni',
        utmParams: overrides && overrides.hasOwnProperty('utmParams') ? overrides.utmParams! : relationshipsToOmit.has('UtmParams') ? {} as UtmParams : anUtmParams({}, relationshipsToOmit),
        vendorData: overrides && overrides.hasOwnProperty('vendorData') ? overrides.vendorData! : 'repudiandae',
    };
};

export const aMarketingInput = (overrides?: Partial<MarketingInput>, _relationshipsToOmit: Set<string> = new Set()): MarketingInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MarketingInput');
    return {
        dealerCode: overrides && overrides.hasOwnProperty('dealerCode') ? overrides.dealerCode! : 'est',
        dealerName: overrides && overrides.hasOwnProperty('dealerName') ? overrides.dealerName! : 'tempora',
        promoCode: overrides && overrides.hasOwnProperty('promoCode') ? overrides.promoCode! : 'vel',
        referralPartner: overrides && overrides.hasOwnProperty('referralPartner') ? overrides.referralPartner! : 'error',
        referrerCode: overrides && overrides.hasOwnProperty('referrerCode') ? overrides.referrerCode! : 'aut',
        salesChannel: overrides && overrides.hasOwnProperty('salesChannel') ? overrides.salesChannel! : 'dignissimos',
        salesPersonId: overrides && overrides.hasOwnProperty('salesPersonId') ? overrides.salesPersonId! : 'quasi',
        salesSessionId: overrides && overrides.hasOwnProperty('salesSessionId') ? overrides.salesSessionId! : 'sunt',
        storeCode: overrides && overrides.hasOwnProperty('storeCode') ? overrides.storeCode! : 'praesentium',
        utmParams: overrides && overrides.hasOwnProperty('utmParams') ? overrides.utmParams! : relationshipsToOmit.has('UtmParamsInput') ? {} as UtmParamsInput : anUtmParamsInput({}, relationshipsToOmit),
        vendorData: overrides && overrides.hasOwnProperty('vendorData') ? overrides.vendorData! : 'exercitationem',
    };
};

export const aMdnVerification = (overrides?: Partial<MdnVerification>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'MdnVerification' } & MdnVerification => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MdnVerification');
    return {
        __typename: 'MdnVerification',
        accessToken: overrides && overrides.hasOwnProperty('accessToken') ? overrides.accessToken! : 'dolor',
        attemptsRemaining: overrides && overrides.hasOwnProperty('attemptsRemaining') ? overrides.attemptsRemaining! : 971,
        expiration: overrides && overrides.hasOwnProperty('expiration') ? overrides.expiration! : 'voluptas',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'f90e8cda-b791-40c9-9860-456b30b9529c',
        refreshToken: overrides && overrides.hasOwnProperty('refreshToken') ? overrides.refreshToken! : 'quasi',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : MdnVerificationStatus.Failed,
        transactionId: overrides && overrides.hasOwnProperty('transactionId') ? overrides.transactionId! : 'sapiente',
    };
};

export const aMutation = (overrides?: Partial<Mutation>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Mutation' } & Mutation => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Mutation');
    return {
        __typename: 'Mutation',
        addExpertSession: overrides && overrides.hasOwnProperty('addExpertSession') ? overrides.addExpertSession! : relationshipsToOmit.has('AddExpertSessionSuccessPayload') ? {} as AddExpertSessionSuccessPayload : anAddExpertSessionSuccessPayload({}, relationshipsToOmit),
        createBilling: overrides && overrides.hasOwnProperty('createBilling') ? overrides.createBilling! : relationshipsToOmit.has('BaseError') ? {} as BaseError : aBaseError({}, relationshipsToOmit),
        createBillingDiscounts: overrides && overrides.hasOwnProperty('createBillingDiscounts') ? overrides.createBillingDiscounts! : relationshipsToOmit.has('BaseError') ? {} as BaseError : aBaseError({}, relationshipsToOmit),
        createCommunication: overrides && overrides.hasOwnProperty('createCommunication') ? overrides.createCommunication! : relationshipsToOmit.has('BaseError') ? {} as BaseError : aBaseError({}, relationshipsToOmit),
        createCpfVerification: overrides && overrides.hasOwnProperty('createCpfVerification') ? overrides.createCpfVerification! : relationshipsToOmit.has('BaseError') ? {} as BaseError : aBaseError({}, relationshipsToOmit),
        createCustomerSession: overrides && overrides.hasOwnProperty('createCustomerSession') ? overrides.createCustomerSession! : relationshipsToOmit.has('BaseError') ? {} as BaseError : aBaseError({}, relationshipsToOmit),
        createExpertSession: overrides && overrides.hasOwnProperty('createExpertSession') ? overrides.createExpertSession! : relationshipsToOmit.has('BaseError') ? {} as BaseError : aBaseError({}, relationshipsToOmit),
        createMdnVerification: overrides && overrides.hasOwnProperty('createMdnVerification') ? overrides.createMdnVerification! : relationshipsToOmit.has('BaseError') ? {} as BaseError : aBaseError({}, relationshipsToOmit),
        createPaySession: overrides && overrides.hasOwnProperty('createPaySession') ? overrides.createPaySession! : relationshipsToOmit.has('BaseError') ? {} as BaseError : aBaseError({}, relationshipsToOmit),
        createProductDeclination: overrides && overrides.hasOwnProperty('createProductDeclination') ? overrides.createProductDeclination! : relationshipsToOmit.has('BaseError') ? {} as BaseError : aBaseError({}, relationshipsToOmit),
        createProductEnrollment: overrides && overrides.hasOwnProperty('createProductEnrollment') ? overrides.createProductEnrollment! : relationshipsToOmit.has('BaseError') ? {} as BaseError : aBaseError({}, relationshipsToOmit),
        createProductOffer: overrides && overrides.hasOwnProperty('createProductOffer') ? overrides.createProductOffer! : relationshipsToOmit.has('BaseError') ? {} as BaseError : aBaseError({}, relationshipsToOmit),
        deleteCustomerSession: overrides && overrides.hasOwnProperty('deleteCustomerSession') ? overrides.deleteCustomerSession! : relationshipsToOmit.has('BaseError') ? {} as BaseError : aBaseError({}, relationshipsToOmit),
        deleteProductOffer: overrides && overrides.hasOwnProperty('deleteProductOffer') ? overrides.deleteProductOffer! : relationshipsToOmit.has('BaseError') ? {} as BaseError : aBaseError({}, relationshipsToOmit),
        generateSmartLink: overrides && overrides.hasOwnProperty('generateSmartLink') ? overrides.generateSmartLink! : relationshipsToOmit.has('SmartLinkResponse') ? {} as SmartLinkResponse : aSmartLinkResponse({}, relationshipsToOmit),
        incrementAccept: overrides && overrides.hasOwnProperty('incrementAccept') ? overrides.incrementAccept! : relationshipsToOmit.has('IncrementAcceptPayload') ? {} as IncrementAcceptPayload : anIncrementAcceptPayload({}, relationshipsToOmit),
        incrementCustomerSession: overrides && overrides.hasOwnProperty('incrementCustomerSession') ? overrides.incrementCustomerSession! : relationshipsToOmit.has('IncrementCustomerSessionPayload') ? {} as IncrementCustomerSessionPayload : anIncrementCustomerSessionPayload({}, relationshipsToOmit),
        incrementEnrollment: overrides && overrides.hasOwnProperty('incrementEnrollment') ? overrides.incrementEnrollment! : relationshipsToOmit.has('IncrementEnrollmentPayload') ? {} as IncrementEnrollmentPayload : anIncrementEnrollmentPayload({}, relationshipsToOmit),
        incrementOffer: overrides && overrides.hasOwnProperty('incrementOffer') ? overrides.incrementOffer! : relationshipsToOmit.has('IncrementOfferPayload') ? {} as IncrementOfferPayload : anIncrementOfferPayload({}, relationshipsToOmit),
        incrementOpportunity: overrides && overrides.hasOwnProperty('incrementOpportunity') ? overrides.incrementOpportunity! : relationshipsToOmit.has('IncrementOpportunityPayload') ? {} as IncrementOpportunityPayload : anIncrementOpportunityPayload({}, relationshipsToOmit),
        incrementSearch: overrides && overrides.hasOwnProperty('incrementSearch') ? overrides.incrementSearch! : relationshipsToOmit.has('IncrementSearchPayload') ? {} as IncrementSearchPayload : anIncrementSearchPayload({}, relationshipsToOmit),
        updateBilling: overrides && overrides.hasOwnProperty('updateBilling') ? overrides.updateBilling! : relationshipsToOmit.has('BaseError') ? {} as BaseError : aBaseError({}, relationshipsToOmit),
        updateCommunication: overrides && overrides.hasOwnProperty('updateCommunication') ? overrides.updateCommunication! : relationshipsToOmit.has('BaseError') ? {} as BaseError : aBaseError({}, relationshipsToOmit),
        updateCpfVerification: overrides && overrides.hasOwnProperty('updateCpfVerification') ? overrides.updateCpfVerification! : relationshipsToOmit.has('BaseError') ? {} as BaseError : aBaseError({}, relationshipsToOmit),
        updateCustomer: overrides && overrides.hasOwnProperty('updateCustomer') ? overrides.updateCustomer! : relationshipsToOmit.has('BaseError') ? {} as BaseError : aBaseError({}, relationshipsToOmit),
        updateCustomerSession: overrides && overrides.hasOwnProperty('updateCustomerSession') ? overrides.updateCustomerSession! : relationshipsToOmit.has('BaseError') ? {} as BaseError : aBaseError({}, relationshipsToOmit),
        updateCustomerSessions: overrides && overrides.hasOwnProperty('updateCustomerSessions') ? overrides.updateCustomerSessions! : relationshipsToOmit.has('BaseError') ? {} as BaseError : aBaseError({}, relationshipsToOmit),
        updateExpertOrgChartData: overrides && overrides.hasOwnProperty('updateExpertOrgChartData') ? overrides.updateExpertOrgChartData! : relationshipsToOmit.has('BaseError') ? {} as BaseError : aBaseError({}, relationshipsToOmit),
        updateExpertSession: overrides && overrides.hasOwnProperty('updateExpertSession') ? overrides.updateExpertSession! : relationshipsToOmit.has('BaseError') ? {} as BaseError : aBaseError({}, relationshipsToOmit),
        updateMdnVerification: overrides && overrides.hasOwnProperty('updateMdnVerification') ? overrides.updateMdnVerification! : relationshipsToOmit.has('BaseError') ? {} as BaseError : aBaseError({}, relationshipsToOmit),
        updatePaySession: overrides && overrides.hasOwnProperty('updatePaySession') ? overrides.updatePaySession! : relationshipsToOmit.has('BaseError') ? {} as BaseError : aBaseError({}, relationshipsToOmit),
        updateProductEligibility: overrides && overrides.hasOwnProperty('updateProductEligibility') ? overrides.updateProductEligibility! : relationshipsToOmit.has('BaseError') ? {} as BaseError : aBaseError({}, relationshipsToOmit),
        updateProductEnrollment: overrides && overrides.hasOwnProperty('updateProductEnrollment') ? overrides.updateProductEnrollment! : relationshipsToOmit.has('BaseError') ? {} as BaseError : aBaseError({}, relationshipsToOmit),
        updateProductOffer: overrides && overrides.hasOwnProperty('updateProductOffer') ? overrides.updateProductOffer! : relationshipsToOmit.has('BaseError') ? {} as BaseError : aBaseError({}, relationshipsToOmit),
        updateSalesConfig: overrides && overrides.hasOwnProperty('updateSalesConfig') ? overrides.updateSalesConfig! : 'aut',
    };
};

export const aNode = (overrides?: Partial<Node>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Node' } & Node => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Node');
    return {
        __typename: 'Node',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '95bb2f34-6c86-495f-bfdc-f25b025cdba5',
    };
};

export const aNotFoundError = (overrides?: Partial<NotFoundError>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'NotFoundError' } & NotFoundError => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('NotFoundError');
    return {
        __typename: 'NotFoundError',
        message: overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'voluptatum',
    };
};

export const aPageInfo = (overrides?: Partial<PageInfo>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'PageInfo' } & PageInfo => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PageInfo');
    return {
        __typename: 'PageInfo',
        endCursor: overrides && overrides.hasOwnProperty('endCursor') ? overrides.endCursor! : 'id',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : true,
        hasPreviousPage: overrides && overrides.hasOwnProperty('hasPreviousPage') ? overrides.hasPreviousPage! : false,
        startCursor: overrides && overrides.hasOwnProperty('startCursor') ? overrides.startCursor! : 'eum',
    };
};

export const aPaySession = (overrides?: Partial<PaySession>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'PaySession' } & PaySession => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PaySession');
    return {
        __typename: 'PaySession',
        billingFrequencyInMonths: overrides && overrides.hasOwnProperty('billingFrequencyInMonths') ? overrides.billingFrequencyInMonths! : 'eaque',
        billingGatewaySessionId: overrides && overrides.hasOwnProperty('billingGatewaySessionId') ? overrides.billingGatewaySessionId! : 'recusandae',
        billingToken: overrides && overrides.hasOwnProperty('billingToken') ? overrides.billingToken! : 'corrupti',
        brand: overrides && overrides.hasOwnProperty('brand') ? overrides.brand! : 'commodi',
        encryptionKey: overrides && overrides.hasOwnProperty('encryptionKey') ? overrides.encryptionKey! : 'aut',
        expirationMonth: overrides && overrides.hasOwnProperty('expirationMonth') ? overrides.expirationMonth! : 'quibusdam',
        expirationYear: overrides && overrides.hasOwnProperty('expirationYear') ? overrides.expirationYear! : 'eligendi',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '58eabe8c-b284-4828-86b1-0721a416d935',
        lastFour: overrides && overrides.hasOwnProperty('lastFour') ? overrides.lastFour! : 'eum',
        payMethodId: overrides && overrides.hasOwnProperty('payMethodId') ? overrides.payMethodId! : 'qui',
        paymentLink: overrides && overrides.hasOwnProperty('paymentLink') ? overrides.paymentLink! : 'minus',
        paymentType: overrides && overrides.hasOwnProperty('paymentType') ? overrides.paymentType! : PaymentType.Bta,
        productPaidFrequency: overrides && overrides.hasOwnProperty('productPaidFrequency') ? overrides.productPaidFrequency! : 'pariatur',
        productSku: overrides && overrides.hasOwnProperty('productSku') ? overrides.productSku! : 'laboriosam',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : PaySessionStatus.Authorized,
        transactionType: overrides && overrides.hasOwnProperty('transactionType') ? overrides.transactionType! : TransactionType.AgentAssisted,
    };
};

export const aProduct = (overrides?: Partial<Product>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Product' } & Product => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Product');
    return {
        __typename: 'Product',
        sku: overrides && overrides.hasOwnProperty('sku') ? overrides.sku! : 'corrupti',
    };
};

export const aProductDeclination = (overrides?: Partial<ProductDeclination>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ProductDeclination' } & ProductDeclination => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ProductDeclination');
    return {
        __typename: 'ProductDeclination',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '0b270b95-eecd-470f-94df-6db9467266fe',
        reason: overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : 'et',
    };
};

export const aProductEligibility = (overrides?: Partial<ProductEligibility>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ProductEligibility' } & ProductEligibility => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ProductEligibility');
    return {
        __typename: 'ProductEligibility',
        extensions: overrides && overrides.hasOwnProperty('extensions') ? overrides.extensions! : [relationshipsToOmit.has('Extension') ? {} as Extension : anExtension({}, relationshipsToOmit)],
        externalEligibilityId: overrides && overrides.hasOwnProperty('externalEligibilityId') ? overrides.externalEligibilityId! : 'enim',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '84246fae-e4b6-4703-8480-8e3320401423',
        reason: overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : 'dolores',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : ProductEligibilityStatus.AlreadyEnrolled,
        subscriptionNumber: overrides && overrides.hasOwnProperty('subscriptionNumber') ? overrides.subscriptionNumber! : 'vero',
    };
};

export const aProductEnrollment = (overrides?: Partial<ProductEnrollment>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ProductEnrollment' } & ProductEnrollment => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ProductEnrollment');
    return {
        __typename: 'ProductEnrollment',
        additionalData: overrides && overrides.hasOwnProperty('additionalData') ? overrides.additionalData! : 'aut',
        confirmationCode: overrides && overrides.hasOwnProperty('confirmationCode') ? overrides.confirmationCode! : 'iste',
        error: overrides && overrides.hasOwnProperty('error') ? overrides.error! : relationshipsToOmit.has('ProductEnrollmentError') ? {} as ProductEnrollmentError : aProductEnrollmentError({}, relationshipsToOmit),
        externalReferenceId: overrides && overrides.hasOwnProperty('externalReferenceId') ? overrides.externalReferenceId! : 'enim',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '1f8780c9-e612-4d1b-9f1b-98fed2a7e1bd',
        lastModified: overrides && overrides.hasOwnProperty('lastModified') ? overrides.lastModified! : 'repellendus',
        paySessionId: overrides && overrides.hasOwnProperty('paySessionId') ? overrides.paySessionId! : 'b39dea65-b2cb-499a-9c73-45ec42b79b1d',
        planId: overrides && overrides.hasOwnProperty('planId') ? overrides.planId! : '848ac927-fe73-4b7d-b426-0ed5aa92b912',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : ProductEnrollmentStatus.Failure,
    };
};

export const aProductEnrollmentError = (overrides?: Partial<ProductEnrollmentError>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ProductEnrollmentError' } & ProductEnrollmentError => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ProductEnrollmentError');
    return {
        __typename: 'ProductEnrollmentError',
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : ProductEnrollmentErrorCategory.AlreadyEnrolled,
        code: overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'corporis',
        message: overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'dolor',
    };
};

export const aProductEnrollmentErrorInput = (overrides?: Partial<ProductEnrollmentErrorInput>, _relationshipsToOmit: Set<string> = new Set()): ProductEnrollmentErrorInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ProductEnrollmentErrorInput');
    return {
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : ProductEnrollmentErrorCategory.AlreadyEnrolled,
        code: overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'temporibus',
        message: overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'error',
    };
};

export const aProductMetrics = (overrides?: Partial<ProductMetrics>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ProductMetrics' } & ProductMetrics => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ProductMetrics');
    return {
        __typename: 'ProductMetrics',
        businessUnits: overrides && overrides.hasOwnProperty('businessUnits') ? overrides.businessUnits! : relationshipsToOmit.has('BusinessUnitsConnection') ? {} as BusinessUnitsConnection : aBusinessUnitsConnection({}, relationshipsToOmit),
        experts: overrides && overrides.hasOwnProperty('experts') ? overrides.experts! : relationshipsToOmit.has('ExpertsConnection') ? {} as ExpertsConnection : anExpertsConnection({}, relationshipsToOmit),
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '4c961669-3a4a-4bd1-a69b-6551b91e1ac2',
        interval: overrides && overrides.hasOwnProperty('interval') ? overrides.interval! : relationshipsToOmit.has('Interval') ? {} as Interval : anInterval({}, relationshipsToOmit),
        managers: overrides && overrides.hasOwnProperty('managers') ? overrides.managers! : relationshipsToOmit.has('ManagersConnection') ? {} as ManagersConnection : aManagersConnection({}, relationshipsToOmit),
        product: overrides && overrides.hasOwnProperty('product') ? overrides.product! : relationshipsToOmit.has('Product') ? {} as Product : aProduct({}, relationshipsToOmit),
        sites: overrides && overrides.hasOwnProperty('sites') ? overrides.sites! : relationshipsToOmit.has('SitesConnection') ? {} as SitesConnection : aSitesConnection({}, relationshipsToOmit),
        supervisors: overrides && overrides.hasOwnProperty('supervisors') ? overrides.supervisors! : relationshipsToOmit.has('SupervisorsConnection') ? {} as SupervisorsConnection : aSupervisorsConnection({}, relationshipsToOmit),
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : relationshipsToOmit.has('SalesMetric') ? {} as SalesMetric : aSalesMetric({}, relationshipsToOmit),
    };
};

export const aProductOffer = (overrides?: Partial<ProductOffer>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ProductOffer' } & ProductOffer => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ProductOffer');
    return {
        __typename: 'ProductOffer',
        billingDiscounts: overrides && overrides.hasOwnProperty('billingDiscounts') ? overrides.billingDiscounts! : [relationshipsToOmit.has('BillingDiscount') ? {} as BillingDiscount : aBillingDiscount({}, relationshipsToOmit)],
        customerMdn: overrides && overrides.hasOwnProperty('customerMdn') ? overrides.customerMdn! : 'facere',
        customerSession: overrides && overrides.hasOwnProperty('customerSession') ? overrides.customerSession! : relationshipsToOmit.has('CustomerSession') ? {} as CustomerSession : aCustomerSession({}, relationshipsToOmit),
        disclosureStatus: overrides && overrides.hasOwnProperty('disclosureStatus') ? overrides.disclosureStatus! : TransmittedDisclosureStatus.Accepted,
        expertSession: overrides && overrides.hasOwnProperty('expertSession') ? overrides.expertSession! : relationshipsToOmit.has('ExpertSession') ? {} as ExpertSession : anExpertSession({}, relationshipsToOmit),
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'defac3c7-57da-4748-a40d-4417ad06bb86',
        linkId: overrides && overrides.hasOwnProperty('linkId') ? overrides.linkId! : 'id',
        partner: overrides && overrides.hasOwnProperty('partner') ? overrides.partner! : 'explicabo',
        productDeclination: overrides && overrides.hasOwnProperty('productDeclination') ? overrides.productDeclination! : relationshipsToOmit.has('ProductDeclination') ? {} as ProductDeclination : aProductDeclination({}, relationshipsToOmit),
        productEligibility: overrides && overrides.hasOwnProperty('productEligibility') ? overrides.productEligibility! : relationshipsToOmit.has('ProductEligibility') ? {} as ProductEligibility : aProductEligibility({}, relationshipsToOmit),
        productEnrollment: overrides && overrides.hasOwnProperty('productEnrollment') ? overrides.productEnrollment! : relationshipsToOmit.has('ProductEnrollment') ? {} as ProductEnrollment : aProductEnrollment({}, relationshipsToOmit),
        productSku: overrides && overrides.hasOwnProperty('productSku') ? overrides.productSku! : 'consequatur',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : ProductOfferStatus.Accepted,
        taxAmount: overrides && overrides.hasOwnProperty('taxAmount') ? overrides.taxAmount! : 'sint',
    };
};

export const aQuery = (overrides?: Partial<Query>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Query' } & Query => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Query');
    return {
        __typename: 'Query',
        customerSession: overrides && overrides.hasOwnProperty('customerSession') ? overrides.customerSession! : relationshipsToOmit.has('CustomerSession') ? {} as CustomerSession : aCustomerSession({}, relationshipsToOmit),
        customerSessions: overrides && overrides.hasOwnProperty('customerSessions') ? overrides.customerSessions! : [relationshipsToOmit.has('CustomerSession') ? {} as CustomerSession : aCustomerSession({}, relationshipsToOmit)],
        customerSessionsByExternalSessionId: overrides && overrides.hasOwnProperty('customerSessionsByExternalSessionId') ? overrides.customerSessionsByExternalSessionId! : [relationshipsToOmit.has('CustomerSession') ? {} as CustomerSession : aCustomerSession({}, relationshipsToOmit)],
        expertMetric: overrides && overrides.hasOwnProperty('expertMetric') ? overrides.expertMetric! : relationshipsToOmit.has('ExpertMetric') ? {} as ExpertMetric : anExpertMetric({}, relationshipsToOmit),
        expertSession: overrides && overrides.hasOwnProperty('expertSession') ? overrides.expertSession! : relationshipsToOmit.has('ExpertSession') ? {} as ExpertSession : anExpertSession({}, relationshipsToOmit),
        expertSessions: overrides && overrides.hasOwnProperty('expertSessions') ? overrides.expertSessions! : relationshipsToOmit.has('ExpertSessionsConnection') ? {} as ExpertSessionsConnection : anExpertSessionsConnection({}, relationshipsToOmit),
        metrics: overrides && overrides.hasOwnProperty('metrics') ? overrides.metrics! : relationshipsToOmit.has('ProductMetrics') ? {} as ProductMetrics : aProductMetrics({}, relationshipsToOmit),
        productOffer: overrides && overrides.hasOwnProperty('productOffer') ? overrides.productOffer! : relationshipsToOmit.has('ProductOffer') ? {} as ProductOffer : aProductOffer({}, relationshipsToOmit),
        productOffersByCustomerSessionId: overrides && overrides.hasOwnProperty('productOffersByCustomerSessionId') ? overrides.productOffersByCustomerSessionId! : [relationshipsToOmit.has('ProductOffer') ? {} as ProductOffer : aProductOffer({}, relationshipsToOmit)],
        salesConfig: overrides && overrides.hasOwnProperty('salesConfig') ? overrides.salesConfig! : 'et',
    };
};

export const aSalesMetric = (overrides?: Partial<SalesMetric>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SalesMetric' } & SalesMetric => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SalesMetric');
    return {
        __typename: 'SalesMetric',
        acceptRate: overrides && overrides.hasOwnProperty('acceptRate') ? overrides.acceptRate! : 8.91,
        accepts: overrides && overrides.hasOwnProperty('accepts') ? overrides.accepts! : 3829,
        customerSessions: overrides && overrides.hasOwnProperty('customerSessions') ? overrides.customerSessions! : 1039,
        enrollmentRate: overrides && overrides.hasOwnProperty('enrollmentRate') ? overrides.enrollmentRate! : 7.73,
        enrollments: overrides && overrides.hasOwnProperty('enrollments') ? overrides.enrollments! : 8956,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '45d1c9fb-7342-4148-b76f-f54d61fcfbcd',
        offerRate: overrides && overrides.hasOwnProperty('offerRate') ? overrides.offerRate! : 4.63,
        offers: overrides && overrides.hasOwnProperty('offers') ? overrides.offers! : 7085,
        opportunities: overrides && overrides.hasOwnProperty('opportunities') ? overrides.opportunities! : 5066,
        searches: overrides && overrides.hasOwnProperty('searches') ? overrides.searches! : 1761,
        sessionOfferRate: overrides && overrides.hasOwnProperty('sessionOfferRate') ? overrides.sessionOfferRate! : 9.93,
    };
};

export const aSite = (overrides?: Partial<Site>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Site' } & Site => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Site');
    return {
        __typename: 'Site',
        businessUnit: overrides && overrides.hasOwnProperty('businessUnit') ? overrides.businessUnit! : 'et',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'd7cf1c40-3cf8-44b4-8964-677e980f4494',
        metrics: overrides && overrides.hasOwnProperty('metrics') ? overrides.metrics! : relationshipsToOmit.has('SalesMetric') ? {} as SalesMetric : aSalesMetric({}, relationshipsToOmit),
        site: overrides && overrides.hasOwnProperty('site') ? overrides.site! : 'molestiae',
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : 'voluptatem',
    };
};

export const aSitesConnection = (overrides?: Partial<SitesConnection>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SitesConnection' } & SitesConnection => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SitesConnection');
    return {
        __typename: 'SitesConnection',
        edges: overrides && overrides.hasOwnProperty('edges') ? overrides.edges! : [relationshipsToOmit.has('SitesEdge') ? {} as SitesEdge : aSitesEdge({}, relationshipsToOmit)],
        pageInfo: overrides && overrides.hasOwnProperty('pageInfo') ? overrides.pageInfo! : relationshipsToOmit.has('PageInfo') ? {} as PageInfo : aPageInfo({}, relationshipsToOmit),
    };
};

export const aSitesEdge = (overrides?: Partial<SitesEdge>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SitesEdge' } & SitesEdge => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SitesEdge');
    return {
        __typename: 'SitesEdge',
        cursor: overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'modi',
        node: overrides && overrides.hasOwnProperty('node') ? overrides.node! : relationshipsToOmit.has('Site') ? {} as Site : aSite({}, relationshipsToOmit),
    };
};

export const aSmartLinkResponse = (overrides?: Partial<SmartLinkResponse>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SmartLinkResponse' } & SmartLinkResponse => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SmartLinkResponse');
    return {
        __typename: 'SmartLinkResponse',
        expires_at: overrides && overrides.hasOwnProperty('expires_at') ? overrides.expires_at! : 'rem',
        link: overrides && overrides.hasOwnProperty('link') ? overrides.link! : 'maiores',
        link_id: overrides && overrides.hasOwnProperty('link_id') ? overrides.link_id! : 'dolorem',
        render_billing_page: overrides && overrides.hasOwnProperty('render_billing_page') ? overrides.render_billing_page! : false,
    };
};

export const aSubscription = (overrides?: Partial<Subscription>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Subscription' } & Subscription => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Subscription');
    return {
        __typename: 'Subscription',
        customerSessionCreated: overrides && overrides.hasOwnProperty('customerSessionCreated') ? overrides.customerSessionCreated! : relationshipsToOmit.has('CustomerSession') ? {} as CustomerSession : aCustomerSession({}, relationshipsToOmit),
        customerSessionUpdated: overrides && overrides.hasOwnProperty('customerSessionUpdated') ? overrides.customerSessionUpdated! : relationshipsToOmit.has('CustomerSession') ? {} as CustomerSession : aCustomerSession({}, relationshipsToOmit),
        mdnVerificationUpdated: overrides && overrides.hasOwnProperty('mdnVerificationUpdated') ? overrides.mdnVerificationUpdated! : relationshipsToOmit.has('MdnVerification') ? {} as MdnVerification : aMdnVerification({}, relationshipsToOmit),
        paySessionUpdated: overrides && overrides.hasOwnProperty('paySessionUpdated') ? overrides.paySessionUpdated! : relationshipsToOmit.has('PaySession') ? {} as PaySession : aPaySession({}, relationshipsToOmit),
        productEligibilityCreated: overrides && overrides.hasOwnProperty('productEligibilityCreated') ? overrides.productEligibilityCreated! : relationshipsToOmit.has('ProductEligibility') ? {} as ProductEligibility : aProductEligibility({}, relationshipsToOmit),
        productEligibilityUpdated: overrides && overrides.hasOwnProperty('productEligibilityUpdated') ? overrides.productEligibilityUpdated! : relationshipsToOmit.has('ProductEligibility') ? {} as ProductEligibility : aProductEligibility({}, relationshipsToOmit),
        productEnrollmentCreated: overrides && overrides.hasOwnProperty('productEnrollmentCreated') ? overrides.productEnrollmentCreated! : relationshipsToOmit.has('ProductEnrollment') ? {} as ProductEnrollment : aProductEnrollment({}, relationshipsToOmit),
        productEnrollmentUpdated: overrides && overrides.hasOwnProperty('productEnrollmentUpdated') ? overrides.productEnrollmentUpdated! : relationshipsToOmit.has('ProductEnrollment') ? {} as ProductEnrollment : aProductEnrollment({}, relationshipsToOmit),
        productOfferCreated: overrides && overrides.hasOwnProperty('productOfferCreated') ? overrides.productOfferCreated! : relationshipsToOmit.has('ProductOffer') ? {} as ProductOffer : aProductOffer({}, relationshipsToOmit),
        productOfferUpdated: overrides && overrides.hasOwnProperty('productOfferUpdated') ? overrides.productOfferUpdated! : relationshipsToOmit.has('ProductOffer') ? {} as ProductOffer : aProductOffer({}, relationshipsToOmit),
    };
};

export const aSupervisor = (overrides?: Partial<Supervisor>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Supervisor' } & Supervisor => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Supervisor');
    return {
        __typename: 'Supervisor',
        businessUnit: overrides && overrides.hasOwnProperty('businessUnit') ? overrides.businessUnit! : 'consequuntur',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '1601ad45-12b3-45d4-8ac1-dcea34addb42',
        managerId: overrides && overrides.hasOwnProperty('managerId') ? overrides.managerId! : 'dolores',
        site: overrides && overrides.hasOwnProperty('site') ? overrides.site! : 'qui',
        supervisorId: overrides && overrides.hasOwnProperty('supervisorId') ? overrides.supervisorId! : 'laudantium',
        supervisorName: overrides && overrides.hasOwnProperty('supervisorName') ? overrides.supervisorName! : 'ad',
    };
};

export const aSupervisorsConnection = (overrides?: Partial<SupervisorsConnection>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SupervisorsConnection' } & SupervisorsConnection => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SupervisorsConnection');
    return {
        __typename: 'SupervisorsConnection',
        edges: overrides && overrides.hasOwnProperty('edges') ? overrides.edges! : [relationshipsToOmit.has('SupervisorsEdge') ? {} as SupervisorsEdge : aSupervisorsEdge({}, relationshipsToOmit)],
        pageInfo: overrides && overrides.hasOwnProperty('pageInfo') ? overrides.pageInfo! : relationshipsToOmit.has('PageInfo') ? {} as PageInfo : aPageInfo({}, relationshipsToOmit),
    };
};

export const aSupervisorsEdge = (overrides?: Partial<SupervisorsEdge>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SupervisorsEdge' } & SupervisorsEdge => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SupervisorsEdge');
    return {
        __typename: 'SupervisorsEdge',
        cursor: overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'suscipit',
        node: overrides && overrides.hasOwnProperty('node') ? overrides.node! : relationshipsToOmit.has('Supervisor') ? {} as Supervisor : aSupervisor({}, relationshipsToOmit),
    };
};

export const anUpdateAsurionCallInput = (overrides?: Partial<UpdateAsurionCallInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateAsurionCallInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateAsurionCallInput');
    return {
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : CallDirection.Inbound,
        flexReservation: overrides && overrides.hasOwnProperty('flexReservation') ? overrides.flexReservation! : relationshipsToOmit.has('FlexReservationInput') ? {} as FlexReservationInput : aFlexReservationInput({}, relationshipsToOmit),
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ae2304b5-cf9d-415e-893a-2239f614d325',
    };
};

export const anUpdateBillingInput = (overrides?: Partial<UpdateBillingInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateBillingInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateBillingInput');
    return {
        address: overrides && overrides.hasOwnProperty('address') ? overrides.address! : relationshipsToOmit.has('AddressInput') ? {} as AddressInput : anAddressInput({}, relationshipsToOmit),
        customerSessionId: overrides && overrides.hasOwnProperty('customerSessionId') ? overrides.customerSessionId! : 'a055f774-1448-4958-bc19-96ae9e5d17f3',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '587a286e-6e89-4d6f-ae77-e8614e48b381',
    };
};

export const anUpdateBillingSuccessPayload = (overrides?: Partial<UpdateBillingSuccessPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateBillingSuccessPayload' } & UpdateBillingSuccessPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateBillingSuccessPayload');
    return {
        __typename: 'UpdateBillingSuccessPayload',
        billing: overrides && overrides.hasOwnProperty('billing') ? overrides.billing! : relationshipsToOmit.has('Billing') ? {} as Billing : aBilling({}, relationshipsToOmit),
    };
};

export const anUpdateCommunicationInput = (overrides?: Partial<UpdateCommunicationInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateCommunicationInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateCommunicationInput');
    return {
        customerSessionId: overrides && overrides.hasOwnProperty('customerSessionId') ? overrides.customerSessionId! : '0baf7e17-6021-4921-994a-2fedca5b0528',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '9c0ee7a2-cb53-431f-a148-e3a85ca623ae',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : MessageStatus.Accepted,
        templateId: overrides && overrides.hasOwnProperty('templateId') ? overrides.templateId! : 'autem',
        templateVariables: overrides && overrides.hasOwnProperty('templateVariables') ? overrides.templateVariables! : 'molestias',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : MessageType.Email,
    };
};

export const anUpdateCommunicationSuccessPayload = (overrides?: Partial<UpdateCommunicationSuccessPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateCommunicationSuccessPayload' } & UpdateCommunicationSuccessPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateCommunicationSuccessPayload');
    return {
        __typename: 'UpdateCommunicationSuccessPayload',
        communication: overrides && overrides.hasOwnProperty('communication') ? overrides.communication! : relationshipsToOmit.has('Communication') ? {} as Communication : aCommunication({}, relationshipsToOmit),
    };
};

export const anUpdateCpfVerificationInput = (overrides?: Partial<UpdateCpfVerificationInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateCpfVerificationInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateCpfVerificationInput');
    return {
        customerSessionId: overrides && overrides.hasOwnProperty('customerSessionId') ? overrides.customerSessionId! : '75263ab0-01b6-4a83-89b4-23cfa65dcde2',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : CpfVerificationStatus.Failed,
    };
};

export const anUpdateCpfVerificationSuccessPayload = (overrides?: Partial<UpdateCpfVerificationSuccessPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateCpfVerificationSuccessPayload' } & UpdateCpfVerificationSuccessPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateCpfVerificationSuccessPayload');
    return {
        __typename: 'UpdateCpfVerificationSuccessPayload',
        cpfVerification: overrides && overrides.hasOwnProperty('cpfVerification') ? overrides.cpfVerification! : relationshipsToOmit.has('CpfVerification') ? {} as CpfVerification : aCpfVerification({}, relationshipsToOmit),
    };
};

export const anUpdateCustomerInput = (overrides?: Partial<UpdateCustomerInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateCustomerInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateCustomerInput');
    return {
        accountNumber: overrides && overrides.hasOwnProperty('accountNumber') ? overrides.accountNumber! : 'aut',
        address: overrides && overrides.hasOwnProperty('address') ? overrides.address! : relationshipsToOmit.has('AddressInput') ? {} as AddressInput : anAddressInput({}, relationshipsToOmit),
        asset: overrides && overrides.hasOwnProperty('asset') ? overrides.asset! : relationshipsToOmit.has('AssetInput') ? {} as AssetInput : anAssetInput({}, relationshipsToOmit),
        asurionId: overrides && overrides.hasOwnProperty('asurionId') ? overrides.asurionId! : 'd1bbc87d-52ca-4ba7-9c1b-4de49908f990',
        customerSessionId: overrides && overrides.hasOwnProperty('customerSessionId') ? overrides.customerSessionId! : '129c0ae9-fdf8-4b53-a623-a21e7d305874',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'aliquid',
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'qui',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '01cdd17e-22f2-4087-9749-a916cc34dc62',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'architecto',
        mdn: overrides && overrides.hasOwnProperty('mdn') ? overrides.mdn! : 'molestias',
        mobileBan: overrides && overrides.hasOwnProperty('mobileBan') ? overrides.mobileBan! : 'voluptas',
        socialName: overrides && overrides.hasOwnProperty('socialName') ? overrides.socialName! : 'voluptate',
        temporaryMdn: overrides && overrides.hasOwnProperty('temporaryMdn') ? overrides.temporaryMdn! : 'est',
    };
};

export const anUpdateCustomerSessionCpfVerificationInput = (overrides?: Partial<UpdateCustomerSessionCpfVerificationInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateCustomerSessionCpfVerificationInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateCustomerSessionCpfVerificationInput');
    return {
        cpf: overrides && overrides.hasOwnProperty('cpf') ? overrides.cpf! : 'quam',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : CpfVerificationStatus.Failed,
    };
};

export const anUpdateCustomerSessionCustomerInput = (overrides?: Partial<UpdateCustomerSessionCustomerInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateCustomerSessionCustomerInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateCustomerSessionCustomerInput');
    return {
        accountNumber: overrides && overrides.hasOwnProperty('accountNumber') ? overrides.accountNumber! : 'est',
        address: overrides && overrides.hasOwnProperty('address') ? overrides.address! : relationshipsToOmit.has('AddressInput') ? {} as AddressInput : anAddressInput({}, relationshipsToOmit),
        asset: overrides && overrides.hasOwnProperty('asset') ? overrides.asset! : relationshipsToOmit.has('AssetInput') ? {} as AssetInput : anAssetInput({}, relationshipsToOmit),
        asurionId: overrides && overrides.hasOwnProperty('asurionId') ? overrides.asurionId! : 'df47458b-54a5-4125-b600-472404c91368',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'qui',
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'quis',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'est',
        mdn: overrides && overrides.hasOwnProperty('mdn') ? overrides.mdn! : 'quia',
        mobileBan: overrides && overrides.hasOwnProperty('mobileBan') ? overrides.mobileBan! : 'eos',
        socialName: overrides && overrides.hasOwnProperty('socialName') ? overrides.socialName! : 'et',
        temporaryMdn: overrides && overrides.hasOwnProperty('temporaryMdn') ? overrides.temporaryMdn! : 'rerum',
    };
};

export const anUpdateCustomerSessionInput = (overrides?: Partial<UpdateCustomerSessionInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateCustomerSessionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateCustomerSessionInput');
    return {
        asurionCall: overrides && overrides.hasOwnProperty('asurionCall') ? overrides.asurionCall! : relationshipsToOmit.has('UpdateAsurionCallInput') ? {} as UpdateAsurionCallInput : anUpdateAsurionCallInput({}, relationshipsToOmit),
        billing: overrides && overrides.hasOwnProperty('billing') ? overrides.billing! : relationshipsToOmit.has('UpdateCustomerSessionUpdateBillingInput') ? {} as UpdateCustomerSessionUpdateBillingInput : anUpdateCustomerSessionUpdateBillingInput({}, relationshipsToOmit),
        cpfVerification: overrides && overrides.hasOwnProperty('cpfVerification') ? overrides.cpfVerification! : relationshipsToOmit.has('UpdateCustomerSessionCpfVerificationInput') ? {} as UpdateCustomerSessionCpfVerificationInput : anUpdateCustomerSessionCpfVerificationInput({}, relationshipsToOmit),
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 'quis',
        customer: overrides && overrides.hasOwnProperty('customer') ? overrides.customer! : relationshipsToOmit.has('UpdateCustomerSessionCustomerInput') ? {} as UpdateCustomerSessionCustomerInput : anUpdateCustomerSessionCustomerInput({}, relationshipsToOmit),
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : CallDirection.Inbound,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '6dd6c60d-6dff-4c82-8663-08a8436658d6',
        language: overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'aut',
        marketing: overrides && overrides.hasOwnProperty('marketing') ? overrides.marketing! : relationshipsToOmit.has('UpdateCustomerSessionMarketingInput') ? {} as UpdateCustomerSessionMarketingInput : anUpdateCustomerSessionMarketingInput({}, relationshipsToOmit),
        outboundCall: overrides && overrides.hasOwnProperty('outboundCall') ? overrides.outboundCall! : relationshipsToOmit.has('UpdateAsurionCallInput') ? {} as UpdateAsurionCallInput : anUpdateAsurionCallInput({}, relationshipsToOmit),
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : SessionStatus.Callback,
    };
};

export const anUpdateCustomerSessionMarketingInput = (overrides?: Partial<UpdateCustomerSessionMarketingInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateCustomerSessionMarketingInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateCustomerSessionMarketingInput');
    return {
        dealerCode: overrides && overrides.hasOwnProperty('dealerCode') ? overrides.dealerCode! : 'sed',
        dealerName: overrides && overrides.hasOwnProperty('dealerName') ? overrides.dealerName! : 'et',
        promoCode: overrides && overrides.hasOwnProperty('promoCode') ? overrides.promoCode! : 'aut',
        referralPartner: overrides && overrides.hasOwnProperty('referralPartner') ? overrides.referralPartner! : 'placeat',
        referrerCode: overrides && overrides.hasOwnProperty('referrerCode') ? overrides.referrerCode! : 'sit',
        salesChannel: overrides && overrides.hasOwnProperty('salesChannel') ? overrides.salesChannel! : 'nesciunt',
        salesPersonId: overrides && overrides.hasOwnProperty('salesPersonId') ? overrides.salesPersonId! : 'molestias',
        salesSessionId: overrides && overrides.hasOwnProperty('salesSessionId') ? overrides.salesSessionId! : 'ad',
        storeCode: overrides && overrides.hasOwnProperty('storeCode') ? overrides.storeCode! : 'numquam',
        utmParams: overrides && overrides.hasOwnProperty('utmParams') ? overrides.utmParams! : relationshipsToOmit.has('UtmParamsInput') ? {} as UtmParamsInput : anUtmParamsInput({}, relationshipsToOmit),
        vendorData: overrides && overrides.hasOwnProperty('vendorData') ? overrides.vendorData! : 'fugit',
    };
};

export const anUpdateCustomerSessionSuccessPayload = (overrides?: Partial<UpdateCustomerSessionSuccessPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateCustomerSessionSuccessPayload' } & UpdateCustomerSessionSuccessPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateCustomerSessionSuccessPayload');
    return {
        __typename: 'UpdateCustomerSessionSuccessPayload',
        customerSession: overrides && overrides.hasOwnProperty('customerSession') ? overrides.customerSession! : relationshipsToOmit.has('CustomerSession') ? {} as CustomerSession : aCustomerSession({}, relationshipsToOmit),
    };
};

export const anUpdateCustomerSessionUpdateBillingInput = (overrides?: Partial<UpdateCustomerSessionUpdateBillingInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateCustomerSessionUpdateBillingInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateCustomerSessionUpdateBillingInput');
    return {
        address: overrides && overrides.hasOwnProperty('address') ? overrides.address! : relationshipsToOmit.has('AddressInput') ? {} as AddressInput : anAddressInput({}, relationshipsToOmit),
        closingDay: overrides && overrides.hasOwnProperty('closingDay') ? overrides.closingDay! : 'commodi',
        dueDay: overrides && overrides.hasOwnProperty('dueDay') ? overrides.dueDay! : 'officiis',
        externalBillingCycleId: overrides && overrides.hasOwnProperty('externalBillingCycleId') ? overrides.externalBillingCycleId! : 'sint',
    };
};

export const anUpdateCustomerSessionsInput = (overrides?: Partial<UpdateCustomerSessionsInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateCustomerSessionsInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateCustomerSessionsInput');
    return {
        expertId: overrides && overrides.hasOwnProperty('expertId') ? overrides.expertId! : '791fe70d-251f-4994-bc25-6e52b65f2a7b',
        externalSessionId: overrides && overrides.hasOwnProperty('externalSessionId') ? overrides.externalSessionId! : 'ec800123-961f-43ac-99ca-f7219420dad3',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'bd0054e0-aed2-4b0b-9b01-6a018053be4b',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : SessionStatus.Callback,
    };
};

export const anUpdateCustomerSessionsSuccessPayload = (overrides?: Partial<UpdateCustomerSessionsSuccessPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateCustomerSessionsSuccessPayload' } & UpdateCustomerSessionsSuccessPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateCustomerSessionsSuccessPayload');
    return {
        __typename: 'UpdateCustomerSessionsSuccessPayload',
        customerSessions: overrides && overrides.hasOwnProperty('customerSessions') ? overrides.customerSessions! : [relationshipsToOmit.has('CustomerSession') ? {} as CustomerSession : aCustomerSession({}, relationshipsToOmit)],
    };
};

export const anUpdateCustomerSuccessPayload = (overrides?: Partial<UpdateCustomerSuccessPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateCustomerSuccessPayload' } & UpdateCustomerSuccessPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateCustomerSuccessPayload');
    return {
        __typename: 'UpdateCustomerSuccessPayload',
        customer: overrides && overrides.hasOwnProperty('customer') ? overrides.customer! : relationshipsToOmit.has('Customer') ? {} as Customer : aCustomer({}, relationshipsToOmit),
    };
};

export const anUpdateExpertOrgChartDataInput = (overrides?: Partial<UpdateExpertOrgChartDataInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateExpertOrgChartDataInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateExpertOrgChartDataInput');
    return {
        businessUnit: overrides && overrides.hasOwnProperty('businessUnit') ? overrides.businessUnit! : 'eaque',
        expertSessionId: overrides && overrides.hasOwnProperty('expertSessionId') ? overrides.expertSessionId! : 'be5d9732-f7c6-46ff-8811-2ed33339d622',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '6c05563a-7571-45c6-9c7e-4eb578d3926e',
        lob: overrides && overrides.hasOwnProperty('lob') ? overrides.lob! : 'aperiam',
        manager: overrides && overrides.hasOwnProperty('manager') ? overrides.manager! : 'alias',
        managerId: overrides && overrides.hasOwnProperty('managerId') ? overrides.managerId! : 'quia',
        site: overrides && overrides.hasOwnProperty('site') ? overrides.site! : 'et',
        supervisor: overrides && overrides.hasOwnProperty('supervisor') ? overrides.supervisor! : 'labore',
        supervisorId: overrides && overrides.hasOwnProperty('supervisorId') ? overrides.supervisorId! : 'molestiae',
    };
};

export const anUpdateExpertOrgChartDataSuccessPayload = (overrides?: Partial<UpdateExpertOrgChartDataSuccessPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateExpertOrgChartDataSuccessPayload' } & UpdateExpertOrgChartDataSuccessPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateExpertOrgChartDataSuccessPayload');
    return {
        __typename: 'UpdateExpertOrgChartDataSuccessPayload',
        expertSession: overrides && overrides.hasOwnProperty('expertSession') ? overrides.expertSession! : relationshipsToOmit.has('ExpertSession') ? {} as ExpertSession : anExpertSession({}, relationshipsToOmit),
    };
};

export const anUpdateExpertSessionInput = (overrides?: Partial<UpdateExpertSessionInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateExpertSessionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateExpertSessionInput');
    return {
        hostApp: overrides && overrides.hasOwnProperty('hostApp') ? overrides.hostApp! : 'quaerat',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '5b0a0f1d-9930-45e1-bf6b-842e206560ed',
    };
};

export const anUpdateExpertSessionSuccessPayload = (overrides?: Partial<UpdateExpertSessionSuccessPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateExpertSessionSuccessPayload' } & UpdateExpertSessionSuccessPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateExpertSessionSuccessPayload');
    return {
        __typename: 'UpdateExpertSessionSuccessPayload',
        expertSession: overrides && overrides.hasOwnProperty('expertSession') ? overrides.expertSession! : relationshipsToOmit.has('ExpertSession') ? {} as ExpertSession : anExpertSession({}, relationshipsToOmit),
    };
};

export const anUpdateMdnVerificationInput = (overrides?: Partial<UpdateMdnVerificationInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateMdnVerificationInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateMdnVerificationInput');
    return {
        accessToken: overrides && overrides.hasOwnProperty('accessToken') ? overrides.accessToken! : 'aspernatur',
        attemptsRemaining: overrides && overrides.hasOwnProperty('attemptsRemaining') ? overrides.attemptsRemaining! : 9572,
        customerSessionId: overrides && overrides.hasOwnProperty('customerSessionId') ? overrides.customerSessionId! : '43c33c84-4517-45d3-a586-effb5a500e2e',
        expiration: overrides && overrides.hasOwnProperty('expiration') ? overrides.expiration! : 'asperiores',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '542931ad-220a-4c95-b5d5-3cbb02d670fe',
        otp: overrides && overrides.hasOwnProperty('otp') ? overrides.otp! : 'quia',
        refreshToken: overrides && overrides.hasOwnProperty('refreshToken') ? overrides.refreshToken! : 'dolorem',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : MdnVerificationStatus.Failed,
        transactionId: overrides && overrides.hasOwnProperty('transactionId') ? overrides.transactionId! : 'aut',
    };
};

export const anUpdateMdnVerificationSuccessPayload = (overrides?: Partial<UpdateMdnVerificationSuccessPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateMdnVerificationSuccessPayload' } & UpdateMdnVerificationSuccessPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateMdnVerificationSuccessPayload');
    return {
        __typename: 'UpdateMdnVerificationSuccessPayload',
        mdnVerification: overrides && overrides.hasOwnProperty('mdnVerification') ? overrides.mdnVerification! : relationshipsToOmit.has('MdnVerification') ? {} as MdnVerification : aMdnVerification({}, relationshipsToOmit),
    };
};

export const anUpdatePaySessionInput = (overrides?: Partial<UpdatePaySessionInput>, _relationshipsToOmit: Set<string> = new Set()): UpdatePaySessionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdatePaySessionInput');
    return {
        billingFrequencyInMonths: overrides && overrides.hasOwnProperty('billingFrequencyInMonths') ? overrides.billingFrequencyInMonths! : 'suscipit',
        billingGatewaySessionId: overrides && overrides.hasOwnProperty('billingGatewaySessionId') ? overrides.billingGatewaySessionId! : 'accusamus',
        billingToken: overrides && overrides.hasOwnProperty('billingToken') ? overrides.billingToken! : 'assumenda',
        brand: overrides && overrides.hasOwnProperty('brand') ? overrides.brand! : 'atque',
        customerSessionId: overrides && overrides.hasOwnProperty('customerSessionId') ? overrides.customerSessionId! : 'fe90158e-8333-4b90-b2a8-1e49fa697212',
        encryptionKey: overrides && overrides.hasOwnProperty('encryptionKey') ? overrides.encryptionKey! : 'debitis',
        expirationMonth: overrides && overrides.hasOwnProperty('expirationMonth') ? overrides.expirationMonth! : 'dolor',
        expirationYear: overrides && overrides.hasOwnProperty('expirationYear') ? overrides.expirationYear! : 'corporis',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '28c6a809-02cd-4106-96d1-1b61083c9a59',
        lastFour: overrides && overrides.hasOwnProperty('lastFour') ? overrides.lastFour! : 'mollitia',
        payMethodId: overrides && overrides.hasOwnProperty('payMethodId') ? overrides.payMethodId! : 'saepe',
        paymentLink: overrides && overrides.hasOwnProperty('paymentLink') ? overrides.paymentLink! : 'ratione',
        paymentType: overrides && overrides.hasOwnProperty('paymentType') ? overrides.paymentType! : PaymentType.Bta,
        productPaidFrequency: overrides && overrides.hasOwnProperty('productPaidFrequency') ? overrides.productPaidFrequency! : 'et',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : PaySessionStatus.Authorized,
    };
};

export const anUpdatePaySessionSuccessPayload = (overrides?: Partial<UpdatePaySessionSuccessPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdatePaySessionSuccessPayload' } & UpdatePaySessionSuccessPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdatePaySessionSuccessPayload');
    return {
        __typename: 'UpdatePaySessionSuccessPayload',
        paySession: overrides && overrides.hasOwnProperty('paySession') ? overrides.paySession! : relationshipsToOmit.has('PaySession') ? {} as PaySession : aPaySession({}, relationshipsToOmit),
    };
};

export const anUpdateProductEligibilityInput = (overrides?: Partial<UpdateProductEligibilityInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateProductEligibilityInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateProductEligibilityInput');
    return {
        extensions: overrides && overrides.hasOwnProperty('extensions') ? overrides.extensions! : [relationshipsToOmit.has('ExtensionInput') ? {} as ExtensionInput : anExtensionInput({}, relationshipsToOmit)],
        externalEligibilityId: overrides && overrides.hasOwnProperty('externalEligibilityId') ? overrides.externalEligibilityId! : 'doloribus',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '4243410d-8c4f-43e3-90b8-fbb9795eef38',
        productOfferId: overrides && overrides.hasOwnProperty('productOfferId') ? overrides.productOfferId! : '9a2798d3-684a-4735-9940-c0a16c83bc13',
        reason: overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : 'a',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : ProductEligibilityStatus.AlreadyEnrolled,
        subscriptionNumber: overrides && overrides.hasOwnProperty('subscriptionNumber') ? overrides.subscriptionNumber! : 'dolor',
    };
};

export const anUpdateProductEligibilitySuccessPayload = (overrides?: Partial<UpdateProductEligibilitySuccessPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateProductEligibilitySuccessPayload' } & UpdateProductEligibilitySuccessPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateProductEligibilitySuccessPayload');
    return {
        __typename: 'UpdateProductEligibilitySuccessPayload',
        productEligibility: overrides && overrides.hasOwnProperty('productEligibility') ? overrides.productEligibility! : relationshipsToOmit.has('ProductEligibility') ? {} as ProductEligibility : aProductEligibility({}, relationshipsToOmit),
    };
};

export const anUpdateProductEnrollmentInput = (overrides?: Partial<UpdateProductEnrollmentInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateProductEnrollmentInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateProductEnrollmentInput');
    return {
        error: overrides && overrides.hasOwnProperty('error') ? overrides.error! : relationshipsToOmit.has('ProductEnrollmentErrorInput') ? {} as ProductEnrollmentErrorInput : aProductEnrollmentErrorInput({}, relationshipsToOmit),
        externalReferenceId: overrides && overrides.hasOwnProperty('externalReferenceId') ? overrides.externalReferenceId! : 'aspernatur',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'dd61e1e5-faf7-422e-ab3b-20032448f1b4',
        planId: overrides && overrides.hasOwnProperty('planId') ? overrides.planId! : '292aa770-45fc-413e-9290-914a0f313e6e',
        productOfferId: overrides && overrides.hasOwnProperty('productOfferId') ? overrides.productOfferId! : 'deb622b8-b022-4859-91a0-64c8a01ae524',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : ProductEnrollmentStatus.Failure,
    };
};

export const anUpdateProductEnrollmentSuccessPayload = (overrides?: Partial<UpdateProductEnrollmentSuccessPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateProductEnrollmentSuccessPayload' } & UpdateProductEnrollmentSuccessPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateProductEnrollmentSuccessPayload');
    return {
        __typename: 'UpdateProductEnrollmentSuccessPayload',
        productEnrollment: overrides && overrides.hasOwnProperty('productEnrollment') ? overrides.productEnrollment! : relationshipsToOmit.has('ProductEnrollment') ? {} as ProductEnrollment : aProductEnrollment({}, relationshipsToOmit),
    };
};

export const anUpdateProductOfferInput = (overrides?: Partial<UpdateProductOfferInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateProductOfferInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateProductOfferInput');
    return {
        disclosureStatus: overrides && overrides.hasOwnProperty('disclosureStatus') ? overrides.disclosureStatus! : TransmittedDisclosureStatus.Accepted,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '3d16961c-ae8a-4832-9342-f4f880d62c72',
        linkId: overrides && overrides.hasOwnProperty('linkId') ? overrides.linkId! : 'dolores',
    };
};

export const anUpdateProductOfferSuccessPayload = (overrides?: Partial<UpdateProductOfferSuccessPayload>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateProductOfferSuccessPayload' } & UpdateProductOfferSuccessPayload => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateProductOfferSuccessPayload');
    return {
        __typename: 'UpdateProductOfferSuccessPayload',
        productOffer: overrides && overrides.hasOwnProperty('productOffer') ? overrides.productOffer! : relationshipsToOmit.has('ProductOffer') ? {} as ProductOffer : aProductOffer({}, relationshipsToOmit),
    };
};

export const anUtmParams = (overrides?: Partial<UtmParams>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UtmParams' } & UtmParams => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UtmParams');
    return {
        __typename: 'UtmParams',
        utmCampaign: overrides && overrides.hasOwnProperty('utmCampaign') ? overrides.utmCampaign! : 'dolor',
        utmContent: overrides && overrides.hasOwnProperty('utmContent') ? overrides.utmContent! : 'veritatis',
        utmMedium: overrides && overrides.hasOwnProperty('utmMedium') ? overrides.utmMedium! : 'corporis',
        utmSource: overrides && overrides.hasOwnProperty('utmSource') ? overrides.utmSource! : 'incidunt',
    };
};

export const anUtmParamsInput = (overrides?: Partial<UtmParamsInput>, _relationshipsToOmit: Set<string> = new Set()): UtmParamsInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UtmParamsInput');
    return {
        utmCampaign: overrides && overrides.hasOwnProperty('utmCampaign') ? overrides.utmCampaign! : 'in',
        utmContent: overrides && overrides.hasOwnProperty('utmContent') ? overrides.utmContent! : 'veniam',
        utmMedium: overrides && overrides.hasOwnProperty('utmMedium') ? overrides.utmMedium! : 'saepe',
        utmSource: overrides && overrides.hasOwnProperty('utmSource') ? overrides.utmSource! : 'ullam',
    };
};


/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateBillingMutation(
 *   ({ query, variables }) => {
 *     const { customerSessionId, address } = variables;
 *     return HttpResponse.json({
 *       data: { createBilling }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateBillingMutation = (resolver: GraphQLResponseResolver<CreateBillingMutation, CreateBillingMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateBillingMutation, CreateBillingMutationVariables>(
    'CreateBilling',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateCommunicationMutation(
 *   ({ query, variables }) => {
 *     const { customerSessionId, templateId, status, productSku, type, mdn, transactionId, email, templateVariables } = variables;
 *     return HttpResponse.json({
 *       data: { createCommunication }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateCommunicationMutation = (resolver: GraphQLResponseResolver<CreateCommunicationMutation, CreateCommunicationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateCommunicationMutation, CreateCommunicationMutationVariables>(
    'CreateCommunication',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateCustomerSessionMutation(
 *   ({ query, variables }) => {
 *     const { id, expertSessionId, partner, customer, includeCustomer, origin, externalClientAccount, horizonSession, externalSession, asurionCall, channel, language, direction, marketing, includeMarketing, extensions, sessionStatus, cohortTag } = variables;
 *     return HttpResponse.json({
 *       data: { createCustomerSession }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateCustomerSessionMutation = (resolver: GraphQLResponseResolver<CreateCustomerSessionMutation, CreateCustomerSessionMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateCustomerSessionMutation, CreateCustomerSessionMutationVariables>(
    'CreateCustomerSession',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateMdnVerificationMutation(
 *   ({ query, variables }) => {
 *     const { customerSessionId } = variables;
 *     return HttpResponse.json({
 *       data: { createMdnVerification }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateMdnVerificationMutation = (resolver: GraphQLResponseResolver<CreateMdnVerificationMutation, CreateMdnVerificationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateMdnVerificationMutation, CreateMdnVerificationMutationVariables>(
    'CreateMdnVerification',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreatePaySessionMutation(
 *   ({ query, variables }) => {
 *     const { customerSessionId, productSku, transactionType, billingToken, paymentType, billingFrequencyInMonths, productPaidFrequency } = variables;
 *     return HttpResponse.json({
 *       data: { createPaySession }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreatePaySessionMutation = (resolver: GraphQLResponseResolver<CreatePaySessionMutation, CreatePaySessionMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreatePaySessionMutation, CreatePaySessionMutationVariables>(
    'CreatePaySession',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGenerateSmartLinkMutation(
 *   ({ query, variables }) => {
 *     const { productOfferId, appName, checkoutMethod, smartLinkMdn, externalConsentReference } = variables;
 *     return HttpResponse.json({
 *       data: { generateSmartLink }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGenerateSmartLinkMutation = (resolver: GraphQLResponseResolver<GenerateSmartLinkMutation, GenerateSmartLinkMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<GenerateSmartLinkMutation, GenerateSmartLinkMutationVariables>(
    'GenerateSmartLink',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateBillingMutation(
 *   ({ query, variables }) => {
 *     const { id, customerSessionId, address } = variables;
 *     return HttpResponse.json({
 *       data: { updateBilling }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateBillingMutation = (resolver: GraphQLResponseResolver<UpdateBillingMutation, UpdateBillingMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateBillingMutation, UpdateBillingMutationVariables>(
    'UpdateBilling',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateCommunicationMutation(
 *   ({ query, variables }) => {
 *     const { customerSessionId, communicationId, templateId, status, type, templateVariables } = variables;
 *     return HttpResponse.json({
 *       data: { updateCommunication }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateCommunicationMutation = (resolver: GraphQLResponseResolver<UpdateCommunicationMutation, UpdateCommunicationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateCommunicationMutation, UpdateCommunicationMutationVariables>(
    'UpdateCommunication',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateCustomerSessionMutation(
 *   ({ query, variables }) => {
 *     const { id, status, outboundCall, marketing, customer, direction, language, includeCustomer, includeMarketing } = variables;
 *     return HttpResponse.json({
 *       data: { updateCustomerSession }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateCustomerSessionMutation = (resolver: GraphQLResponseResolver<UpdateCustomerSessionMutation, UpdateCustomerSessionMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateCustomerSessionMutation, UpdateCustomerSessionMutationVariables>(
    'UpdateCustomerSession',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateCustomerSessionsMutation(
 *   ({ query, variables }) => {
 *     const { id, externalSessionId, expertId, status, includeCustomer, includeMarketing } = variables;
 *     return HttpResponse.json({
 *       data: { updateCustomerSessions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateCustomerSessionsMutation = (resolver: GraphQLResponseResolver<UpdateCustomerSessionsMutation, UpdateCustomerSessionsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateCustomerSessionsMutation, UpdateCustomerSessionsMutationVariables>(
    'UpdateCustomerSessions',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateCustomerMutation(
 *   ({ query, variables }) => {
 *     const { customerSessionId, address, asurionId, email, firstName, id, lastName, mdn, asset } = variables;
 *     return HttpResponse.json({
 *       data: { updateCustomer }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateCustomerMutation = (resolver: GraphQLResponseResolver<UpdateCustomerMutation, UpdateCustomerMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateCustomerMutation, UpdateCustomerMutationVariables>(
    'UpdateCustomer',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateMdnVerificationMutation(
 *   ({ query, variables }) => {
 *     const { id, customerSessionId, status, transactionId, expiration, attemptsRemaining, accessToken, refreshToken, otp } = variables;
 *     return HttpResponse.json({
 *       data: { updateMdnVerification }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateMdnVerificationMutation = (resolver: GraphQLResponseResolver<UpdateMdnVerificationMutation, UpdateMdnVerificationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateMdnVerificationMutation, UpdateMdnVerificationMutationVariables>(
    'UpdateMdnVerification',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdatePaySessionMutation(
 *   ({ query, variables }) => {
 *     const { id, customerSessionId, status, billingGatewaySessionId, billingToken, paymentLink, paymentType, payMethodId, encryptionKey, billingFrequencyInMonths, productPaidFrequency, lastFour, brand, expirationMonth, expirationYear } = variables;
 *     return HttpResponse.json({
 *       data: { updatePaySession }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdatePaySessionMutation = (resolver: GraphQLResponseResolver<UpdatePaySessionMutation, UpdatePaySessionMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdatePaySessionMutation, UpdatePaySessionMutationVariables>(
    'UpdatePaySession',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCustomerSessionExpertSessionsQuery(
 *   ({ query, variables }) => {
 *     const { customerSessionId, includeExpert } = variables;
 *     return HttpResponse.json({
 *       data: { customerSession }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCustomerSessionExpertSessionsQuery = (resolver: GraphQLResponseResolver<CustomerSessionExpertSessionsQuery, CustomerSessionExpertSessionsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CustomerSessionExpertSessionsQuery, CustomerSessionExpertSessionsQueryVariables>(
    'CustomerSessionExpertSessions',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCustomerSessionQuery(
 *   ({ query, variables }) => {
 *     const { customerSessionId, includeCustomer, includeMarketing } = variables;
 *     return HttpResponse.json({
 *       data: { customerSession }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCustomerSessionQuery = (resolver: GraphQLResponseResolver<CustomerSessionQuery, CustomerSessionQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CustomerSessionQuery, CustomerSessionQueryVariables>(
    'CustomerSession',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCustomerSessionsByMdnQuery(
 *   ({ query, variables }) => {
 *     const { mdn, partner, includeCustomer, includeMarketing } = variables;
 *     return HttpResponse.json({
 *       data: { customerSessions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCustomerSessionsByMdnQuery = (resolver: GraphQLResponseResolver<CustomerSessionsByMdnQuery, CustomerSessionsByMdnQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CustomerSessionsByMdnQuery, CustomerSessionsByMdnQueryVariables>(
    'CustomerSessionsByMdn',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCustomerQuery(
 *   ({ query, variables }) => {
 *     const { customerSessionId } = variables;
 *     return HttpResponse.json({
 *       data: { customerSession }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCustomerQuery = (resolver: GraphQLResponseResolver<CustomerQuery, CustomerQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CustomerQuery, CustomerQueryVariables>(
    'Customer',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMdnVerificationQuery(
 *   ({ query, variables }) => {
 *     const { customerSessionId, mdnVerificationId } = variables;
 *     return HttpResponse.json({
 *       data: { customerSession }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockMdnVerificationQuery = (resolver: GraphQLResponseResolver<MdnVerificationQuery, MdnVerificationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<MdnVerificationQuery, MdnVerificationQueryVariables>(
    'MdnVerification',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPaySessionQuery(
 *   ({ query, variables }) => {
 *     const { customerSessionId, paySessionId } = variables;
 *     return HttpResponse.json({
 *       data: { customerSession }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPaySessionQuery = (resolver: GraphQLResponseResolver<PaySessionQuery, PaySessionQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<PaySessionQuery, PaySessionQueryVariables>(
    'PaySession',
    resolver,
    options
  )




/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateExpertSessionMutation(
 *   ({ query, variables }) => {
 *     const { expert, includeExpert, supportedSkus } = variables;
 *     return HttpResponse.json({
 *       data: { createExpertSession }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateExpertSessionMutation = (resolver: GraphQLResponseResolver<CreateExpertSessionMutation, CreateExpertSessionMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateExpertSessionMutation, CreateExpertSessionMutationVariables>(
    'CreateExpertSession',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateExpertOrgChartDataMutation(
 *   ({ query, variables }) => {
 *     const { id, expertSessionId, lob } = variables;
 *     return HttpResponse.json({
 *       data: { updateExpertOrgChartData }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateExpertOrgChartDataMutation = (resolver: GraphQLResponseResolver<UpdateExpertOrgChartDataMutation, UpdateExpertOrgChartDataMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateExpertOrgChartDataMutation, UpdateExpertOrgChartDataMutationVariables>(
    'UpdateExpertOrgChartData',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateExpertSessionMutation(
 *   ({ query, variables }) => {
 *     const { id, hostApp, includeExpert } = variables;
 *     return HttpResponse.json({
 *       data: { updateExpertSession }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateExpertSessionMutation = (resolver: GraphQLResponseResolver<UpdateExpertSessionMutation, UpdateExpertSessionMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateExpertSessionMutation, UpdateExpertSessionMutationVariables>(
    'UpdateExpertSession',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockExpertSessionQuery(
 *   ({ query, variables }) => {
 *     const { expertSessionId, includeExpert } = variables;
 *     return HttpResponse.json({
 *       data: { expertSession }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockExpertSessionQuery = (resolver: GraphQLResponseResolver<ExpertSessionQuery, ExpertSessionQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ExpertSessionQuery, ExpertSessionQueryVariables>(
    'ExpertSession',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockExpertSessionsQuery(
 *   ({ query, variables }) => {
 *     const { username, first, since, after, sort, includeExpert } = variables;
 *     return HttpResponse.json({
 *       data: { expertSessions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockExpertSessionsQuery = (resolver: GraphQLResponseResolver<ExpertSessionsQuery, ExpertSessionsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ExpertSessionsQuery, ExpertSessionsQueryVariables>(
    'ExpertSessions',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockExpertQuery(
 *   ({ query, variables }) => {
 *     const { expertSessionId } = variables;
 *     return HttpResponse.json({
 *       data: { expertSession }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockExpertQuery = (resolver: GraphQLResponseResolver<ExpertQuery, ExpertQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ExpertQuery, ExpertQueryVariables>(
    'Expert',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateBillingDiscountsMutation(
 *   ({ query, variables }) => {
 *     const { productOfferId, billingDiscounts } = variables;
 *     return HttpResponse.json({
 *       data: { createBillingDiscounts }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateBillingDiscountsMutation = (resolver: GraphQLResponseResolver<CreateBillingDiscountsMutation, CreateBillingDiscountsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateBillingDiscountsMutation, CreateBillingDiscountsMutationVariables>(
    'CreateBillingDiscounts',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateProductDeclinationMutation(
 *   ({ query, variables }) => {
 *     const { productOfferId, reason } = variables;
 *     return HttpResponse.json({
 *       data: { createProductDeclination }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateProductDeclinationMutation = (resolver: GraphQLResponseResolver<CreateProductDeclinationMutation, CreateProductDeclinationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateProductDeclinationMutation, CreateProductDeclinationMutationVariables>(
    'CreateProductDeclination',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateProductEnrollmentMutation(
 *   ({ query, variables }) => {
 *     const { productOfferId, status, paySessionId, confirmationCode, externalReferenceId, planId } = variables;
 *     return HttpResponse.json({
 *       data: { createProductEnrollment }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateProductEnrollmentMutation = (resolver: GraphQLResponseResolver<CreateProductEnrollmentMutation, CreateProductEnrollmentMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateProductEnrollmentMutation, CreateProductEnrollmentMutationVariables>(
    'CreateProductEnrollment',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateProductOfferMutation(
 *   ({ query, variables }) => {
 *     const { customerMdn, productSku, customerSessionId, partner, expertSessionId, includeProductEligibility, includeProductEnrollment, includeProductDeclination, includeBillingDiscounts, productEligibilityStatus } = variables;
 *     return HttpResponse.json({
 *       data: { createProductOffer }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateProductOfferMutation = (resolver: GraphQLResponseResolver<CreateProductOfferMutation, CreateProductOfferMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateProductOfferMutation, CreateProductOfferMutationVariables>(
    'CreateProductOffer',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteProductOfferMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteProductOffer }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteProductOfferMutation = (resolver: GraphQLResponseResolver<DeleteProductOfferMutation, DeleteProductOfferMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteProductOfferMutation, DeleteProductOfferMutationVariables>(
    'DeleteProductOffer',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateProductEligibilityMutation(
 *   ({ query, variables }) => {
 *     const { productEligibilityId, productOfferId, externalEligibilityId, status, subscriptionNumber, reason } = variables;
 *     return HttpResponse.json({
 *       data: { updateProductEligibility }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateProductEligibilityMutation = (resolver: GraphQLResponseResolver<UpdateProductEligibilityMutation, UpdateProductEligibilityMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateProductEligibilityMutation, UpdateProductEligibilityMutationVariables>(
    'UpdateProductEligibility',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateProductEnrollmentMutation(
 *   ({ query, variables }) => {
 *     const { id, productOfferId, status, planId, error, externalReferenceId } = variables;
 *     return HttpResponse.json({
 *       data: { updateProductEnrollment }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateProductEnrollmentMutation = (resolver: GraphQLResponseResolver<UpdateProductEnrollmentMutation, UpdateProductEnrollmentMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateProductEnrollmentMutation, UpdateProductEnrollmentMutationVariables>(
    'UpdateProductEnrollment',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateProductOfferMutation(
 *   ({ query, variables }) => {
 *     const { id, disclosureStatus, linkId, includeProductEligibility, includeProductEnrollment, includeProductDeclination, includeBillingDiscounts } = variables;
 *     return HttpResponse.json({
 *       data: { updateProductOffer }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateProductOfferMutation = (resolver: GraphQLResponseResolver<UpdateProductOfferMutation, UpdateProductOfferMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateProductOfferMutation, UpdateProductOfferMutationVariables>(
    'UpdateProductOffer',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProductEligibilityQuery(
 *   ({ query, variables }) => {
 *     const { productOfferId } = variables;
 *     return HttpResponse.json({
 *       data: { productOffer }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProductEligibilityQuery = (resolver: GraphQLResponseResolver<ProductEligibilityQuery, ProductEligibilityQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ProductEligibilityQuery, ProductEligibilityQueryVariables>(
    'ProductEligibility',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProductEnrollmentQuery(
 *   ({ query, variables }) => {
 *     const { productOfferId } = variables;
 *     return HttpResponse.json({
 *       data: { productOffer }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProductEnrollmentQuery = (resolver: GraphQLResponseResolver<ProductEnrollmentQuery, ProductEnrollmentQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ProductEnrollmentQuery, ProductEnrollmentQueryVariables>(
    'ProductEnrollment',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProductOfferCustomerSessionQuery(
 *   ({ query, variables }) => {
 *     const { productOfferId, includeCustomer, includeMarketing } = variables;
 *     return HttpResponse.json({
 *       data: { productOffer }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProductOfferCustomerSessionQuery = (resolver: GraphQLResponseResolver<ProductOfferCustomerSessionQuery, ProductOfferCustomerSessionQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ProductOfferCustomerSessionQuery, ProductOfferCustomerSessionQueryVariables>(
    'ProductOfferCustomerSession',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProductOfferTaxAmountQuery(
 *   ({ query, variables }) => {
 *     const { productOfferId, invoiceAmount, shipToAddress } = variables;
 *     return HttpResponse.json({
 *       data: { productOffer }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProductOfferTaxAmountQuery = (resolver: GraphQLResponseResolver<ProductOfferTaxAmountQuery, ProductOfferTaxAmountQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ProductOfferTaxAmountQuery, ProductOfferTaxAmountQueryVariables>(
    'ProductOfferTaxAmount',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProductOfferQuery(
 *   ({ query, variables }) => {
 *     const { productOfferId, includeProductEligibility, includeProductEnrollment, includeProductDeclination, includeBillingDiscounts } = variables;
 *     return HttpResponse.json({
 *       data: { productOffer }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProductOfferQuery = (resolver: GraphQLResponseResolver<ProductOfferQuery, ProductOfferQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ProductOfferQuery, ProductOfferQueryVariables>(
    'ProductOffer',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProductOffersByCustomerSessionIdQuery(
 *   ({ query, variables }) => {
 *     const { customerSessionId, productSku, includeProductEligibility, includeProductEnrollment, includeProductDeclination, includeBillingDiscounts } = variables;
 *     return HttpResponse.json({
 *       data: { productOffersByCustomerSessionId }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProductOffersByCustomerSessionIdQuery = (resolver: GraphQLResponseResolver<ProductOffersByCustomerSessionIdQuery, ProductOffersByCustomerSessionIdQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ProductOffersByCustomerSessionIdQuery, ProductOffersByCustomerSessionIdQueryVariables>(
    'ProductOffersByCustomerSessionId',
    resolver,
    options
  )







/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSalesConfigQuery(
 *   ({ query, variables }) => {
 *     const { applicationName, configName } = variables;
 *     return HttpResponse.json({
 *       data: { salesConfig }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSalesConfigQuery = (resolver: GraphQLResponseResolver<SalesConfigQuery, SalesConfigQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SalesConfigQuery, SalesConfigQueryVariables>(
    'SalesConfig',
    resolver,
    options
  )
